import ButtonBase from '@material-ui/core/ButtonBase';
import React__default, { useContext, useMemo, memo, isValidElement, createElement, useCallback, Children, Fragment, useState, useEffect, useRef, Component, forwardRef, Suspense } from 'react';
import muiTooltip__default from '@material-ui/core/Tooltip';
import muiCheckbox__default from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { IconCheckboxChecked, IconCheckboxUnchecked, IconError, IconWarning, IconClose, IconBadgeUp, IconBadgeDown, IconDefaultUserImage, IconDropDown, IconDropDownReverse } from '@reynolds/icons-common';
import muiIcon__default from '@material-ui/core/Icon';
import muiSvgIcon__default from '@material-ui/core/SvgIcon';
import muiIconButton__default from '@material-ui/core/IconButton';
import muiCircularProgress__default from '@material-ui/core/CircularProgress';
import muiCollapse__default from '@material-ui/core/Collapse';
import { createStyles, withStyles, useTheme as useTheme$1 } from '@material-ui/core/styles';
import { InputAdornment, InputLabel, Popover, Popper } from '@material-ui/core';
import MuiTextField__default from '@material-ui/core/TextField';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import MaskedInput from 'react-text-mask';
import { GetCurrencySymbol } from '@reynolds/currencyformat';
import Transition from 'react-transition-group/Transition';
import muiGrow__default from '@material-ui/core/Grow';
import muiLinearProgress__default from '@material-ui/core/LinearProgress';
import muiPaper__default from '@material-ui/core/Paper';
import { Format } from '@reynolds/phonenumberformat';
import Scrollbar from 'react-scrollbars-custom';
import classNames from 'classnames';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import muiDialog__default from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import muiPopover__default from '@material-ui/core/Popover';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { JSXIf } from '@framework-controls/jsxconditions';
import muiAvatar__default from '@material-ui/core/Avatar';
import muiBadge__default from '@material-ui/core/Badge';
import Radio from '@material-ui/core/Radio';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import { TransitionGroup } from 'react-transition-group';
import Grid from '@material-ui/core/Grid';
import muiDivider__default from '@material-ui/core/Divider';
import muiTabs__default from '@material-ui/core/Tabs';
import muiTab__default from '@material-ui/core/Tab';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Popper$1 from '@material-ui/core/Popper';
import { isEqual, isNumber, isEmpty, startsWith } from 'lodash';
import Creatable from 'react-select';
import { createSelector } from 'reselect';

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".Tooltip-module_tooltip__g7YQo {\n  font-family: inherit;\n  overflow-wrap: break-word;\n  max-width: 200px;\n  font-size: 0.8rem;\n  margin: 15px 0;\n  opacity: 1;\n}";
var css = {"tooltip":"Tooltip-module_tooltip__g7YQo"};
styleInject(css_248z,{"insertAt":"top"});

/** Theme context, empty by default. */
const ThemeContext = React__default.createContext({});
/** Provides a theme for use with the `useTheme` hook. */
const ThemeProvider = ThemeContext.Provider;
/** Separates component class name prefixes from variant names. */
const variantSeparator = '_';
/**
 * Adds the given prefix to the given variant name, using `variantSeparator` in between.
 * @param prefix CSS class name prefix
 * @param variant Single variant name
 * @returns Prefixed variant name
 */
const concatVariant = (prefix, variant) => `${prefix}${variantSeparator}${variant}`;
/**
 * If a theme is currently active, applies the theme to a copy of the given CSS.
 * Otherwise, just returns the `css` parameter as given.
 * Memoized.
 *
 * A theme is applied by merging the theme class name table with the `css` table, and returning the result.
 *
 * If an entry is present in `css`, but not the theme, it is copied from `css` to the result table.
 *
 * If an entry is present in the theme, but not in `css`, it is copied from the theme to the result table.
 *
 * If an entry is present in both the theme and `css`, the values are joined together with a space and stored in the result table.
 *
 * For example, given the following theme:
 *
 * ```jsx
 * <ThemeProvider theme={{ 'button': '3zrM9', 'button_horse': 'lkUY5' }}>
 * ```
 *
 * And the following `css` table:
 *
 * ```js
 * const css = {
 *   "button": "1yqRw",
 *   "button_sizeSmall": "LTh7L",
 * };
 * ```
 *
 * Then the result of `useTheme(css)` would be:
 *
 * ```js
 * {
 *   "button": "1yqRw 3zrM9",
 *   "button_sizeSmall": "LTh7L",
 *   'button_horse': "lkUY5",
 * }
 * ```
 *
 * @param css A CSS class name table, usually obtained by importing a CSS file.
 * @returns Either `css` or a copy of `css` with the current theme applied.
 */
const useTheme = (css) => {
    const theme = useContext(ThemeContext);
    const merged = useMemo(() => {
        if (!theme) {
            return css;
        }
        const result = Object.assign({}, css);
        for (const k in theme) {
            if (Object.prototype.hasOwnProperty.call(theme, k)) {
                if (result[k]) {
                    result[k] = `${result[k]} ${theme[k]}`;
                }
                else {
                    result[k] = theme[k];
                }
            }
        }
        return result;
    }, [css, theme]);
    return merged;
};
/**
 * Flattens a Variant array.
 * @param variant An arbitrarily nested Variant array.
 * @returns A flattened array of variant names.
 */
const arrayify = (variant) => {
    if (!variant) {
        return [];
    }
    else if (typeof variant === 'string') {
        return [variant];
    }
    else {
        return variant.map(v => arrayify(v)).reduce((a, v) => a.concat(v), []);
    }
};
/** Conjoins and concatenates variant names into a class name list. See docs for `useClassNames`. */
const conjoinVariants = (theme, name, variant, skipBaseName) => {
    const flatVariant = arrayify(variant);
    const variantClassNames = flatVariant.map(s => concatVariant(name, s));
    const allClassNames = skipBaseName ?
        variantClassNames :
        [name, ...variantClassNames];
    return allClassNames
        .map(s => theme[s])
        .filter(s => s && s.length)
        .join(' ');
};
/**
 * Prepares variant class names. Memoized.
 *
 * Constructs class names by flattening and filtering the `variant` array,
 * and prefixing each variant name with the `name` parameter.
 *
 * The `name` parameter by itself is also included as a class name by default.
 *
 * The resulting names are then converted to themed class names using the `theme` parameter as a dictionary.
 *
 * The obfuscated names are then all joined, separated by spaces, to form the final class name list.
 *
 * For example, if the `theme` table contains the following:
 *
 * ```js
 * const theme = {
 *   "button": "1yqRw"
 *   "button_sizeFull": "R6URd",
 *   "button_sizeSmall": "LTh7L",
 *   "button_sizeLarge": "md1oN",
 * };
 * ```
 *
 * Then calling `useClassNames` with the following arguments:
 *
 * ```js
 * const classnames = useClassNames(theme, 'button', ['sizeSmall']);
 * ```
 *
 * Would result in the class name string `"1yqRw LTh7L"`.
 *
 * The `variant` parameter can be any arbitrarily nested array of variant atoms.
 * Each atom may be either a string (in which case it is included in the output) or one of the values `false` or `undefined`
 * (in which case it is ignored).
 *
 * @param theme A CSS class table, either from importing a CSS file, or from `useTheme()`.
 * @param name Base class name, also used as the variant prefix.
 * @param variant An arbitrarily nested Variant array.
 * @param skipBaseName If true, the non-variant class name based on `name` is not included in the result.
 * @returns Fully concatenated class names, including the base class name and all given variants.
 */
const useClassNames = (theme, name, variant, skipBaseName) => useMemo(() => conjoinVariants(theme, name, variant, skipBaseName), [variant, skipBaseName, name, theme]);
/** Applies the equivalent of `useClassNames` to each entry in the `classes` table.
 *
 * Non-variant class name based on `name` is only included for the `"root"` classname.
 *
 * The `name` argument should usually be a sub-element of a control (e.g. `'textField__input'`).
 *
 * @param theme A CSS class table, either from importing a CSS file, or from `useTheme()`.
 * @param name Base class name, also used as the variant prefix.
 * @param classes A table mapping MUI classnames to variants.
 * @returns Table of fully applies variant class names, suitable for use with MUI `classes` props.
 */
const useMuiClasses = (theme, name, classes) => useMemo(() => {
    const result = {};
    for (const classname in classes) {
        if (Object.prototype.hasOwnProperty.call(classes, classname)) {
            const classnames = conjoinVariants(theme, name, classes[classname], classname !== 'root');
            if (classnames !== '') {
                result[classname] = classnames;
            }
        }
    }
    return result;
}, [classes, name, theme]);

/** Displays a tooltip for the given component. */
const Tooltip = memo((props) => {
    var _a, _b;
    let child = props.children;
    const isValidElement$1 = isValidElement(child);
    if (!isValidElement$1 || ((_a = child === null || child === void 0 ? void 0 : child.props) === null || _a === void 0 ? void 0 : _a.disabled)) {
        child = createElement("span", null, child);
    }
    const theme = useTheme(css);
    const classNames = useClassNames(theme, 'tooltip', props.variant);
    const placement = props.placement ? props.placement : 'bottom';
    const open = (!props.text) ? false : props.open;
    return (createElement(muiTooltip__default, { className: classNames, placement: placement, title: (_b = props.text) !== null && _b !== void 0 ? _b : '', disableFocusListener: true, open: open }, child));
});

var css_248z$1 = ".Button-module_button__1yqRw {\n  font-family: inherit;\n  color: inherit;\n  background: #ddd;\n}\n.Button-module_button_sizeFull__R6URd {\n  flex: 1;\n  width: 100%;\n}\n.Button-module_button_sizeSmall__LTh7L {\n  padding: 4px 10px;\n}\n.Button-module_button_sizeLarge__md1oN {\n  padding: 8px 11px;\n}";
var css$1 = {"button":"Button-module_button__1yqRw","button_sizeFull":"Button-module_button_sizeFull__R6URd","button_sizeSmall":"Button-module_button_sizeSmall__LTh7L","button_sizeLarge":"Button-module_button_sizeLarge__md1oN"};
styleInject(css_248z$1,{"insertAt":"top"});

/** This controls builds a basic Button with more options. */
const Button = memo((props) => {
    var _a;
    const size = (_a = props.size) !== null && _a !== void 0 ? _a : 'medium';
    const onClickImpl = props.onClick;
    const onClick = useCallback((event) => onClickImpl && onClickImpl(event), [onClickImpl]);
    const theme = useTheme(css$1);
    const classNames = useClassNames(theme, 'button', [
        `size${size.charAt(0).toUpperCase() + size.slice(1)}`,
        props.variant,
    ]);
    // Setup defaults
    let control = (createElement(ButtonBase, { classes: {
            disabled: theme[`button_disabled`],
        }, className: classNames, disabled: props.disabled, disableRipple: props.disableRipple, focusRipple: !props.disableFocusRipple, centerRipple: props.centerRipple, onClick: onClick, type: props.submit ? 'submit' : undefined }, props.children));
    // Add the tooltip if needed.
    if (!!props.tooltip) {
        control = (createElement(Tooltip, { text: props.tooltip }, control));
    }
    return control;
});

var css_248z$2 = ".ButtonGroup-module_buttonGroup__38lZF {\n  display: flex;\n  justify-content: flex-end;\n  height: 45px;\n  z-index: 1;\n}\n.ButtonGroup-module_buttonGroup_leftAlign__3DRhf {\n  justify-content: flex-start;\n}\n.ButtonGroup-module_buttonGroup_centerAlign__Tn9vZ {\n  justify-content: center;\n}\n.ButtonGroup-module_buttonGroup_rightAlign__2Zscy {\n  justify-content: flex-end;\n}";
var css$2 = {"buttonGroup":"ButtonGroup-module_buttonGroup__38lZF","buttonGroup_leftAlign":"ButtonGroup-module_buttonGroup_leftAlign__3DRhf","buttonGroup_centerAlign":"ButtonGroup-module_buttonGroup_centerAlign__Tn9vZ","buttonGroup_rightAlign":"ButtonGroup-module_buttonGroup_rightAlign__2Zscy"};
styleInject(css_248z$2,{"insertAt":"top"});

const ButtonGroup = memo((props) => {
    const theme = useTheme(css$2);
    const classNames = useClassNames(theme, 'buttonGroup', props.variant);
    if (Children.count(props.children) > 0) {
        return (createElement("div", { className: classNames }, props.children));
    }
    else {
        return null;
    }
});

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

var css_248z$3 = ".Checkbox-module_checkbox_button__1L6H9 {\n  padding: 0;\n  height: 44px;\n  width: 44px;\n  margin-right: 10px;\n}\n.Checkbox-module_checkbox_checkboxField__U97oj {\n  margin: 0 10px;\n}\n.Checkbox-module_checkbox_checked__VJAF8 {\n  color: inherit;\n}";
var css$3 = {"checkbox_button":"Checkbox-module_checkbox_button__1L6H9","checkbox_checkboxField":"Checkbox-module_checkbox_checkboxField__U97oj","checkbox_checked":"Checkbox-module_checkbox_checked__VJAF8"};
styleInject(css_248z$3,{"insertAt":"top"});

var css_248z$4 = ".Icon-module_icon__3zJ6R {\n  font-size: 24px;\n}\n@supports (display: contents) {\n  .Icon-module_icon__3zJ6R {\n    display: contents;\n  }\n}\n@supports not (display: contents) {\n  .Icon-module_icon__3zJ6R {\n    display: ruby-base;\n  }\n}\n.Icon-module_icon_underline__2CQv7 {\n  text-decoration: underline;\n}\n.Icon-module_icon_clickable__1jgar {\n  cursor: pointer;\n}\n.Icon-module_icon_sizeXs__3eLax {\n  font-size: 0.75em;\n}\n.Icon-module_icon_sizeSm__2k5sQ {\n  font-size: 0.875em;\n}\n.Icon-module_icon_sizeRg__2HTaC {\n  font-size: 1em;\n}\n.Icon-module_icon_sizeLg__22Fx8 {\n  font-size: 1.5em;\n}\n.Icon-module_icon_sizeXL__30L_4 {\n  font-size: 2.5em;\n}\n.Icon-module_icon_childRootImg__1ZPAO {\n  display: flex;\n}\n.Icon-module_icon_childRoot__V2gQC {\n  display: inline-block;\n}\n.Icon-module_icon_svgChildRoot__3YlrU {\n  align-self: center;\n}\n.Icon-module_icon_svgIcon__5lUPr {\n  font-size: 24px;\n  align-self: center;\n  display: inline-flex;\n}\n@media screen and (max-width: 1680px) {\n  .Icon-module_icon_svgIcon__5lUPr {\n    font-size: 23px;\n  }\n}\n@media screen and (max-width: 1366px) {\n  .Icon-module_icon_svgIcon__5lUPr {\n    font-size: 22px;\n  }\n}";
var css$4 = {"icon":"Icon-module_icon__3zJ6R","icon_underline":"Icon-module_icon_underline__2CQv7","icon_clickable":"Icon-module_icon_clickable__1jgar","icon_sizeXs":"Icon-module_icon_sizeXs__3eLax","icon_sizeSm":"Icon-module_icon_sizeSm__2k5sQ","icon_sizeRg":"Icon-module_icon_sizeRg__2HTaC","icon_sizeLg":"Icon-module_icon_sizeLg__22Fx8","icon_sizeXL":"Icon-module_icon_sizeXL__30L_4","icon_childRootImg":"Icon-module_icon_childRootImg__1ZPAO","icon_childRoot":"Icon-module_icon_childRoot__V2gQC","icon_svgChildRoot":"Icon-module_icon_svgChildRoot__3YlrU","icon_svgIcon":"Icon-module_icon_svgIcon__5lUPr"};
styleInject(css_248z$4,{"insertAt":"top"});

/** Builds an Icon. */
const Icon = memo((props) => {
    // Determine the type of icon.
    const isSVG = (props.children && typeof props.children === 'function');
    return isSVG ? createElement(SVGIcon, Object.assign({}, props)) : createElement(FontIcon, Object.assign({}, props));
});
/** Font Icons. */
const FontIcon = (props) => {
    const size = (!!props.size) ? props.size : 'rg';
    // Determine if icon just be passed as a property or a child.
    const isImg = props.children ? props.children.type === 'img' : false;
    const theme = useTheme(css$4);
    const classNames = useClassNames(theme, 'icon', [
        `size${size.charAt(0).toUpperCase() + size.slice(1)}`,
        props.variant,
    ]);
    const childClassNames = useClassNames(theme, 'icon', [
        'childRoot',
        `size${size.charAt(0).toUpperCase() + size.slice(1)}`,
        props.childVariant,
        isImg ? 'childRootImg' : undefined,
    ]);
    // Base Icon.
    let iconElement = null;
    if (isImg) {
        iconElement = createElement("span", { className: childClassNames });
    }
    else {
        iconElement = createElement("span", { className: childClassNames }, props.children);
    }
    // Add the tooltip if needed.
    if (props.tooltip) {
        const tooltipProps = typeof props.tooltip === 'string' ?
            { text: props.tooltip } :
            props.tooltip;
        iconElement = (createElement(Tooltip, Object.assign({}, tooltipProps), iconElement));
    }
    const control = (createElement(muiIcon__default, { className: classNames, onClick: props.onClick, onMouseEnter: props.onMouseEnter, onMouseLeave: props.onMouseLeave }, iconElement));
    return control;
};
/** SVG Icons. */
const SVGIcon = (props) => {
    // Setup defaults
    const defaultSize = 'rg';
    const size = (props.size !== undefined) ? props.size : defaultSize;
    const theme = useTheme(css$4);
    const classNames = useClassNames(theme, 'icon', [
        'svgChildRoot',
        `size${size.charAt(0).toUpperCase() + size.slice(1)}`,
        props.onClick ? 'clickable' : undefined,
        props.childVariant,
    ]);
    const spanClass = theme[`icon__svgIcon`] + ' ' + props.spanClassName;
    const child = props.children ? props.children() : null;
    let control = (createElement("span", { className: spanClass },
        createElement(muiSvgIcon__default, { className: classNames, onClick: props.onClick, onMouseEnter: props.onMouseEnter, onMouseLeave: props.onMouseLeave }, child)));
    // Add the tooltip if needed.
    if (props.tooltip) {
        const tooltipProps = typeof props.tooltip === 'string' ?
            { text: props.tooltip } :
            props.tooltip;
        control = (createElement(Tooltip, Object.assign({}, tooltipProps), control));
    }
    return control;
};

var css_248z$5 = ".IconButton-module_iconButton__HvlOX {\n  width: 44px;\n  height: 44px;\n  padding: 0;\n  vertical-align: baseline;\n}\n.IconButton-module_iconButton__HvlOX:hover {\n  background-color: inherit;\n}\n.IconButton-module_iconButton_iconButtonOnHover___VwdF .IconButton-module_iconButtonChildSelected__1yjtq {\n  visibility: hidden;\n}\n.IconButton-module_iconButton_iconButtonOnHover___VwdF:hover .IconButton-module_iconButtonChildSelected__1yjtq {\n  visibility: inherit;\n}\n.IconButton-module_iconButton_iconButtonGlowing__1X5cw {\n  -webkit-animation: IconButton-module_glowing__3OGcm 1500ms infinite;\n  -moz-animation: IconButton-module_glowing__3OGcm 1500ms infinite;\n  -o-animation: IconButton-module_glowing__3OGcm 1500ms infinite;\n  animation: IconButton-module_glowing__3OGcm 1500ms infinite;\n}\n.IconButton-module_iconButton__iconButtonChildSelected__3G47f {\n  height: 1px;\n  width: 100%;\n}\n.IconButton-module_iconButton__iconButtonChildSelectedIndicator__1AF5Q {\n  margin: auto;\n  width: 60%;\n  height: 100%;\n}\n.IconButton-module_iconButton__iconButtonChild__-4Kio {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n@media (max-width: 1366px) {\n  .IconButton-module_iconButton__HvlOX {\n    width: 35px;\n  }\n}\n@-webkit-keyframes IconButton-module_glowing__3OGcm {\n  0% {\n    filter: brightness(100%) drop-shadow(0 0 3px);\n  }\n  50% {\n    filter: brightness(150%) drop-shadow(0 0 20px);\n  }\n  100% {\n    filter: brightness(100%) drop-shadow(0 0 3px);\n  }\n}\n@-moz-keyframes IconButton-module_glowing__3OGcm {\n  0% {\n    filter: brightness(100%) drop-shadow(0 0 3px);\n  }\n  50% {\n    filter: brightness(150%) drop-shadow(0 0 20px);\n  }\n  100% {\n    filter: brightness(100%) drop-shadow(0 0 3px);\n  }\n}\n@-o-keyframes IconButton-module_glowing__3OGcm {\n  0% {\n    filter: brightness(100%) drop-shadow(0 0 3px);\n  }\n  50% {\n    filter: brightness(150%) drop-shadow(0 0 20px);\n  }\n  100% {\n    filter: brightness(100%) drop-shadow(0 0 3px);\n  }\n}\n@keyframes IconButton-module_glowing__3OGcm {\n  0% {\n    filter: brightness(100%) drop-shadow(0 0 3px);\n  }\n  50% {\n    filter: brightness(150%) drop-shadow(0 0 20px);\n  }\n  100% {\n    filter: brightness(100%) drop-shadow(0 0 3px);\n  }\n}";
var css$5 = {"iconButton":"IconButton-module_iconButton__HvlOX","iconButton_iconButtonOnHover":"IconButton-module_iconButton_iconButtonOnHover___VwdF","iconButtonChildSelected":"IconButton-module_iconButtonChildSelected__1yjtq","iconButton_iconButtonGlowing":"IconButton-module_iconButton_iconButtonGlowing__1X5cw","glowing":"IconButton-module_glowing__3OGcm","iconButton__iconButtonChildSelected":"IconButton-module_iconButton__iconButtonChildSelected__3G47f","iconButton__iconButtonChildSelectedIndicator":"IconButton-module_iconButton__iconButtonChildSelectedIndicator__1AF5Q","iconButton__iconButtonChild":"IconButton-module_iconButton__iconButtonChild__-4Kio"};
styleInject(css_248z$5,{"insertAt":"top"});

/** Builds an IconButton with more options. */
const IconButton = memo((props) => {
    const theme = useTheme(css$5);
    const classNames = useClassNames(theme, 'iconButton', [
        props.selected && !props.selectedIndicator && props.selectedIndicatorOnHover ? 'iconButtonOnHover' : undefined,
        props.glow ? 'iconButtonGlowing' : undefined,
        props.disabled ? (props.disabledAlternate ? 'disabledAlternate' : 'disabled') : undefined,
        props.variant,
    ]) + (props.className ? ' ' + props.className : '');
    let selectedIndicator = null;
    if (props.selected && (props.selectedIndicator || props.selectedIndicatorOnHover)) {
        selectedIndicator = (createElement("div", { className: theme['iconButton__iconButtonChildSelected'] },
            createElement("div", { className: theme['iconButton__iconButtonChildSelectedIndicator'] })));
    }
    // Base IconButton.
    let control = (createElement(muiIconButton__default, { className: classNames, id: props.id, disabled: props.disabled, disableRipple: true, disableTouchRipple: true, disableFocusRipple: true, onClick: props.onClick, style: {
            width: props.width ? props.width : null,
            height: props.height ? props.height : null,
            borderRadius: props.square ? 0 : null,
            zIndex: props.onTop ? 1 : null,
            cursor: props.disableCursor ? 'default' : 'pointer',
        } },
        createElement("div", { className: theme['iconButton__iconButtonChild'] },
            props.children,
            selectedIndicator)));
    // Add the tooltip if needed.
    if (props.tooltip) {
        const tooltipProps = typeof props.tooltip === 'string' ?
            { text: props.tooltip } :
            props.tooltip;
        control = (createElement(Tooltip, Object.assign({}, tooltipProps), control));
    }
    return control;
});

const Checkbox = memo((props) => {
    // Triggered when a field's value is changed.
    const onCheckboxChange = useCallback((event, checked) => {
        // prevent the onRowSelect from occurring.
        if (props.inDataList) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (props.onChange) {
            props.onChange(props.id, checked);
        }
    }, [props === null || props === void 0 ? void 0 : props.id, props === null || props === void 0 ? void 0 : props.inDataList, props === null || props === void 0 ? void 0 : props.onChange]);
    // We will pass all props to the InnerControl except the functions.
    const other = __rest(props, ["onChange"]);
    return (createElement(InnerControl, Object.assign({ onChange: onCheckboxChange }, other)));
});
/** This is the styled implementation of a Checkbox. */
const InnerControl = (props) => {
    const theme = useTheme(css$3);
    const classNames = useClassNames(theme, 'checkbox', [
        props.checked ? 'checked' : undefined,
        props.disabled ? 'disabled' : undefined,
        props.variant,
    ]);
    const labelPlacement = props.labelPlacement ? props.labelPlacement : 'end';
    const isChecked = props.checked ? true : false;
    const iconSize = props.size ? props.size : 'xs';
    let checkbox = (createElement(muiCheckbox__default, { className: classNames, id: props.id, value: props.id, checked: isChecked, indeterminate: props.indeterminate, disabled: props.disabled, onChange: props.onChange, checkedIcon: createElement(Icon, { size: 'rg' }, IconCheckboxChecked), icon: createElement(Icon, { size: 'rg' }, IconCheckboxUnchecked), disableRipple: true, disableTouchRipple: true }));
    // Add the tooltip if needed.
    if (props.tooltip) {
        checkbox = (createElement(Tooltip, { text: props.tooltip },
            createElement("span", { className: 'fitContent' }, checkbox)));
    }
    // Note that material ui .20 had label as a prop for checkboxes.  material ui 1.0 does not have a label prop on the checkbox.
    let context = (createElement(Fragment, null, checkbox));
    if (!!props.inDataList) {
        context = (createElement(IconButton, { onClick: (event) => props.onChange(event, !props.checked), disabled: props.disabled, width: props.width, height: props.height, tooltip: props.tooltip },
            createElement(Icon, { size: iconSize }, props.checked ? IconCheckboxChecked : IconCheckboxUnchecked)));
    }
    else if (!!props.label && props.label.length > 0) {
        context = (createElement(FormControlLabel, { labelPlacement: labelPlacement, control: checkbox, label: props.label, disabled: props.disabled, classes: {
                root: theme['checkbox__checkboxField'],
                label: props.labelClass,
            } }));
    }
    return (createElement(Fragment, null, context));
};

var css_248z$6 = "";
var css$6 = {};
styleInject(css_248z$6,{"insertAt":"top"});

/** Displays a Circular Progress Indicator. */
const CircularProgress = memo((props) => {
    var _a, _b, _c;
    // Setup defaults
    const max = (_a = props.max) !== null && _a !== void 0 ? _a : 100;
    const min = (_b = props.min) !== null && _b !== void 0 ? _b : 0;
    const size = props.size ? props.size : 40;
    const thickness = props.thickness ? props.thickness : 3.6;
    const value = props.value ? props.value : 0;
    const type = props.type ? props.type : 'indeterminate';
    const color = (_c = props.color) !== null && _c !== void 0 ? _c : 'default';
    const theme = useTheme(css$6);
    // Apply default class name and class Size
    const classNames = `${theme.circularProgress} ` + theme[`color${color.charAt(0).toUpperCase() + color.slice(1)}`];
    return (createElement(muiCircularProgress__default, { className: classNames, value: (value - min) / (max - min) * 100, size: size, thickness: thickness, variant: type }));
});

/** Custom styles for the Collapse control. */
const styles = createStyles({
    entered: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
    },
    wrapper: {
        flex: 1,
    },
    wrapperInner: {
        display: 'flex',
        flexDirection: 'column',
    },
});
/** Builds a collapsible container around the given elements. */
const Collapse = withStyles(styles)((props) => {
    const collapsedHeight = props.collapsedHeight ? `${props.collapsedHeight}px` : '0px';
    return (createElement(muiCollapse__default, { classes: {
            entered: props.fill ? props.classes.entered : null,
            wrapper: props.fill ? props.classes.wrapper : null,
            wrapperInner: props.fill ? props.classes.wrapperInner : null,
        }, in: props.collapse, collapsedHeight: collapsedHeight, timeout: 'auto', onEntered: (props.onEntered) ? props.onEntered : undefined }, props.children));
});

var css_248z$7 = ".Literal-module_textDiv__32w81 {\n  overflow: hidden;\n  white-space: nowrap !important;\n  text-overflow: ellipsis;\n  opacity: inherit;\n}";
var css$7 = {"textDiv":"Literal-module_textDiv__32w81"};
styleInject(css_248z$7,{"insertAt":"top"});

/** Builds an Icon. */
const Literal = memo((props) => {
    var _a, _b, _c, _d, _e;
    const [isOverflow, setIsOverflow] = useState(false);
    /** This variable is used to keep track of the parent div for the text.
     * We use it to determine if we need to display a tooltip when requested.
     */
    let literalRef = null;
    useEffect(() => {
        if (literalRef) {
            // Check the text is out-of-bounds.
            if (literalRef.clientWidth < literalRef.scrollWidth) {
                setIsOverflow(true);
            }
            if (props.getRef) {
                props.getRef(literalRef);
            }
        }
    }, [literalRef, props === null || props === void 0 ? void 0 : props.getRef]);
    const hasLabel = ((_b = (_a = props === null || props === void 0 ? void 0 : props.label) === null || _a === void 0 ? void 0 : _a.trim()) !== null && _b !== void 0 ? _b : '') !== '';
    let tooltipWithLabel = '';
    if (hasLabel) {
        tooltipWithLabel = isOverflow ? props.label + ': ' + props.text : props.label;
    }
    let showTooltip = false;
    if (hasLabel) {
        showTooltip = ((_c = tooltipWithLabel === null || tooltipWithLabel === void 0 ? void 0 : tooltipWithLabel.trim()) !== null && _c !== void 0 ? _c : '') !== '';
    }
    else if (isOverflow) {
        showTooltip = ((_e = (_d = props === null || props === void 0 ? void 0 : props.text) === null || _d === void 0 ? void 0 : _d.trim()) !== null && _e !== void 0 ? _e : '') !== '';
    }
    const theme = useTheme(css$7);
    const classNames = useClassNames(theme, 'literal', [
        props.variant,
    ]);
    let text = createElement("span", null, props.text);
    // display with tooltip if given a label, or if overflowing
    if (showTooltip && !props.hideTooltip) {
        text = (createElement(Tooltip, { text: hasLabel ? tooltipWithLabel : props.text }, text));
    }
    if (!!props.textIsLink && !!props.onLinkClick) {
        text = (createElement("a", { onClick: props.onLinkClick, className: props.linkClass },
            text,
            props.required && createElement("span", null, "*")));
    }
    return (createElement("div", { ref: (el) => literalRef = el, className: classNames, style: { width: `${props.width}px` } }, text));
});

var css_248z$8 = ".TextField-module_textField___jQH1 + textarea {\n  min-height: 0px !important;\n}\n.TextField-module_textField___jQH1 label + .MuiInput-formControl {\n  margin-top: 14px;\n}\n.TextField-module_textField___jQH1 label + .MuiInput-multiline {\n  margin-top: 19px;\n}\n.TextField-module_textField_fullWidth__140No {\n  width: 100%;\n}\n.TextField-module_textField_sizeXs__1Ta2r {\n  width: 4rem;\n}\n.TextField-module_textField_sizeSm__33m9b {\n  width: 7rem;\n}\n.TextField-module_textField_sizeMd__1eTyb {\n  width: 10rem;\n}\n.TextField-module_textField_sizeLg__100Nn {\n  width: 13rem;\n}\n.TextField-module_textField_size15x__1HP9e {\n  width: 15rem;\n}\n.TextField-module_textField_sizeXl__2C20l {\n  width: 21rem;\n}\n.TextField-module_textField_sizeXxl__34zVO {\n  width: 26rem;\n}\n.TextField-module_textField_size3xl__y42Jf {\n  width: 30rem;\n}\n.TextField-module_textField_sizeStatic__dPXG5 {\n  width: 150px;\n}\n.TextField-module_textField_sizeStaticsm__3Mv34 {\n  width: 90px;\n}\n.TextField-module_textField_sizeStaticlg__1Xzoa {\n  width: 200px;\n}\n.TextField-module_textField_sizeStaticxl__1N89P {\n  width: 250px;\n}\n.TextField-module_textField_bold__b5IS3 {\n  font-weight: bold;\n}\n.TextField-module_textField_marginBottom__1Z2gr {\n  margin-bottom: 14px;\n}\n.TextField-module_textField_roundedBorder__Kaigy {\n  border: 1px solid var(--labelColor);\n  border-radius: 20px;\n  overflow: hidden;\n  padding: 0 10px;\n  flex-direction: row;\n}\n.TextField-module_textField_roundedBorder__Kaigy:hover {\n  border-color: var(--primaryColor);\n}\n.TextField-module_textField__input__1cfno {\n  display: inline-flex;\n  padding: 0 9px;\n  font-family: inherit;\n  font-size: 1rem;\n  color: var(--textColor);\n  height: 24px;\n}\n.TextField-module_textField__input_default__1Rq5i {\n  color: var(--textColor);\n}\n.TextField-module_textField__input_primary__3MzHK {\n  color: var(--primaryColor);\n}\n.TextField-module_textField__input_secondary__MRNQp {\n  color: var(--secondaryColor);\n}\n.TextField-module_textField__input_contrast__u5Qtg {\n  color: var(--contrastColor);\n}\n.TextField-module_textField__input__1cfno:hover > .MuiSelect-icon {\n  color: var(--primaryColor);\n}\n.TextField-module_textField__input_fullWidth__1E3sw {\n  width: 100%;\n}\n.TextField-module_textField__input_fullHeight__ZmNaw {\n  height: 100%;\n}\n.TextField-module_textField__input_full__1U5kZ {\n  width: 100%;\n  height: 100%;\n}\n.TextField-module_textField__input_multiline__aut_D {\n  padding-left: 5px;\n  border: 1px solid var(--borderColor);\n  border-radius: 4px;\n}\n.TextField-module_textField__input_border__3KO2S {\n  border-style: solid;\n  border-width: 1px;\n}\n.TextField-module_textField__input_borderHasContent__1XGAH {\n  border-style: solid;\n  border-width: 1px;\n}\n.TextField-module_textField__input_borderError__2pmal {\n  border-style: solid;\n  border-width: 1px;\n}\n.TextField-module_textField__input_roundedBorderSelect__3037N {\n  display: flex;\n  flex-grow: 1;\n  flex-shrink: 0;\n  align-items: center;\n  padding-left: 10px;\n  padding-right: 10px;\n  margin-left: -10px;\n  margin-right: -10px;\n  box-sizing: border-box;\n}\n.TextField-module_textField__input_readOnly__1At-0 {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  opacity: inherit;\n  color: var(--textColor);\n}\n.TextField-module_textField__input_underline__UV9lW:before {\n  border-bottom-width: 1px;\n  border-bottom-style: solid;\n}\n.TextField-module_textField__input_underline__UV9lW:after {\n  border-bottom-width: 2px;\n  border-bottom-style: solid;\n}\n.TextField-module_textField__input_underline__UV9lW.TextField-module_textField__input_underline__UV9lW error:not(.TextField-module_textField__input_disabled__1rHpB):before {\n  border-bottom-color: var(--errorColor);\n}\n.TextField-module_textField__input_underline__UV9lW.TextField-module_textField__input_underline__UV9lW error:not(.TextField-module_textField__input_disabled__1rHpB):after {\n  border-bottom-color: var(--errorColor);\n}\n.TextField-module_textField__input_underline__UV9lW.TextField-module_textField__input_required__3n2fO:not(.TextField-module_textField__input_disabled__1rHpB):not(.TextField-module_textField__input_error__2Da3X):before {\n  border-bottom: 2px solid var(--errorColor);\n}\n.TextField-module_textField__input_underline__UV9lW.TextField-module_textField__input_required__3n2fO:not(.TextField-module_textField__input_disabled__1rHpB):not(.TextField-module_textField__input_error__2Da3X):after {\n  border-bottom: 2px solid var(--errorColor);\n}\n.TextField-module_textField__input_underline__UV9lW:hover:not(.TextField-module_textField__input_disabled__1rHpB):not(.TextField-module_textField__input_focused__1Nuba):not(.TextField-module_textField__input_error__2Da3X):before {\n  border-bottom-width: 1px;\n  border-bottom-style: solid;\n}\n.TextField-module_textField__input_underline-default__1jpK1:after, .TextField-module_textField__input_underline-defaultFilled__1raSw:after {\n  border-bottom-color: var(--defaultColor);\n}\n.TextField-module_textField__input_underline-default__1jpK1:before, .TextField-module_textField__input_underline-defaultFilled__1raSw:before {\n  border-bottom-color: var(--labelColor);\n}\n.TextField-module_textField__input_underline-default__1jpK1:hover:not(.TextField-module_disabled__nGdOX):not(.TextField-module_focused__3OJbn):not(.TextField-module_error__1J67e):not(.TextField-module_required__3YmdA):before, .TextField-module_textField__input_underline-defaultFilled__1raSw:hover:not(.TextField-module_disabled__nGdOX):not(.TextField-module_focused__3OJbn):not(.TextField-module_error__1J67e):not(.TextField-module_required__3YmdA):before {\n  border-bottom-color: var(--primaryColor);\n}\n.TextField-module_textField__input_underline-default__1jpK1.TextField-module_disabled__nGdOX:before, .TextField-module_textField__input_underline-defaultFilled__1raSw.TextField-module_disabled__nGdOX:before {\n  border-bottom-color: var(--disabledColor);\n}\n.TextField-module_textField__input_underline-default__1jpK1.TextField-module_focused__3OJbn:not(.TextField-module_error__1J67e):not(.TextField-module_required__3YmdA):after, .TextField-module_textField__input_underline-defaultFilled__1raSw.TextField-module_focused__3OJbn:not(.TextField-module_error__1J67e):not(.TextField-module_required__3YmdA):after {\n  border-bottom-color: var(--textColor);\n}\n.TextField-module_textField__input_underline-defaultFilled__1raSw:before {\n  border-bottom-color: var(--textColor);\n}\n.TextField-module_textField__input_underline-defaultFilled__1raSw.TextField-module_focused__3OJbn:not(.TextField-module_error__1J67e):not(.TextField-module_required__3YmdA):after {\n  border-bottom-color: var(--defaultColor);\n}\n.TextField-module_textField__input_underline-primary__J7N-W:after, .TextField-module_textField__input_underline-primaryFilled__2t0ML:after {\n  border-bottom-color: var(--secondaryColor);\n}\n.TextField-module_textField__input_underline-primary__J7N-W:before, .TextField-module_textField__input_underline-primaryFilled__2t0ML:before {\n  border-bottom-color: var(--primaryColor) 6B;\n  /* not a typo, adds transparency */\n}\n.TextField-module_textField__input_underline-primary__J7N-W:hover:not(.TextField-module_textField__input_disabled__1rHpB):not(.TextField-module_textField__input_focused__1Nuba):not(.TextField-module_textField__input_error__2Da3X):not(.TextField-module_textField__input_required__3n2fO):before, .TextField-module_textField__input_underline-primaryFilled__2t0ML:hover:not(.TextField-module_textField__input_disabled__1rHpB):not(.TextField-module_textField__input_focused__1Nuba):not(.TextField-module_textField__input_error__2Da3X):not(.TextField-module_textField__input_required__3n2fO):before {\n  border-bottom-color: var(--primaryColor);\n}\n.TextField-module_textField__input_underline-primary__J7N-W.TextField-module_textField__input_disabled__1rHpB:before, .TextField-module_textField__input_underline-primaryFilled__2t0ML.TextField-module_textField__input_disabled__1rHpB:before {\n  border-bottom-color: linear-gradient(to right, var(--primaryColor) 6B 33%, transparent 0%);\n}\n.TextField-module_textField__input_underline-primary__J7N-W.TextField-module_textField__input_focused__1Nuba:not(.TextField-module_textField__input_error__2Da3X):not(.TextField-module_textField__input_required__3n2fO):after, .TextField-module_textField__input_underline-primaryFilled__2t0ML.TextField-module_textField__input_focused__1Nuba:not(.TextField-module_textField__input_error__2Da3X):not(.TextField-module_textField__input_required__3n2fO):after {\n  border-bottom-color: var(--secondaryColor);\n}\n.TextField-module_textField__input_underline-secondary__2HEpx:after, .TextField-module_textField__input_underline-secondaryFilled__1HhiY:after {\n  border-bottom-color: var(--primaryColor);\n}\n.TextField-module_textField__input_underline-secondary__2HEpx:before, .TextField-module_textField__input_underline-secondaryFilled__1HhiY:before {\n  border-bottom-color: var(--secondaryColor) 6B;\n}\n.TextField-module_textField__input_underline-secondary__2HEpx:hover:not(.TextField-module_textField__input_disabled__1rHpB):not(.TextField-module_textField__input_focused__1Nuba):not(.TextField-module_textField__input_error__2Da3X):not(.TextField-module_textField__input_required__3n2fO):before, .TextField-module_textField__input_underline-secondaryFilled__1HhiY:hover:not(.TextField-module_textField__input_disabled__1rHpB):not(.TextField-module_textField__input_focused__1Nuba):not(.TextField-module_textField__input_error__2Da3X):not(.TextField-module_textField__input_required__3n2fO):before {\n  border-bottom-color: var(--secondaryColor);\n}\n.TextField-module_textField__input_underline-secondary__2HEpx.TextField-module_textField__input_disabled__1rHpB:before, .TextField-module_textField__input_underline-secondaryFilled__1HhiY.TextField-module_textField__input_disabled__1rHpB:before {\n  border-bottom-color: linear-gradient(to right, var(--secondaryColor) 6B 33%, transparent 0%);\n}\n.TextField-module_textField__input_underline-secondary__2HEpx.TextField-module_textField__input_focused__1Nuba:not(.TextField-module_textField__input_error__2Da3X):not(.TextField-module_textField__input_required__3n2fO):after, .TextField-module_textField__input_underline-secondaryFilled__1HhiY.TextField-module_textField__input_focused__1Nuba:not(.TextField-module_textField__input_error__2Da3X):not(.TextField-module_textField__input_required__3n2fO):after {\n  border-bottom-color: var(--primaryColor);\n}\n.TextField-module_textField__input_underline-contrast__2KK2M:after, .TextField-module_textField__input_underline-contrastFilled__3uedR:after {\n  border-bottom-color: var(--textColor);\n}\n.TextField-module_textField__input_underline-contrast__2KK2M:before, .TextField-module_textField__input_underline-contrastFilled__3uedR:before {\n  border-bottom-color: var(--contrastColor) 6B;\n}\n.TextField-module_textField__input_underline-contrast__2KK2M:hover:not(.TextField-module_textField__input_disabled__1rHpB):not(.TextField-module_textField__input_focused__1Nuba):not(.TextField-module_textField__input_error__2Da3X):not(.TextField-module_textField__input_required__3n2fO):before, .TextField-module_textField__input_underline-contrastFilled__3uedR:hover:not(.TextField-module_textField__input_disabled__1rHpB):not(.TextField-module_textField__input_focused__1Nuba):not(.TextField-module_textField__input_error__2Da3X):not(.TextField-module_textField__input_required__3n2fO):before {\n  border-bottom-color: var(--contrastColor);\n}\n.TextField-module_textField__input_underline-contrast__2KK2M.TextField-module_textField__input_disabled__1rHpB:before, .TextField-module_textField__input_underline-contrastFilled__3uedR.TextField-module_textField__input_disabled__1rHpB:before {\n  border-bottom-color: linear-gradient(to right, var(--contrastColor) 6B 33%, transparent 0%);\n}\n.TextField-module_textField__input_underline-contrast__2KK2M.TextField-module_textField__input_focused__1Nuba:not(.TextField-module_textField__input_error__2Da3X):not(.TextField-module_textField__input_required__3n2fO):after, .TextField-module_textField__input_underline-contrastFilled__3uedR.TextField-module_textField__input_focused__1Nuba:not(.TextField-module_textField__input_error__2Da3X):not(.TextField-module_textField__input_required__3n2fO):after {\n  border-bottom-color: var(--textColor);\n}\n.TextField-module_textField__input_overFlow__9hiUW {\n  overflow: hidden;\n  white-space: nowrap !important;\n  text-overflow: ellipsis !important;\n  opacity: inherit;\n}\n.TextField-module_textField__input_inputTypeSearch__1714L[type=search] {\n  /* clears the 'X' from Internet Explorer */\n  /* clears the 'X' from Chrome */\n}\n.TextField-module_textField__input_inputTypeSearch__1714L[type=search]::-ms-clear, .TextField-module_textField__input_inputTypeSearch__1714L[type=search]::-ms-reveal {\n  display: none;\n  width: 0;\n  height: 0;\n}\n.TextField-module_textField__input_inputTypeSearch__1714L[type=search]::-webkit-search-decoration, .TextField-module_textField__input_inputTypeSearch__1714L[type=search]::-webkit-search-cancel-button, .TextField-module_textField__input_inputTypeSearch__1714L[type=search]::-webkit-search-results-button, .TextField-module_textField__input_inputTypeSearch__1714L[type=search]::-webkit-search-results-decoration {\n  display: none;\n}\n.TextField-module_textField__input_inputTypeSearch__1714L[type=search]::placeholder {\n  opacity: 1;\n}\n.TextField-module_textField__label__2xTmI {\n  font-family: inherit;\n  font-size: 1rem;\n  transform: translate(0px, 19px);\n  width: inherit;\n}\n.TextField-module_textField__label_default__2OaKv {\n  color: var(--textColor);\n}\n.TextField-module_textField__label_primary__1c8yG {\n  color: var(--primaryColor);\n}\n.TextField-module_textField__label_secondary__1Z3GB {\n  color: var(--secondaryColor);\n}\n.TextField-module_textField__label_contrast__2ywu3 {\n  color: var(--contrastColor);\n}\n.TextField-module_textField__label_disabled__3_wEm {\n  color: var(--textColor) 92;\n}\n.TextField-module_textField__label_error__244UX:not(.TextField-module_textField__label_disabled__3_wEm) {\n  color: var(--errorColor);\n  font-weight: bold;\n}\n.TextField-module_textField__label_required__1Snti:not(.TextField-module_textField__label_disabled__3_wEm):not(.TextField-module_textField__label_error__244UX) {\n  font-weight: bold;\n}\n.TextField-module_textField__label_withAdornment__2qgWp:not([class*=shrink-]) {\n  width: calc(100% - 24px);\n}\n.TextField-module_textField__label_shrink__1eMLT {\n  font-size: 0.857rem;\n  transform: translate(0, 1.5px);\n}\n.TextField-module_textField__adornment_positionStart__iP6KS {\n  margin-left: 2px;\n  height: auto;\n}\n.TextField-module_textField__adornment_positionEnd__1LOiY {\n  height: auto;\n}\n.TextField-module_textField_helper__3hf88 {\n  font-family: inherit;\n  font-size: 0.857rem;\n  margin-top: 5px;\n}\n.TextField-module_textField_helper_default__1vkEz {\n  color: var(--textColor);\n}\n.TextField-module_textField_helper_primary__3_czB {\n  color: var(--primaryColor);\n}\n.TextField-module_textField_helper_secondary__3Awki {\n  color: var(--secondaryColor);\n}\n.TextField-module_textField_helper_contrast__v5Bs8 {\n  color: var(--contrastColor);\n}\n.TextField-module_textField_helper_error__3hyHx:not(.TextField-module_textField_helper_disabled__2eIYd) {\n  color: var(--errorColor);\n}";
var css$8 = {"textField":"TextField-module_textField___jQH1","textField_fullWidth":"TextField-module_textField_fullWidth__140No","textField_sizeXs":"TextField-module_textField_sizeXs__1Ta2r","textField_sizeSm":"TextField-module_textField_sizeSm__33m9b","textField_sizeMd":"TextField-module_textField_sizeMd__1eTyb","textField_sizeLg":"TextField-module_textField_sizeLg__100Nn","textField_size15x":"TextField-module_textField_size15x__1HP9e","textField_sizeXl":"TextField-module_textField_sizeXl__2C20l","textField_sizeXxl":"TextField-module_textField_sizeXxl__34zVO","textField_size3xl":"TextField-module_textField_size3xl__y42Jf","textField_sizeStatic":"TextField-module_textField_sizeStatic__dPXG5","textField_sizeStaticsm":"TextField-module_textField_sizeStaticsm__3Mv34","textField_sizeStaticlg":"TextField-module_textField_sizeStaticlg__1Xzoa","textField_sizeStaticxl":"TextField-module_textField_sizeStaticxl__1N89P","textField_bold":"TextField-module_textField_bold__b5IS3","textField_marginBottom":"TextField-module_textField_marginBottom__1Z2gr","textField_roundedBorder":"TextField-module_textField_roundedBorder__Kaigy","textField__input":"TextField-module_textField__input__1cfno","textField__input_default":"TextField-module_textField__input_default__1Rq5i","textField__input_primary":"TextField-module_textField__input_primary__3MzHK","textField__input_secondary":"TextField-module_textField__input_secondary__MRNQp","textField__input_contrast":"TextField-module_textField__input_contrast__u5Qtg","textField__input_fullWidth":"TextField-module_textField__input_fullWidth__1E3sw","textField__input_fullHeight":"TextField-module_textField__input_fullHeight__ZmNaw","textField__input_full":"TextField-module_textField__input_full__1U5kZ","textField__input_multiline":"TextField-module_textField__input_multiline__aut_D","textField__input_border":"TextField-module_textField__input_border__3KO2S","textField__input_borderHasContent":"TextField-module_textField__input_borderHasContent__1XGAH","textField__input_borderError":"TextField-module_textField__input_borderError__2pmal","textField__input_roundedBorderSelect":"TextField-module_textField__input_roundedBorderSelect__3037N","textField__input_readOnly":"TextField-module_textField__input_readOnly__1At-0","textField__input_underline":"TextField-module_textField__input_underline__UV9lW","textField__input_disabled":"TextField-module_textField__input_disabled__1rHpB","textField__input_required":"TextField-module_textField__input_required__3n2fO","textField__input_error":"TextField-module_textField__input_error__2Da3X","textField__input_focused":"TextField-module_textField__input_focused__1Nuba","textField__input_underline-default":"TextField-module_textField__input_underline-default__1jpK1","textField__input_underline-defaultFilled":"TextField-module_textField__input_underline-defaultFilled__1raSw","disabled":"TextField-module_disabled__nGdOX","focused":"TextField-module_focused__3OJbn","error":"TextField-module_error__1J67e","required":"TextField-module_required__3YmdA","textField__input_underline-primary":"TextField-module_textField__input_underline-primary__J7N-W","textField__input_underline-primaryFilled":"TextField-module_textField__input_underline-primaryFilled__2t0ML","textField__input_underline-secondary":"TextField-module_textField__input_underline-secondary__2HEpx","textField__input_underline-secondaryFilled":"TextField-module_textField__input_underline-secondaryFilled__1HhiY","textField__input_underline-contrast":"TextField-module_textField__input_underline-contrast__2KK2M","textField__input_underline-contrastFilled":"TextField-module_textField__input_underline-contrastFilled__3uedR","textField__input_overFlow":"TextField-module_textField__input_overFlow__9hiUW","textField__input_inputTypeSearch":"TextField-module_textField__input_inputTypeSearch__1714L","textField__label":"TextField-module_textField__label__2xTmI","textField__label_default":"TextField-module_textField__label_default__2OaKv","textField__label_primary":"TextField-module_textField__label_primary__1c8yG","textField__label_secondary":"TextField-module_textField__label_secondary__1Z3GB","textField__label_contrast":"TextField-module_textField__label_contrast__2ywu3","textField__label_disabled":"TextField-module_textField__label_disabled__3_wEm","textField__label_error":"TextField-module_textField__label_error__244UX","textField__label_required":"TextField-module_textField__label_required__1Snti","textField__label_withAdornment":"TextField-module_textField__label_withAdornment__2qgWp","textField__label_shrink":"TextField-module_textField__label_shrink__1eMLT","textField__adornment_positionStart":"TextField-module_textField__adornment_positionStart__iP6KS","textField__adornment_positionEnd":"TextField-module_textField__adornment_positionEnd__1LOiY","textField_helper":"TextField-module_textField_helper__3hf88","textField_helper_default":"TextField-module_textField_helper_default__1vkEz","textField_helper_primary":"TextField-module_textField_helper_primary__3_czB","textField_helper_secondary":"TextField-module_textField_helper_secondary__3Awki","textField_helper_contrast":"TextField-module_textField_helper_contrast__v5Bs8","textField_helper_error":"TextField-module_textField_helper_error__3hyHx","textField_helper_disabled":"TextField-module_textField_helper_disabled__2eIYd"};
styleInject(css_248z$8,{"insertAt":"top"});

/** A simple text field control. Behaves similarly to an `<input>` element. */
function TextField(props) {
    var _a, _b, _c, _d, _e;
    const [inputRef, setInputRef] = useState(undefined);
    const [error, setError] = useState(false);
    const [value, setValue] = useState(props.value);
    const [displayRequiredText, setDisplayRequiredText] = useState(false);
    const [helperText, setHelperText] = useState(undefined);
    const [isOverflow, setIsOverflow] = useState(false);
    const clientWidth = (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.children[0]) === null || _a === void 0 ? void 0 : _a.clientWidth;
    const scrollWidth = (_b = inputRef === null || inputRef === void 0 ? void 0 : inputRef.children[0]) === null || _b === void 0 ? void 0 : _b.scrollWidth;
    const theme = useTheme(css$8);
    /* Function that sets the tooltip in case of a textoverflow */
    const setOverflow = useCallback(() => {
        // check if text is out-of-bounds.
        if (props.textOverflow && clientWidth && scrollWidth && clientWidth < scrollWidth) {
            setIsOverflow(true);
        }
        else {
            setIsOverflow(false);
        }
    }, [clientWidth, props === null || props === void 0 ? void 0 : props.textOverflow, scrollWidth]);
    /* Sets overflow tooltip once the component mounts */
    useEffect(() => {
        setOverflow();
    }, [inputRef, setOverflow]);
    const formatValue = useCallback((newValue, originalValue, allowMasked) => {
        const value = newValue !== null && newValue !== void 0 ? newValue : '';
        const keepDisplayingRequiredText = displayRequiredText && (value === null ||
            value === '' ||
            +value === -1);
        if (props.formatValue) {
            return props.formatValue(value, originalValue, !!props.required, props.locale, allowMasked);
        }
        return {
            value,
            error,
            helperText,
            displayRequiredText: keepDisplayingRequiredText,
            abortChange: false,
        };
    }, [displayRequiredText, error, helperText, props === null || props === void 0 ? void 0 : props.formatValue, props === null || props === void 0 ? void 0 : props.locale, props === null || props === void 0 ? void 0 : props.required]);
    const prevValue = useRef(value);
    useEffect(() => {
        const { error, helperText, displayRequiredText } = formatValue(value, prevValue.current, true);
        setError(error);
        setHelperText(helperText);
        setDisplayRequiredText(displayRequiredText);
        prevValue.current = value;
    }, [value, formatValue, props === null || props === void 0 ? void 0 : props.textOverflow]);
    /** Triggered when a field's value is changed. */
    const onChange = useCallback((event) => {
        const { value: newValue, error, displayRequiredText, abortChange, } = formatValue(event.target.value, value, false);
        const realValue = props.allowEmoji ? newValue : removeEmoji(newValue);
        setHelperText('');
        setDisplayRequiredText(displayRequiredText);
        if (!abortChange && value !== realValue) {
            setValue(realValue);
            setError(error);
            if (props.onChange) {
                props.onChange(props.id, realValue, error);
            }
        }
    }, [formatValue, props === null || props === void 0 ? void 0 : props.allowEmoji, props === null || props === void 0 ? void 0 : props.id, props === null || props === void 0 ? void 0 : props.onChange, value]);
    /** Triggered when a field loses focus. */
    const onBlur = useCallback((event) => {
        const value = event.target.value;
        setOverflow();
        if (props.onBlur) {
            props.onBlur(props.id, value, error);
        }
        if (props.required) {
            if ((value === '' || +value === -1) && !displayRequiredText) {
                setDisplayRequiredText(true);
            }
            else if (value !== '' && +value !== -1 && displayRequiredText) {
                setDisplayRequiredText(false);
            }
        }
    }, [displayRequiredText, error, props === null || props === void 0 ? void 0 : props.id, props === null || props === void 0 ? void 0 : props.onBlur, props === null || props === void 0 ? void 0 : props.required, setOverflow]);
    /** Triggered when a field gains focus. */
    const onFocus = useCallback((event) => {
        if (props.onFocus) {
            props.onFocus(props.id, event.target.value, error, event.currentTarget);
        }
    }, [error, props === null || props === void 0 ? void 0 : props.id, props === null || props === void 0 ? void 0 : props.onFocus]);
    const setFieldRef = useCallback((el) => {
        setInputRef(el);
        if (props.getFieldRef) {
            props.getFieldRef(el);
        }
    }, [props === null || props === void 0 ? void 0 : props.getFieldRef]);
    const showError = error || displayRequiredText || (props === null || props === void 0 ? void 0 : props.error);
    let fieldSize = props.size;
    let rowCount = props.rows;
    let multiline = props.multiline;
    if (props.adjustSize) {
        if (props.value.toString().length < 7) {
            fieldSize = 'sm';
        }
        else if (props.value.toString().length < 18) {
            fieldSize = 'md';
        }
        else if (props.value.toString().length < 26) {
            fieldSize = 'lg';
        }
        else if (props.value.toString().length < 37) {
            fieldSize = 'xl';
        }
        else if (props.value.toString().length < 51) {
            fieldSize = 'xxl';
        }
    }
    if (!multiline && props.adjustRowCount) {
        if (fieldSize === 'sm' && props.value.toString().length > 5) {
            rowCount = Math.ceil(props.value.toString().length / 5);
            multiline = true;
        }
        else if (fieldSize === 'md' && props.value.toString().length >= 15) {
            rowCount = Math.ceil(props.value.toString().length / 15);
            multiline = true;
        }
        else if (fieldSize === 'lg' && props.value.toString().length >= 20) {
            rowCount = Math.ceil(props.value.toString().length / 20);
            multiline = true;
        }
        else if (fieldSize === 'xl' && props.value.toString().length >= 30) {
            rowCount = Math.ceil(props.value.toString().length / 30);
            multiline = true;
        }
        else if (fieldSize === 'xxl' && props.value.toString().length >= 40) {
            rowCount = Math.ceil(props.value.toString().length / 40);
            multiline = true;
        }
    }
    const endAdornmentClasses = useMuiClasses(theme, 'textField__adornment', {
        positionEnd: 'positionEnd',
    });
    const [mask, displayValue, endAdornment, fieldBlur, fieldChange] = useMemo(() => {
        var _a;
        if (!props.disableMask && props.getMask) {
            const maskResult = props.getMask(value);
            const mask = maskResult.mask;
            const displayValue = (_a = maskResult.displayValue) !== null && _a !== void 0 ? _a : value;
            const endAdornment = maskResult.endAdornment ? (React__default.createElement(InputAdornment, { classes: endAdornmentClasses, position: 'end' }, maskResult.endAdornment)) : undefined;
            const fieldBlur = maskResult.shiftBlurChange ? onChange : onBlur;
            const fieldChange = maskResult.shiftBlurChange ? undefined : onChange;
            return [mask, displayValue, endAdornment, fieldBlur, fieldChange];
        }
        else {
            return [undefined, value, undefined, onBlur, onChange];
        }
    }, [props === null || props === void 0 ? void 0 : props.disableMask, props === null || props === void 0 ? void 0 : props.getMask, value, endAdornmentClasses, onChange, onBlur]);
    const formatOverflow = (!!props.textOverflow && !!isOverflow);
    /** Function to update the field ref. */
    const getFieldRef = useCallback((el) => {
        if (el === null || el === void 0 ? void 0 : el.parentElement) {
            setFieldRef(el.parentElement);
        }
        else {
            setFieldRef(undefined);
        }
    }, [setFieldRef]);
    // Setup default values.
    const helperTextId = (props.helperText || (helperText && displayValue)) ? `${displayValue}-helper-text` : undefined;
    const readOnly = props.readOnly && !props.disabled;
    const required = props.required && props.value === '' && !props.disabled;
    const errorAndNotDisabled = showError && !props.disabled;
    const size = fieldSize !== null && fieldSize !== void 0 ? fieldSize : 'auto';
    const fullWidth = (size === 'full' || size === 'fullWidth');
    const fullHeight = (size === 'fullHeight' || props.multiline);
    // Get custom colors.
    const textColor = (_c = props.textColor) !== null && _c !== void 0 ? _c : 'default';
    const labelColor = textColor;
    const underlineColor = props.value === '' ?
        textColor :
        `${textColor}Filled`;
    const helperColor = `helperColor${textColor.charAt(0).toUpperCase() + textColor.slice(1)}`;
    const resolvedHelperText = (_e = (_d = props.helperText) !== null && _d !== void 0 ? _d : helperText) !== null && _e !== void 0 ? _e : (errorAndNotDisabled ?
        required ?
            'Required' :
            'Invalid Value' :
        undefined);
    // Label overrides.
    const label = props.label ?
        (React__default.createElement(Literal, { text: props.label, variant: props.disabled && props.value === '' ? 'disabled' : undefined, overflowTooltip: true, required: required })) :
        null;
    const labelClassName = useClassNames(theme, 'textField__label', [
        !props.disableEndAdornmentLabelStyling && props.label && !!endAdornment && 'withAdornment',
    ], true);
    const labelProps = {
        classes: useMuiClasses(theme, 'textField__label', {
            root: [
                labelColor,
                required && 'required',
            ],
            shrink: 'shrink',
            error: 'error',
            focused: 'focused',
            disabled: 'disabled',
        }),
        className: labelClassName,
        required: false,
        htmlFor: props.id,
        shrink: props.raisedLabel,
        disabled: props.disabled && !props.readOnly && props.value === '',
    };
    const startAdornmentClasses = useMuiClasses(theme, 'textField__adornment', {
        positionStart: 'positionStart',
    });
    const startAdornment = props.startAdornment ?
        (React__default.createElement(InputAdornment, { classes: startAdornmentClasses, position: 'start' }, props.startAdornment)) :
        null;
    const formHelperTextProps = {
        classes: useMuiClasses(theme, 'textField__helper', {
            root: helperColor,
            error: 'error',
        }),
    };
    const borderClass = showError ? 'borderError' : props.value ? 'borderHasContent' : 'border';
    const inputProps = {
        classes: useMuiClasses(theme, 'textField__input', {
            root: [
                textColor,
                fieldSize === 'fullWidth' && 'fullWidth',
                fieldSize === 'full' && 'full',
                props.border && borderClass,
                props.roundedBorder && 'roundedBorderSelect',
                fullHeight && 'fullHeight',
                props.multiline && 'multiline',
            ],
            error: 'error',
            disabled: readOnly ? 'readOnly' : 'disabled',
            focused: 'focused',
            underline: [
                'underline',
                `underline-${underlineColor}`,
                required && 'required',
            ],
            input: formatOverflow && 'overFlow',
            inputTypeSearch: 'inputTypeSearch',
        }),
        startAdornment: startAdornment,
        endAdornment: endAdornment,
        inputComponent: mask,
        disableUnderline: props.disableUnderline,
        readOnly: readOnly,
    };
    const autoComplete = props.useAutocomplete ? 'on' : 'off';
    const className = useClassNames(theme, 'textField', [
        required && 'required',
        fullWidth && 'fullWidth',
        !fullWidth && size !== 'auto' && `size${size.charAt(0).toUpperCase() + size.slice(1)}`,
        props.variant,
    ]);
    let control = (React__default.createElement("div", { id: props === null || props === void 0 ? void 0 : props.id },
        React__default.createElement(MuiTextField__default, { inputRef: getFieldRef, className: className, autoComplete: autoComplete, autoFocus: props.autoFocus, "aria-describedby": helperTextId, id: `${props.id}_input`, value: props.value, defaultValue: props.defaultValue, label: label, onChange: fieldChange, onBlur: fieldBlur, onFocus: onFocus, onKeyPress: props.onKeyPress, required: required, disabled: props.disabled, error: errorAndNotDisabled, helperText: resolvedHelperText, placeholder: props.hint, fullWidth: fullWidth, type: props.type, multiline: props.multiline, rows: rowCount, rowsMax: props.rowsMax, InputLabelProps: labelProps, InputProps: inputProps, FormHelperTextProps: formHelperTextProps })));
    // display with tooltip if read only and overflowing
    if (isOverflow && (props.textOverflow || (props.readOnly && !props.multiline))) {
        control = (React__default.createElement(Tooltip, { text: displayValue ? displayValue.toString() : '' },
            React__default.createElement("span", null, control)));
    }
    return control;
}
function removeEmoji(str) {
    // eslint-disable-next-line max-len
    const value = str.replace(/([\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|[\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|[\ud83c[\ude32-\ude3a]|[\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g, '');
    return value;
}

function CurrencyField(props) {
    const value = props.value !== undefined && props.value !== '' ? props.value : '';
    const [fieldValue, setFieldValue] = useState(value);
    const [errorText, setErrorText] = useState('');
    const [hasError, setHasError] = useState(false);
    const onChangeHandler = React__default.useCallback((id, value) => {
        const hasError = errorText === '' ? false : true;
        setFieldValue(value);
        if (props.onChange) {
            props.onChange(id, value, hasError);
        }
    }, [errorText, props === null || props === void 0 ? void 0 : props.onChange]);
    /**
     * Formats the input according to the name that is passed in.
     * @param props
     */
    const MaskedFormat = React__default.useCallback((inputProps) => (React__default.createElement(MaskedInput, Object.assign({}, inputProps, { mask: createNumberMask({
            prefix: GetCurrencySymbol(props.locale), allowDecimal: true,
        }), placeholderChar: '\u2000', guide: true }))), [props === null || props === void 0 ? void 0 : props.locale]);
    const getMask = React__default.useCallback(() => ({ mask: MaskedFormat }), [MaskedFormat]);
    const onBlurHandler = React__default.useCallback((id, value) => {
        let errorFlag = false;
        let errorMsg = '';
        let newvalue = value;
        if (props.required) {
            if (((newvalue !== null && newvalue !== void 0 ? newvalue : '') === '' || +newvalue === -1)) {
                errorFlag = true;
                errorMsg = 'Field is required';
            }
            else if ((newvalue !== null && newvalue !== void 0 ? newvalue : '') !== '' && +newvalue !== -1) {
                errorFlag = false;
                errorMsg = '';
            }
        }
        if (!newvalue.toString().match(/.*\.\d\d/) && !newvalue.toString().includes('.')) {
            newvalue = newvalue + '.00';
            setFieldValue(newvalue);
            if (props.onChange) {
                props.onChange(props.id, newvalue, errorFlag);
            }
        }
        else if (newvalue.toString().match(/.*\.\d$/)) {
            newvalue = newvalue + '0';
            setFieldValue(newvalue);
            if (props.onChange) {
                props.onChange(props.id, newvalue, errorFlag);
            }
        }
        setErrorText(errorMsg);
        setHasError(errorFlag);
        props.onBlur(id, value, errorFlag);
    }, [props === null || props === void 0 ? void 0 : props.id, props === null || props === void 0 ? void 0 : props.onBlur, props === null || props === void 0 ? void 0 : props.onChange, props === null || props === void 0 ? void 0 : props.required]);
    return (React__default.createElement(TextField, { getMask: getMask, id: props.id, value: fieldValue, label: props.label, onChange: onChangeHandler, type: 'text', helperText: errorText, error: hasError, onBlur: onBlurHandler, readOnly: props.readOnly }));
}

// Regex used to validated the email address contains an @ and a .ab
// eslint-disable-next-line max-len
const emailRegex = new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
const specCharRegex = new RegExp(/[!#$%^&()=?/<>,|`]/g);
function EmailField(props) {
    const size = props.size !== undefined ? props.size : 'md';
    const [errorText, setErrorText] = useState('');
    const [hasError, setHasError] = useState(false);
    const onChangeHandler = useCallback((id, value) => {
        //
        const hasError = errorText === '' ? false : true;
        props.onChange(id, value, hasError);
    }, [props.onChange, errorText]);
    const onBlurHandler = useCallback((id, value) => {
        // Valid the email is in the correct format.  Must contains @ and a .
        let errorFlag = false;
        let maxLength = 255;
        let errorMsg = '';
        if (props === null || props === void 0 ? void 0 : props.maxLength) {
            maxLength = props.maxLength;
        }
        if (value !== '') {
            errorFlag = value.match(emailRegex) === null ? true : false;
            if (errorFlag) {
                // eslint-disable-next-line max-len
                errorMsg = 'Please enter a valid email address. A valid email address should include a username, domain, and a top-level domain. Example: johndoe@domain.com';
            }
            else {
                if (value.length > maxLength) {
                    errorFlag = true;
                    errorMsg = 'Email address cannot be longer than ' + maxLength + ' characters.';
                }
                if (!errorFlag) {
                    errorFlag = value.match(specCharRegex) === null ? false : true;
                    if (errorFlag) {
                        // eslint-disable-next-line max-len
                        errorMsg = 'Please enter a valid email address. A valid email address should include a username, domain, and a top-level domain. Example: johndoe@domain.com';
                    }
                }
            }
        }
        else {
            if (props.required) {
                errorFlag = true;
                errorMsg = 'No email address entered, please type in your email address.';
            }
        }
        setErrorText(errorMsg);
        setHasError(errorFlag);
        if (props.onBlur) {
            props.onBlur(id, value, errorFlag);
        }
    }, [props === null || props === void 0 ? void 0 : props.maxLength, props === null || props === void 0 ? void 0 : props.onBlur, props === null || props === void 0 ? void 0 : props.required]);
    // const autofill = useCallback((event: any) => {
    //     if (event.target.value !== '' &&
    //         (event.target.id === 'email' || event.target.id === 'email_input') &&
    //         event.inputType === undefined &&
    //         event.data === undefined &&
    //         event.dataTransfer === undefined &&
    //         event.isComposing === undefined) {
    //         onBlurHandler(event.target.id, event.target.value);
    //     }
    // }, [onBlurHandler]);
    // useEffect(() => {
    //     window.addEventListener('input', autofill);
    //     return () => {
    //         window.removeEventListener('input', autofill);
    //     };
    // }, [autofill]);
    return (React__default.createElement(TextField, { id: props.id, 
        // getMask={getMask}
        value: props.value, label: props.label, onChange: onChangeHandler, onBlur: onBlurHandler, onKeyPress: props.onKeyPress, type: 'email', helperText: errorText, error: hasError, disabled: props === null || props === void 0 ? void 0 : props.disabled, readOnly: props === null || props === void 0 ? void 0 : props.readOnly, size: size, required: props === null || props === void 0 ? void 0 : props.required }));
}

/** Wraps the children in a animated container that applies a transition with the child is displayed. */
class FadeAndSlideTransition extends Component {
    constructor() {
        /** Ref to the transition element. */
        // private transition: Transition = null;
        super(...arguments);
        /** Indicates that the component is mounted. */
        this.mounted = false;
        /** Function to handle the enter state of the transition. */
        this.onEnter = (node) => {
            if (node) {
                reflow(node);
                if (this.props.zIndex > 1) {
                    const child = getChild(node);
                    if (child) {
                        child.style.webkitTransform = 'translateX(100%)';
                        child.style.transform = 'translateX(100%)';
                    }
                }
            }
        };
        /** Function to handle the entering state of the transition. */
        this.onEntering = (node) => {
            if (node) {
                const child = getChild(node);
                if (child) {
                    child.style.webkitTransition = `-webkit-transform ${this.props.timeout.enter}ms linear`;
                    child.style.transition = `transform ${this.props.timeout.enter}ms linear`;
                    child.style.webkitTransform = 'translate(0, 0)';
                    child.style.transform = 'translate(0, 0)';
                }
            }
        };
        /** Function to handle the exit stated of the transition. */
        this.onExit = (node) => {
            if (node) {
                const child = getChild(node);
                if (child) {
                    child.style.webkitTransition = `-webkit-transform ${this.props.timeout.exit}ms linear`;
                    child.style.transition = `transform ${this.props.timeout.exit}ms linear`;
                    child.style.webkitTransform = 'translateX(100%)';
                    child.style.transform = 'translateX(100%)';
                }
            }
        };
        /** Function to handle the exited state of the transition. */
        this.onExited = (node) => {
            if (node) {
                const child = getChild(node);
                if (child) {
                    // No need for transitions when the component is hidden
                    child.style.webkitTransition = '';
                    child.style.transition = '';
                    node.style.transition = '';
                }
            }
        };
        /** Function to handle the enter state of the top pane transition. */
        this.onPaneEnter = (node) => {
            reflow(node);
            node.style.webkitTransition = `opacity 100ms linear`;
            node.style.transition = `opacity 100ms linear`;
            node.style.opacity = '1';
            node.style.opacity = '1';
            node.style.visibility = 'inherit';
            node.style.maxHeight = null;
            node.style.overflow = null;
        };
        /** Function to handle the exit state of the top pane transition. */
        this.onPaneExit = (node) => {
            node.style.webkitTransition = `opacity 500ms linear`;
            node.style.transition = `opacity 500ms linear`;
            node.style.opacity = '0';
            node.style.opacity = '0';
            node.style.visibility = 'hidden';
            node.style.maxHeight = '100px';
            node.style.overflow = 'hidden';
        };
    }
    componentDidMount() {
        this.mounted = true;
    }
    render() {
        // Set the default style fot he transition.
        const style = {};
        style.margin = -3;
        style.width = 'calc(100% + 6px)';
        style.overflow = 'hidden';
        if (!this.props.in && !this.mounted) {
            style.visibility = 'hidden';
        }
        return (createElement(Transition, { in: (this.props.isTop && this.props.in), appear: true, onEnter: this.onPaneEnter, onExit: this.onPaneExit, mountOnEnter: true, unmountOnExit: (this.props.zIndex > 1 && !this.props.in), timeout: { enter: 500, exit: 500 } },
            createElement(Pane, { zIndex: this.props.zIndex },
                createElement(Transition, { in: this.props.in, onEnter: this.onEnter, onEntering: this.onEntering, onExit: this.onExit, onExited: this.onExited, mountOnEnter: true, appear: true, timeout: this.props.timeout, 
                    // ref={(node) => { this.transition = node; }}
                    style: style },
                    createElement("div", null, this.props.children)))));
    }
}
/** Wrapper pane to position the component properly. */
const Pane = (props) => (createElement("div", { style: {
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: props.zIndex,
        width: '100%',
        paddingBottom: '24px',
    } }, props.children));
/** Repositions the pane. */
const reflow = (node) => node.scrollTop;
/** Returns the first child element for the node. */
function getChild(node) {
    if (node.children.length > 0) {
        return node.firstChild;
    }
    return null;
}

/** Custom styles for the Collapse control. */
const styles$1 = createStyles({
    entered: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
    },
    wrapper: {
        flex: 1,
    },
    wrapperInner: {
        display: 'flex',
        flexDirection: 'column',
    },
});
/** Builds a collapsible container around the given elements. */
const Grow = withStyles(styles$1)((props) => (createElement(muiGrow__default, { style: props.style, in: props.onHover, timeout: !!props.timeout ? props.timeout : 'auto', onEntered: (props.onEntered) ? props.onEntered : undefined }, props.children)));

var css_248z$9 = ".Label-module_label__eeDiH {\n  font-family: inherit;\n  font-size: 1rem;\n  width: inherit;\n  display: inline-flex;\n  opacity: 0.73;\n}";
var css$9 = {"label":"Label-module_label__eeDiH"};
styleInject(css_248z$9,{"insertAt":"top"});

const Label = memo((props) => {
    const theme = useTheme(css$9);
    return (createElement(InputLabel, { className: theme.label },
        createElement(Literal, { text: props.text })));
});

// Basic Framework.
/** Displays a Circular Progress Indicator. */
const LinearProgress = memo((props) => {
    // Setup defaults
    const value = props.value ? props.value : 0;
    const buffer = props.buffer ? props.buffer : 0;
    const type = props.type ? props.type : 'indeterminate';
    const color = (props.color !== undefined) ? props.color : 'default';
    const barColor = `color${color.charAt(0).toUpperCase() + color.slice(1)}`;
    const height = (props.height && props.height > 0) ? `${props.height}px` : '5px';
    const theme = useTheme(css$6);
    // Apply default class name and class Size
    const classNames = `${theme.linearProgress} ` + theme[`color${color.charAt(0).toUpperCase() + color.slice(1)}`];
    return (createElement(muiLinearProgress__default, { className: classNames, classes: {
            barColorPrimary: props.classes[barColor],
        }, style: { height: height }, color: 'primary', value: value, valueBuffer: buffer, variant: type }));
});

var css_248z$a = ".Link-module_link__2dMyg {\n  display: inline-flex;\n  padding: 0.25rem 0.5rem 0.25rem 0.5rem;\n}\n.Link-module_link__label__1VMBo {\n  font-family: inherit;\n  font-size: 0.86rem;\n  padding: 0;\n  transform: translate(0, 1.5px);\n  width: inherit;\n  opacity: 0.73;\n}\n.Link-module_link_input__1lN_e {\n  font: inherit;\n  width: 100%;\n  padding: 6px 0 7px;\n  display: block;\n  min-width: 0;\n  box-sizing: content-box;\n}\n.Link-module_link__inputBase__hsGOr {\n  padding: 0;\n  font-size: 1rem;\n  font-family: inherit;\n  transform: translate(0, 1.5px);\n}\n.Link-module_link__form__3n7v1 {\n  text-align: initial;\n  margin: 0;\n  border: 0;\n  display: inline-flex;\n  padding: 0;\n  position: relative;\n  min-width: 0;\n  flex-direction: column;\n  vertical-align: top;\n}\n.Link-module_link_disabled__2cQS2 {\n  cursor: default;\n}";
var css$a = {"link":"Link-module_link__2dMyg","link__label":"Link-module_link__label__1VMBo","link_input":"Link-module_link_input__1lN_e","link__inputBase":"Link-module_link__inputBase__hsGOr","link__form":"Link-module_link__form__3n7v1","link_disabled":"Link-module_link_disabled__2cQS2"};
styleInject(css_248z$a,{"insertAt":"top"});

const Link = memo((props) => {
    /** Triggered when the close action is performed. */
    const onClick = useCallback(() => {
        if (props.disabled) {
            return;
        }
        if (!!props.onClick) {
            props.onClick();
        }
        else {
            window.open(props.url, '_blank', 'width=910,height=660,menubar=no,toolbar=no');
        }
    }, [props === null || props === void 0 ? void 0 : props.disabled, props === null || props === void 0 ? void 0 : props.onClick, props === null || props === void 0 ? void 0 : props.url]);
    const theme = useTheme(css$a);
    const classNames = useClassNames(theme, 'link', [
        'input',
        props.disabled ? 'disabled' : undefined,
    ]) + (props.className ? ' ' + props.className : '');
    let content = (createElement("a", { id: props.id, onClick: onClick, className: classNames }, props.children));
    if (props.label && props.label.length > 0) {
        content = (createElement("div", { className: theme.link },
            createElement("div", { className: theme['link__form'] },
                createElement(InputLabel, { className: theme['link__label'] },
                    createElement(Literal, { text: props.label })),
                createElement("div", { className: theme['link__inputBase'] }, content))));
    }
    return content;
});

var css_248z$b = ".LoadingProgress-module_loadingProgress__MQ_p6 {\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  top: 0;\n  left: 0;\n  z-index: 1000;\n}\n.LoadingProgress-module_loadingProgress_modalContainer__3SzDO {\n  position: relative;\n}\n.LoadingProgress-module_loadingProgress__background__2vEBB {\n  z-index: -1;\n  background: black;\n  opacity: 0.2;\n  height: 100%;\n  width: 100%;\n}\n.LoadingProgress-module_loadingProgress__spinner__1JBVX {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n}";
var css$b = {"loadingProgress":"LoadingProgress-module_loadingProgress__MQ_p6","loadingProgress_modalContainer":"LoadingProgress-module_loadingProgress_modalContainer__3SzDO","loadingProgress__background":"LoadingProgress-module_loadingProgress__background__2vEBB","loadingProgress__spinner":"LoadingProgress-module_loadingProgress__spinner__1JBVX"};
styleInject(css_248z$b,{"insertAt":"top"});

/** This component automates displaying a loading animation and optional dark background. */
const LoadingProgress = memo((props) => {
    var _a;
    const { container, background, spinner } = (_a = props.cssClasses) !== null && _a !== void 0 ? _a : {};
    const theme = useTheme(css$b);
    const classNames = useClassNames(theme, 'loadingProgress', [
        props.modal ? 'modalContainer' : undefined,
    ]);
    // Apply default class name and class Size
    let backGround = background;
    if (props.showBackground) {
        backGround = backGround + ` ` + theme[`loadingProgress__background`];
    }
    return (createElement("div", { className: classNames },
        createElement("div", { className: backGround }),
        createElement("div", { className: spinner + ` ` + css$b[`loadingProgress__spinner`] },
            createElement(CircularProgress, { size: props.size, type: 'indeterminate' }))));
});

function NumberField(props) {
    const [errorText, setErrorText] = useState('');
    const [hasError, setHasError] = useState(false);
    const onChangeHandler = useCallback((id, value) => {
        var _a, _b;
        const hasError = errorText === '' ? false : true;
        const tempValue = numberFormat(value, !props.excludeCommas, ',', props.decimal, '.', ((_a = props.maxDecimals) !== null && _a !== void 0 ? _a : 2), props.decimal, false, false, ((_b = props.maxInteger) !== null && _b !== void 0 ? _b : 7));
        if (props.onChange) {
            props.onChange(id, tempValue, hasError);
        }
    }, [errorText, props]);
    const onBlurHandler = useCallback((id, value) => {
        let errorFlag = false;
        let errorMsg = '';
        if (props.required) {
            if (((value !== null && value !== void 0 ? value : '') === '' || +value === -1)) {
                errorFlag = true;
                errorMsg = 'Field is required';
            }
            else if ((value !== null && value !== void 0 ? value : '') !== '' && +value !== -1) {
                errorFlag = false;
            }
        }
        setErrorText(errorMsg);
        setHasError(errorFlag);
        if (props.onBlur) {
            props.onBlur(id, value, errorFlag);
        }
    }, [props === null || props === void 0 ? void 0 : props.onBlur, props === null || props === void 0 ? void 0 : props.required]);
    return (React__default.createElement(TextField, { id: props.id, value: props.value, label: props.label, onChange: onChangeHandler, type: 'text', helperText: errorText, error: hasError, onBlur: onBlurHandler, readOnly: props.readOnly, disabled: props.disabled }));
}
function numberFormat(rawValue = '', includeThousandsSeparator = true, thousandsSeparatorSymbol = ',', allowDecimal = false, decimalSymbol = '.', decimalLimit = 2, requireDecimal = false, allowNegative = false, allowLeadingZeroes = false, integerLimit = null) {
    const thousandsSeparatorSymbolLength = (thousandsSeparatorSymbol && thousandsSeparatorSymbol.length) || 0;
    const nonDigitsRegExp = /\D+/g;
    const rawValueLength = rawValue.length;
    let tempValue = rawValue;
    const isNegative = (tempValue[0] === '-') && allowNegative;
    // If negative remove "-" sign
    if (isNegative) {
        tempValue = tempValue.toString().substr(1);
    }
    const indexOfLastDecimal = tempValue.lastIndexOf(decimalSymbol);
    const hasDecimal = indexOfLastDecimal !== -1;
    let integer;
    // let fraction;
    // let mask;
    if (hasDecimal && (allowDecimal || requireDecimal)) {
        // integer = tempValue.slice(tempValue.slice(0, prefixLength) === prefix ? prefixLength : 0, indexOfLastDecimal);
        integer = tempValue.slice(indexOfLastDecimal + 1, rawValueLength);
    }
    else {
        // if (tempValue.slice(0, prefixLength) === prefix) {
        //     integer = tempValue.slice(prefixLength);
        // } else {
        integer = tempValue;
        // }
    }
    if (integerLimit && typeof integerLimit === 'number') {
        const thousandsSeparatorRegex = thousandsSeparatorSymbol === '.' ? '[.]' : `${thousandsSeparatorSymbol}`;
        const numberOfThousandSeparators = (integer.match(new RegExp(thousandsSeparatorRegex, 'g')) || []).length;
        integer = integer.slice(0, integerLimit + (numberOfThousandSeparators * thousandsSeparatorSymbolLength));
    }
    integer = integer.replace(nonDigitsRegExp, '');
    if (!allowLeadingZeroes) {
        integer = integer.replace(/^0+(0$|[^0])/, '$1');
    }
    integer = (includeThousandsSeparator) ? addThousandsSeparator(integer, thousandsSeparatorSymbol) : integer;
    return integer;
}
// http://stackoverflow.com/a/10899795/604296
function addThousandsSeparator(n, thousandsSeparatorSymbol) {
    return n.replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparatorSymbol);
}

var css_248z$c = ".Paper-module_paper__3oKNG {\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n.Paper-module_paper_rounded__A88hg {\n  border-radius: 3px;\n}\n.Paper-module_paper_rounded__A88hg .buttonGroup.primaryButtonGroup {\n  border-radius: 0 0 8px 0;\n}\n.Paper-module_paper_rounded__A88hg .buttonGroup.primaryButtonGroup button.primaryButton {\n  border-radius: 0 0 3px 0;\n}\n.Paper-module_paper_roundedRight__364AP {\n  border-radius: 10px 10px 22px 10px;\n}\n.Paper-module_paper_roundedRight__364AP .buttonGroup.primaryButtonGroup {\n  border-radius: 0 0 27px 0;\n}\n.Paper-module_paper_roundedRight__364AP .buttonGroup.primaryButtonGroup button.primaryButton {\n  border-radius: 0 0 22px 0;\n}\n.Paper-module_paper_roundedLeft__3GI9U {\n  border-radius: 10px 10px 10px 22px;\n}\n.Paper-module_paper_roundedLeft__3GI9U .buttonGroup.primaryButtonGroup {\n  border-radius: 0 0 15px 0;\n}\n.Paper-module_paper_roundedLeft__3GI9U .buttonGroup.primaryButtonGroup button.primaryButton {\n  border-radius: 0 0 10px 0;\n}\n.Paper-module_paper_topRightUnrounded__HPPBe {\n  border-radius: 3px 0 3px 3px;\n}\n.Paper-module_paper_topRightUnrounded__HPPBe .buttonGroup.primaryButtonGroup {\n  border-radius: 0 0 8px 0;\n}\n.Paper-module_paper_topRightUnrounded__HPPBe .buttonGroup.primaryButtonGroup button.primaryButton {\n  border-radius: 0 0 3px 0;\n}\n.Paper-module_paper_minimalBoxShadow__2_lqd {\n  box-shadow: 1px 1px 1px 0 rgba(0, 0, 0, 0.4);\n}\n.Paper-module_paper_circle__1brZP {\n  border-radius: 50%;\n}\n.Paper-module_paper_contentsOnly__8dEO4 {\n  display: contents;\n}";
var css$c = {"paper":"Paper-module_paper__3oKNG","paper_rounded":"Paper-module_paper_rounded__A88hg","paper_roundedRight":"Paper-module_paper_roundedRight__364AP","paper_roundedLeft":"Paper-module_paper_roundedLeft__3GI9U","paper_topRightUnrounded":"Paper-module_paper_topRightUnrounded__HPPBe","paper_minimalBoxShadow":"Paper-module_paper_minimalBoxShadow__2_lqd","paper_circle":"Paper-module_paper_circle__1brZP","paper_contentsOnly":"Paper-module_paper_contentsOnly__8dEO4"};
styleInject(css_248z$c,{"insertAt":"top"});

/** Builds a canvas to hold elements that can be elevated on its parent. */
const Paper = memo((props) => {
    const shape = props.shape ? props.shape : 'round';
    const elevation = props.minimalBoxShadow ? 0 : props.elevation >= 0 ? props.elevation : 4;
    const theme = useTheme(css$c);
    const classNames = useClassNames(theme, 'paper', [
        props.shape || 'round',
        props.minimalBoxShadow ? 'minimalBoxShadow' : undefined,
        props.variant,
    ]);
    const paperSize = props.size ? `${props.size}px` : null;
    return (createElement(muiPaper__default, { className: classNames, elevation: elevation, square: shape === 'square', style: { width: paperSize, height: paperSize }, ref: props.forwardRef }, props.children));
});

// The acceptable Special Characters in a password where accepted
const specialChars = ['!', '"', '#', '$', '%', '&', '\'', '(', ')', '*', '+', ',', '-', '.', '/', ':', ';',
    '<', '=', '>', '?', '@', '[', '\\', ']', '^', '_', '`', '{', '|', '}', '~'];
function PasswordField(props) {
    const size = props.size !== undefined ? props.size : 'md';
    const [errorText, setErrorText] = useState('');
    const [hasError, setHasError] = useState(false);
    const [capsLock, setCapsLock] = useState(false);
    const capsLockActivated = useCallback((event) => {
        if (event.key === 'CapsLock') {
            setCapsLock(!capsLock);
        }
    }, [capsLock]);
    useEffect(() => {
        window.addEventListener('keydown', capsLockActivated);
        return () => {
            window.removeEventListener('keydown', capsLockActivated);
        };
    }, [capsLockActivated]);
    useEffect(() => {
        if (props.error) {
            setHasError(props.error);
            setErrorText(props.helperText);
        }
        if (capsLock) {
            setHasError(true);
            setErrorText('Caps lock is turned on');
        }
        else {
            setHasError(false);
            setErrorText('');
        }
    }, [props === null || props === void 0 ? void 0 : props.error, props === null || props === void 0 ? void 0 : props.helperText, capsLock]);
    const onChangeHandler = useCallback((id, value) => {
        const hasError = errorText === '' ? false : true;
        props.onChange(id, value, hasError);
    }, [props.onChange, errorText]);
    const onBlurHandler = useCallback((id, value) => {
        let errorFlag = false;
        let errorMsg = '';
        // First check for password length.  Check against min and max length
        if (value && value !== '') {
            if (value.length < props.minLength || value.length > props.maxLength) {
                errorFlag = true;
                errorMsg = 'Password must be between ' + props.minLength + ' and ' + props.maxLength + ' characters.';
            }
            if (!errorFlag) {
                if (props.reqNumbers) {
                    errorFlag = value.match(/[0-9]/) === null ? true : false;
                }
                if (!errorFlag && props.reqSpecChar) {
                    const specChar = specialChars.join('|\\');
                    errorFlag = value.match(specChar) === null ? true : false;
                }
                if (errorFlag) {
                    if (props.reqNumbers && props.reqSpecChar) {
                        errorMsg = 'Password must contain at least one number and one special ( ' +
                            specialChars.toString() + ' ) character.';
                    }
                    if (props.reqNumbers && !props.reqSpecChar) {
                        errorMsg = 'Password must contain at least one number.';
                    }
                    if (props.reqSpecChar && !props.reqNumbers) {
                        errorMsg = 'Password must contain at least one specail ( ' +
                            specialChars.toString() + ' ) character.';
                    }
                }
            }
        }
        setErrorText(errorMsg);
        setHasError(errorFlag);
        setCapsLock(false);
        if (props.onBlur) {
            props.onBlur(id, value, errorFlag);
        }
    }, [props.minLength, props.maxLength, props === null || props === void 0 ? void 0 : props.reqNumbers, props === null || props === void 0 ? void 0 : props.reqSpecChar, props === null || props === void 0 ? void 0 : props.onBlur]);
    // const autofill = useCallback((event: any) => {
    //     if (event.target.value !== '' &&
    //         (event.target.id === 'password' || event.target.id === 'password_input') &&
    //         event.inputType === undefined &&
    //         event.data === undefined &&
    //         event.dataTransfer === undefined &&
    //         event.isComposing === undefined) {
    //         onBlurHandler(event.target.id, event.target.value);
    //     }
    // }, [onBlurHandler]);
    // useEffect(() => {
    //     window.addEventListener('DOM', autofill);
    //     return () => {
    //         window.removeEventListener('input', autofill);
    //     };
    // }, [autofill]);
    return (React__default.createElement(TextField, { id: props.id, value: props.value, label: props.label, onChange: onChangeHandler, onBlur: onBlurHandler, onKeyPress: props.onKeyPress, type: 'password', helperText: errorText, error: hasError, disabled: props === null || props === void 0 ? void 0 : props.disabled, readOnly: props === null || props === void 0 ? void 0 : props.readOnly, size: size, useAutocomplete: props.useAutoComplete ? props.useAutoComplete : false }));
}

function PhoneField(props) {
    const size = props.size !== undefined ? props.size : 'md';
    const [errorText, setErrorText] = useState('');
    const [hasError, setHasError] = useState(false);
    const onChangeHandler = useCallback((id, value) => {
        //
        const hasError = errorText === '' ? false : true;
        const tempValue = value.toString().replace(/[^0-9]/g, '');
        props.onChange(id, tempValue, hasError);
    }, [props.onChange, errorText]);
    // const MaskedFormat = useCallback((inputProps: InputBaseComponentProps) => {
    //     const mask: maskArray =
    //         ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    //     return (
    //         <MaskedInput
    //             {...inputProps}
    //             mask={mask}
    //             placeholderChar={'\u2000'}
    //             guide
    //         />
    //     );
    // }, []);
    // const getMask = useCallback(() => ({ mask: MaskedFormat }), [MaskedFormat]);
    const onBlurHandler = useCallback((id, value) => {
        // Valid the email is in the correct format.  Must contains @ and a .
        let errorFlag = false;
        let errorMsg = '';
        const tempValue = value.replace(/\D/g, '');
        if (tempValue !== '') {
            if (tempValue.length !== 10) {
                errorFlag = true;
                errorMsg = 'Please enter a valid 10-digit phone number.  XXX-XXX-XXXX';
            }
            if (!errorFlag) {
                const isNumeric = tempValue.match(/[0-9]/) === null ? false : true;
                if (!isNumeric) {
                    errorFlag = true;
                    errorMsg = 'Phone number must contain numeric values only';
                }
            }
        }
        setErrorText(errorMsg);
        setHasError(errorFlag);
        if (props.onBlur) {
            props.onBlur(id, tempValue, errorFlag);
        }
    }, [props === null || props === void 0 ? void 0 : props.onBlur]);
    return (React__default.createElement(TextField, { id: props.id, 
        // getMask={getMask}
        value: Format(props.value), label: props.label, onChange: onChangeHandler, onBlur: onBlurHandler, type: 'tel', helperText: errorText, error: hasError, disabled: props === null || props === void 0 ? void 0 : props.disabled, readOnly: props === null || props === void 0 ? void 0 : props.readOnly, onKeyPress: props === null || props === void 0 ? void 0 : props.onKeyPress, size: size }));
}

var css_248z$d = ".ScrollArea-module_scrollArea_ScrollbarsCustom__1WBoh {\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n.ScrollArea-module_scrollArea_ScrollbarsCustom-Wrapper__1_sPt {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n.ScrollArea-module_scrollArea_ScrollbarsCustom-Scroller__xMs5J {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n.ScrollArea-module_scrollArea_ScrollbarsCustom-Content__E5HK_ {\n  position: relative;\n  box-sizing: border-box;\n  min-width: 100%;\n  min-height: 100%;\n}\n.ScrollArea-module_scrollArea_ScrollbarsCustom-Track__12maE {\n  position: absolute;\n  border-radius: 5px;\n  opacity: 0.3;\n  transition: opacity 0.4s ease-out;\n  background: var(--scrollbarTrack);\n}\n.ScrollArea-module_scrollArea_ScrollbarsCustom__1WBoh:hover .ScrollArea-module_scrollArea_ScrollbarsCustom-Track__12maE {\n  opacity: 1;\n  transition-duration: 0.2s;\n}\n.ScrollArea-module_scrollArea_ScrollbarsCustom-TrackY__1xP1D {\n  width: 5px;\n  height: calc(100% - (2 * 14px));\n  top: 14px;\n  right: calc(14px / 2);\n}\n.ScrollArea-module_scrollArea_ScrollbarsCustom-TrackX__1Np0G {\n  height: 5px;\n  width: calc(100% - (2 * 14px));\n  left: 14px;\n  bottom: calc(14px / 2);\n}\n.ScrollArea-module_scrollArea_ScrollbarsCustom-Thumb__1ReYf {\n  cursor: pointer;\n  border-radius: 5px;\n  background-color: var(--scrollbarThumb);\n}\n.ScrollArea-module_scrollArea_ScrollbarsCustom-ThumbY__1xebT {\n  width: 5px;\n}\n.ScrollArea-module_scrollArea_ScrollbarsCustom-ThumbX__13PcF {\n  height: 5px;\n}\n.ScrollArea-module_scrollArea_trackYVisible__1z2PI .ScrollArea-module_scrollArea_crollbarsCustom-Wrapper__2izW9 {\n  right: 15px;\n}\n.ScrollArea-module_scrollArea_trackXVisible__UwXFY .ScrollArea-module_scrollArea_ScrollbarsCustom-Wrapper__1_sPt {\n  bottom: 15px;\n}\n.ScrollArea-module_scrollArea_dialogScroller__388SZ.ScrollArea-module_trackYVisible__2eLkL > .ScrollArea-module_ScrollbarsCustom-TrackY__tQgLb {\n  margin-right: -24px;\n}";
var css$d = {"scrollArea_ScrollbarsCustom":"ScrollArea-module_scrollArea_ScrollbarsCustom__1WBoh","scrollArea_ScrollbarsCustom-Wrapper":"ScrollArea-module_scrollArea_ScrollbarsCustom-Wrapper__1_sPt","scrollArea_ScrollbarsCustom-Scroller":"ScrollArea-module_scrollArea_ScrollbarsCustom-Scroller__xMs5J","scrollArea_ScrollbarsCustom-Content":"ScrollArea-module_scrollArea_ScrollbarsCustom-Content__E5HK_","scrollArea_ScrollbarsCustom-Track":"ScrollArea-module_scrollArea_ScrollbarsCustom-Track__12maE","scrollArea_ScrollbarsCustom-TrackY":"ScrollArea-module_scrollArea_ScrollbarsCustom-TrackY__1xP1D","scrollArea_ScrollbarsCustom-TrackX":"ScrollArea-module_scrollArea_ScrollbarsCustom-TrackX__1Np0G","scrollArea_ScrollbarsCustom-Thumb":"ScrollArea-module_scrollArea_ScrollbarsCustom-Thumb__1ReYf","scrollArea_ScrollbarsCustom-ThumbY":"ScrollArea-module_scrollArea_ScrollbarsCustom-ThumbY__1xebT","scrollArea_ScrollbarsCustom-ThumbX":"ScrollArea-module_scrollArea_ScrollbarsCustom-ThumbX__13PcF","scrollArea_trackYVisible":"ScrollArea-module_scrollArea_trackYVisible__1z2PI","scrollArea_crollbarsCustom-Wrapper":"ScrollArea-module_scrollArea_crollbarsCustom-Wrapper__2izW9","scrollArea_trackXVisible":"ScrollArea-module_scrollArea_trackXVisible__UwXFY","scrollArea_dialogScroller":"ScrollArea-module_scrollArea_dialogScroller__388SZ","trackYVisible":"ScrollArea-module_trackYVisible__2eLkL","ScrollbarsCustom-TrackY":"ScrollArea-module_ScrollbarsCustom-TrackY__tQgLb"};
styleInject(css_248z$d,{"insertAt":"top"});

const ScrollArea = (props) => {
    var _a, _b, _c, _d, _e;
    const [scrollbar, setScrollbar] = useState(null);
    const [isAtBottom, setIsAtBottom] = useState(false);
    // Scroll based on the scrollVertical prop.
    useEffect(() => {
        if (props.scrollVertical) {
            if (props.scrollVertical === 'Bottom') {
                setIsAtBottom(true);
                if (scrollbar) {
                    scrollbar.scrollToBottom();
                }
            }
            else if (props.scrollVertical === 'Top') {
                setIsAtBottom(false);
                if (scrollbar) {
                    scrollbar.scrollToTop();
                }
            }
            else if ((!!props.scrollVertical || props.scrollVertical === 0) && scrollbar) {
                scrollbar.scrollTop = props.scrollVertical;
                const sv = scrollbar.getScrollState();
                setIsAtBottom((sv.scrollTop >= (sv.contentScrollHeight - sv.clientHeight)));
            }
        }
    }, [props.scrollVertical, scrollbar]);
    // Scroll based on the scrollHorizontal prop.
    useEffect(() => {
        if (props.scrollHorizontal && scrollbar) {
            if (props.scrollHorizontal === 'Left') {
                scrollbar.scrollToLeft();
            }
            else if (props.scrollHorizontal === 'Right') {
                scrollbar.scrollToRight();
            }
            else if (!!props.scrollHorizontal || props.scrollHorizontal === 0) {
                scrollbar.scrollLeft = props.scrollHorizontal;
            }
        }
    }, [props.scrollHorizontal, scrollbar]);
    // Scroll to the bottom if keepAtBottom is set and we are already at the bottom.
    useEffect(() => {
        if (props.keepAtBottom && scrollbar && isAtBottom) {
            scrollbar.scrollToBottom();
        }
    });
    // Update the scroll state on resize.
    useEffect(() => {
        const onResize = () => {
            if (scrollbar) {
                scrollbar.update(true);
                if (props.onTrackVisible) {
                    const { trackXVisible, trackYVisible } = scrollbar.getScrollState(true);
                    props.onTrackVisible(trackXVisible, trackYVisible);
                }
            }
        };
        window.addEventListener('resize', onResize);
        return () => {
            window.removeEventListener('resize', onResize);
        };
    }, [props === null || props === void 0 ? void 0 : props.onTrackVisible, scrollbar]);
    // Call the onTrackVisible function if indicated.
    useEffect(() => {
        if (props.onTrackVisible && scrollbar) {
            const { trackXVisible, trackYVisible } = scrollbar.getScrollState(true);
            props.onTrackVisible(trackXVisible, trackYVisible);
        }
    }, [props === null || props === void 0 ? void 0 : props.onTrackVisible, scrollbar]);
    // Update the scrollbar state when the ref changes.
    const scrollbarRef = useCallback((node) => {
        if (node !== null) {
            setScrollbar(node);
            if (props.onRef) {
                props.onRef(node);
            }
        }
    }, [props.onRef]);
    // const renderer = React.useCallback(
    //     (x: ElementPropsWithElementRef<HTMLDivElement>) => ScrollbarRoot(x, props.style),
    //     [props?.style]
    // );
    const contentRenderer = useCallback((x) => { var _a; return ScrollbarContent(x, (_a = props.classes) === null || _a === void 0 ? void 0 : _a.content); }, [(_a = props === null || props === void 0 ? void 0 : props.classes) === null || _a === void 0 ? void 0 : _a.content]);
    const trackYRenderer = useCallback((x) => { var _a; return ScrollbarTrackY(x, (_a = props.classes) === null || _a === void 0 ? void 0 : _a.trackY); }, [(_b = props.classes) === null || _b === void 0 ? void 0 : _b.trackY]);
    const trackXRenderer = useCallback((x) => { var _a; return ScrollbarTrackX(x, (_a = props.classes) === null || _a === void 0 ? void 0 : _a.trackX); }, [(_c = props.classes) === null || _c === void 0 ? void 0 : _c.trackX]);
    const wrapperRenderer = useCallback((x) => { var _a; return ScrollbarWrapper(x, (_a = props.classes) === null || _a === void 0 ? void 0 : _a.wrapper); }, [(_d = props.classes) === null || _d === void 0 ? void 0 : _d.wrapper]);
    // const scrollerRenderer = React.useCallback(ScrollbarScroller, []);
    const onScrollImpl = props.onScroll;
    const onScroll = useCallback((sv) => {
        setIsAtBottom((sv.scrollTop >= (sv.contentScrollHeight - sv.clientHeight)));
        if (onScrollImpl) {
            onScrollImpl(sv.scrollTop, sv.scrollLeft);
        }
    }, [onScrollImpl]);
    let componentClassname = 'scrollArea';
    if (!!((_e = props.classes) === null || _e === void 0 ? void 0 : _e.root)) {
        componentClassname = props.classes.root;
    }
    if (!!props.isInDialog) {
        componentClassname = componentClassname + ' scrollArea_dialogScroller';
    }
    return (createElement(Scrollbar, { ref: scrollbarRef, className: componentClassname, style: props.style, removeTracksWhenNotUsed: true, noDefaultStyles: true, translateContentSizesToHolder: props.useContentSize, translateContentSizeXToHolder: props.useContentSizeWidth, translateContentSizeYToHolder: props.useContentSizeHeight, rtl: props.rtl, noScrollX: props.noHorizontalScrollbar, noScrollY: props.noVerticalScrollbar, onScroll: onScroll, 
        // renderer={renderer}
        contentProps: { renderer: contentRenderer }, trackYProps: { renderer: trackYRenderer }, trackXProps: { renderer: trackXRenderer }, wrapperProps: { renderer: wrapperRenderer }, 
        // scrollerProps={{ renderer: scrollerRenderer }}
        trackClickBehavior: 'jump' }, props.children));
};
const ScrollbarContent = (scrollProps, custom) => {
    const { elementRef } = scrollProps, other = __rest(scrollProps, ["elementRef"]);
    const theme = useTheme(css$d);
    const className = useClassNames(theme, 'scrollArea', ['ScrollbarsCustom-Content', custom]);
    return createElement("div", Object.assign({}, other, { ref: elementRef, className: className }));
};
const ScrollbarTrackY = (scrollProps, custom) => {
    const { elementRef } = scrollProps, other = __rest(scrollProps, ["elementRef"]);
    const theme = useTheme(css$d);
    const className = useClassNames(theme, 'scrollArea', ['ScrollbarsCustom-Track', 'ScrollbarsCustom-TrackY', custom]);
    return createElement("div", Object.assign({}, other, { ref: elementRef, className: className }));
};
const ScrollbarTrackX = (scrollProps, custom) => {
    const { elementRef } = scrollProps, other = __rest(scrollProps, ["elementRef"]);
    const theme = useTheme(css$d);
    const className = useClassNames(theme, 'scrollArea', ['ScrollbarsCustom-Track', 'ScrollbarsCustom-TrackX', custom]);
    return createElement("div", Object.assign({}, other, { ref: elementRef, className: className }));
};
const ScrollbarWrapper = (scrollProps, custom) => {
    const { elementRef } = scrollProps, other = __rest(scrollProps, ["elementRef"]);
    const theme = useTheme(css$d);
    const className = useClassNames(theme, 'scrollArea', ['ScrollbarsCustom-Wrapper', custom]);
    return createElement("div", Object.assign({}, other, { ref: elementRef, className: className, style: { overflow: 'hidden' } }));
};

var css_248z$e = ".ScrollBar-module_scrollBar__1yD9m {\n  position: inherit;\n}\n\n.ScrollBar-module_scrollBar__1yD9m::-webkit-scrollbar-thumb {\n  background-color: var(--scrollbarThumb);\n  border-radius: 5px;\n}\n\n.ScrollBar-module_horizontal__UKYrp {\n  overflow-y: hidden;\n  overflow-x: auto;\n}\n\n.ScrollBar-module_horizontal__UKYrp::-webkit-scrollbar {\n  width: 20px;\n  height: 5px;\n  opacity: 0.4;\n}\n\n.ScrollBar-module_vertical__2gU01 {\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n.ScrollBar-module_vertical__2gU01::-webkit-scrollbar {\n  width: 5px;\n  height: 20px;\n  opacity: 0.4;\n}";
var css$e = {"scrollBar":"ScrollBar-module_scrollBar__1yD9m","horizontal":"ScrollBar-module_horizontal__UKYrp","vertical":"ScrollBar-module_vertical__2gU01"};
styleInject(css_248z$e,{"insertAt":"top"});

const ScrollBar = (props) => {
    const scrollClass = classNames(css$e.scrollBar, {
        [css$e.horizontal]: props.scrollHorizontal,
        [css$e.vertical]: props.scrollVertical,
    });
    return (React__default.createElement("div", { className: scrollClass }, props.children));
};

var css_248z$f = ".SelectList-module_baseInput__py6Ch {\n  display: inline-flex;\n  padding: 0 9px;\n  font-family: inherit;\n}\n\n.SelectList-module_selectList__2JIMv {\n  margin-right: 10px;\n}\n.SelectList-module_selectList_sizeFull__zuoD5 {\n  width: 100%;\n}\n.SelectList-module_selectList_sizeAuto__1-uAR {\n  width: 100%;\n}\n.SelectList-module_selectList_sizeXs__33Hn8 {\n  width: 4rem;\n}\n.SelectList-module_selectList_sizeSm__3ZQZA {\n  width: 7rem;\n}\n.SelectList-module_selectList_sizeMd__n9RY5 {\n  width: 10rem;\n}\n.SelectList-module_selectList_sizeLg__28GpV {\n  width: 13rem;\n}\n.SelectList-module_selectList_size15x__3GKoJ {\n  width: 15rem;\n}\n.SelectList-module_selectList_sizeXl__3UFOD {\n  width: 21rem;\n}\n.SelectList-module_selectList_sizeXxl__3iNo0 {\n  width: 26rem;\n}\n.SelectList-module_selectList_size3xl__1r1Wo {\n  width: 30rem;\n}\n.SelectList-module_selectList_sizeStatic__hv2vb {\n  width: 150px;\n}\n.SelectList-module_selectList_sizeStaticsm__DKtMa {\n  width: 90px;\n}\n.SelectList-module_selectList_sizeStaticlg__1Hw8Y {\n  width: 200px;\n}\n.SelectList-module_selectList_sizeStaticxl__3FcTZ {\n  width: 250px;\n}\n.SelectList-module_selectList_bold__Qfpz- {\n  font-weight: bold;\n}\n.SelectList-module_selectList_marginBottom__2jfzP {\n  margin-bottom: 14px;\n}\n.SelectList-module_selectList_roundedBorder__3Kyey {\n  border: 1px solid var(--labelColor);\n  border-radius: 20px;\n  overflow: hidden;\n  padding: 0 10px;\n  flex-direction: row;\n}\n.SelectList-module_selectList_roundedBorder__3Kyey:hover {\n  border-color: var(--primaryColor);\n}\n\n.SelectList-module_baseInputSearch__1SHqZ {\n  padding: 0 0 0 14px;\n}\n\n.SelectList-module_fullWidth__28Ho6 {\n  width: 100%;\n}\n\n.SelectList-module_fullHeight__bsXR2 {\n  height: 100%;\n}\n\n.SelectList-module_full__34tUy {\n  width: 100%;\n  height: 100%;\n}\n\n.SelectList-module_noSidePadding__2hIrA {\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.SelectList-module_selectPaper__10mHG {\n  border-radius: 0 0 10px 10px;\n  box-shadow: 2px 2px 4px 0 rgba(0, 0, 0, 0.4);\n  border: 1px solid;\n}\n\n.SelectList-module_selectScrollArea__3sNUF, .SelectList-module_selectPaper__10mHG {\n  max-height: 316px;\n}\n\n.SelectList-module_roundedFilterIcon__pSidP {\n  top: auto;\n  display: flex;\n  right: 5px;\n}\n\n.SelectList-module_selectMenuItem__xmMkH {\n  min-width: 140px;\n  min-height: 30px;\n  font-family: inherit;\n  background-color: var(--selectListBackground);\n  color: var(--selectListTextColor);\n}\n.SelectList-module_selectMenuItem__xmMkH:hover {\n  background: var(--selectListHoverColor);\n  color: var(--selectListHoverTextColor);\n}\n.SelectList-module_selectMenuItem__xmMkH.SelectList-module_Mui-selected__1HxAW {\n  background-color: var(--selectListSelectedBackground);\n}\n.SelectList-module_selectMenuItem__xmMkH.SelectList-module_Mui-selected__1HxAW:hover {\n  background: var(--selectListHoverColor);\n  color: var(--selectListHoverTextColor);\n}\n\n.SelectList-module_selectMenuList__Gqtnb {\n  overflow-y: auto;\n}\n\n.SelectList-module_selectMenuList__Gqtnb::-webkit-scrollbar-thumb {\n  background-color: var(--scrollbarThumb);\n  border-radius: 5px;\n}\n\n.SelectList-module_selectMenuList__Gqtnb::-webkit-scrollbar {\n  width: 5px;\n  height: 20px;\n}\n\n.SelectList-module_selectListGroupHeader__3kWk2 {\n  font-weight: bold;\n  margin-left: 1em;\n  pointer-events: none;\n}";
var css$f = {"baseInput":"SelectList-module_baseInput__py6Ch","selectList":"SelectList-module_selectList__2JIMv","selectList_sizeFull":"SelectList-module_selectList_sizeFull__zuoD5","selectList_sizeAuto":"SelectList-module_selectList_sizeAuto__1-uAR","selectList_sizeXs":"SelectList-module_selectList_sizeXs__33Hn8","selectList_sizeSm":"SelectList-module_selectList_sizeSm__3ZQZA","selectList_sizeMd":"SelectList-module_selectList_sizeMd__n9RY5","selectList_sizeLg":"SelectList-module_selectList_sizeLg__28GpV","selectList_size15x":"SelectList-module_selectList_size15x__3GKoJ","selectList_sizeXl":"SelectList-module_selectList_sizeXl__3UFOD","selectList_sizeXxl":"SelectList-module_selectList_sizeXxl__3iNo0","selectList_size3xl":"SelectList-module_selectList_size3xl__1r1Wo","selectList_sizeStatic":"SelectList-module_selectList_sizeStatic__hv2vb","selectList_sizeStaticsm":"SelectList-module_selectList_sizeStaticsm__DKtMa","selectList_sizeStaticlg":"SelectList-module_selectList_sizeStaticlg__1Hw8Y","selectList_sizeStaticxl":"SelectList-module_selectList_sizeStaticxl__3FcTZ","selectList_bold":"SelectList-module_selectList_bold__Qfpz-","selectList_marginBottom":"SelectList-module_selectList_marginBottom__2jfzP","selectList_roundedBorder":"SelectList-module_selectList_roundedBorder__3Kyey","baseInputSearch":"SelectList-module_baseInputSearch__1SHqZ","fullWidth":"SelectList-module_fullWidth__28Ho6","fullHeight":"SelectList-module_fullHeight__bsXR2","full":"SelectList-module_full__34tUy","noSidePadding":"SelectList-module_noSidePadding__2hIrA","selectPaper":"SelectList-module_selectPaper__10mHG","selectScrollArea":"SelectList-module_selectScrollArea__3sNUF","roundedFilterIcon":"SelectList-module_roundedFilterIcon__pSidP","selectMenuItem":"SelectList-module_selectMenuItem__xmMkH","Mui-selected":"SelectList-module_Mui-selected__1HxAW","selectMenuList":"SelectList-module_selectMenuList__Gqtnb","selectListGroupHeader":"SelectList-module_selectListGroupHeader__3kWk2"};
styleInject(css_248z$f,{"insertAt":"top"});

// import { ScrollArea } from 'src';
const ARRAY_DELIMITER = '�';
const SelectList = memo((props) => {
    var _a, _b, _c;
    let requiredText = false;
    /** This variable is used to keep track of the parent div for the text.
     * We use it to determine if we need to display a tooltip when requested.
     */
    if (!!props.startRequired && (props.value === null ||
        props.value === '' ||
        +props.value === -1)) {
        requiredText = true;
    }
    const [inputRef, setInputRef] = useState(undefined);
    const [value, setValue] = useState(props.value);
    const [displayRequiredText, setDisplayRequiredText] = useState(requiredText);
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const [keys, setKeys] = useState('');
    const [isOverflow, setIsOverflow] = useState(false);
    const [overflowText, setOverflowText] = useState('');
    useEffect(() => {
        if (value !== undefined) {
            setKeys('');
        }
    }, [value]);
    /** Triggered when a field's value is changed. */
    const onChange = useCallback((event) => {
        if (event !== undefined) {
            let newValue = undefined;
            if (event.target !== undefined) {
                newValue = parseString(event.target.value);
            }
            else if (event.value !== undefined) {
                newValue = parseString(event.value);
            }
            if (newValue !== undefined) {
                setValue(newValue);
                if (props.onChange) {
                    props.onChange(props.id, newValue);
                }
            }
        }
    }, [props === null || props === void 0 ? void 0 : props.id, props === null || props === void 0 ? void 0 : props.onChange]);
    /** Set the display required text */
    useEffect(() => {
        if (!!props.required) {
            if (!!props.required && value !== null && value !== '' && +value !== -1) {
                setDisplayRequiredText(false);
            }
            else {
                setDisplayRequiredText(true);
            }
        }
    }, [props === null || props === void 0 ? void 0 : props.required, value]);
    /** OverFlow text control */
    useEffect(() => {
        var _a, _b;
        let listItem = undefined;
        if (!(((_b = (_a = props.dropDownList) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) === 0)) {
            listItem = props.dropDownList.find((x) => x.value === value);
        }
        let overflow = false;
        let newOverflowText = '';
        if (inputRef && inputRef.children &&
            inputRef.children[0].clientWidth < inputRef.children[0].scrollWidth) {
            overflow = true;
            newOverflowText = value &&
                (typeof value !== 'number' || value > 0) ?
                (listItem ? listItem.label : null) :
                value;
        }
        setIsOverflow(overflow);
        setOverflowText(newOverflowText);
    }, [inputRef, props === null || props === void 0 ? void 0 : props.dropDownList, value]);
    /** Keep track of the keypresses. */
    const onKeyPress = useCallback((event) => {
        event.persist();
        setKeys(keys + event.key);
    }, [keys]);
    /** Triggered when a field loses focus. */
    const onBlur = useCallback((event) => {
        if (props.onBlur) {
            props.onBlur(props.id, parseString(event.target.value));
        }
    }, [props === null || props === void 0 ? void 0 : props.id, props === null || props === void 0 ? void 0 : props.onBlur]);
    /** Triggered when a field gains focus. */
    const onFocus = useCallback((event) => {
        if (props.onFocus) {
            props.onFocus(props.id, parseString(event.target.value));
        }
    }, [props === null || props === void 0 ? void 0 : props.id, props === null || props === void 0 ? void 0 : props.onFocus]);
    useEffect(() => {
        var _a, _b;
        if (keys.length > 0) {
            const theseKeys = keys.toLowerCase();
            if (((_b = (_a = props.dropDownList) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 0) {
                // Find all entries that start with the entered keypresses.
                const items = props.dropDownList.filter((x) => {
                    const label = x.label ? x.label.toLowerCase() : '';
                    return label.startsWith(theseKeys);
                });
                if (items) {
                    // Simulate walking through the list if the same value was entered.
                    let index = items.findIndex((x) => x.value === value);
                    if (index > -1) {
                        index = ((index + 1) > (items.length - 1)) ? 0 : ++index;
                    }
                    else {
                        index = 0;
                    }
                    const item = items[index];
                    if (item) {
                        if (item.value !== value) {
                            setValue(item.value);
                            if (props.onChange) {
                                props.onChange(props.id, item.value);
                            }
                        }
                    }
                }
            }
        }
    }, [keys, props === null || props === void 0 ? void 0 : props.dropDownList, props === null || props === void 0 ? void 0 : props.id, props === null || props === void 0 ? void 0 : props.onChange, value]);
    // Halts event bubbling up if interacting with group headers. Add to more calls if needed.
    // const checkGroupHeaderPass = React.useCallback((event) => {
    //     let halt = false;
    //     if (props.groupItems) {
    //         if (!event || !event.target || !event.target.value) {
    //             halt = true;
    //         }
    //     }
    //     return !halt;
    // }, [props?.groupItems]);
    const onClick = useCallback((event) => {
        // if (!!props.preventDefault && !checkGroupHeaderPass(event)) {
        event.preventDefault();
        event.stopPropagation();
        // }
    }, []);
    let listItem = undefined;
    if (((_b = (_a = props.dropDownList) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 0) {
        listItem = props.dropDownList.find((x) => x.value === value);
    }
    // we don't need to display the field as a select list if it's disabled
    const newValue = (props === null || props === void 0 ? void 0 : props.disabled) && value && (typeof value !== 'number' || value > 0) ?
        (listItem ? listItem.label : null) :
        convertArray(value);
    const list = props.dropDownList ?
        props.dropDownList.map((dropDownItem) => {
            // Stringify arrays.
            const value = convertArray(dropDownItem.value);
            const item = Object.assign(Object.assign({}, dropDownItem), { value: value });
            if (tooltipOpen) {
                return Object.assign(Object.assign({}, item), { tooltip: '' });
            }
            return item;
        }) : [];
    const groupItems = props.groupItems;
    let optionsList = [];
    if (list) {
        if (!groupItems) {
            optionsList = list.map((item) => {
                let icon = (createElement(Fragment, null,
                    createElement("span", null, item.label)));
                if (!!item.icon) {
                    icon = (createElement(Fragment, null,
                        createElement("span", null,
                            createElement(Icon, { size: 'xs', spanClassName: 'selectListIcon' }, item.icon)),
                        createElement("span", null, item.label)));
                }
                if (!tooltipOpen) {
                    icon = (createElement(Tooltip, { text: item.tooltip }, icon));
                }
                return (createElement(MenuItem, { classes: {
                        root: css$f.selectMenuItem,
                    }, key: item.value, value: item.value }, icon));
            });
        }
        else {
            const uniqueGroups = {};
            const uniqueGroupStrings = [];
            const tab = (createElement(Fragment, null, "\u00A0\u00A0\u00A0"));
            list.forEach((listElement) => {
                const idx = uniqueGroupStrings.findIndex(a => a === listElement.group);
                if (idx >= 0) {
                    uniqueGroups[idx] = [];
                    uniqueGroupStrings.push(listElement.group);
                }
                uniqueGroups[listElement.group].push(Object.assign({}, listElement));
            });
            uniqueGroupStrings.forEach((groupString, index) => {
                optionsList.push(createElement("div", { key: index, className: css$f.selectListGroupHeader }, groupString));
                const holdOptionsList = uniqueGroups[groupString].map((item) => {
                    let icon = (createElement(Fragment, null,
                        createElement("span", null, item.label)));
                    if (!!item.icon) {
                        icon = (createElement(Fragment, null,
                            createElement("span", null,
                                createElement(Icon, { size: 'xs', spanClassName: 'selectListIcon' }, item.icon)),
                            createElement("span", null,
                                tab,
                                item.label)));
                    }
                    if (!tooltipOpen) {
                        icon = (createElement(Tooltip, { text: item.tooltip }, icon));
                    }
                    return (createElement(MenuItem, { classes: {
                            root: css$f.selectMenuItem,
                        }, key: item.value, value: item.value }, icon));
                });
                optionsList = [
                    ...optionsList,
                    ...holdOptionsList,
                ];
            });
        }
    }
    const theme = useTheme(css$f);
    const setFieldRef = useCallback((el) => {
        setInputRef(el);
        if (props.getFieldRef) {
            props.getFieldRef(el);
        }
    }, [props === null || props === void 0 ? void 0 : props.getFieldRef]);
    /** Function to update the field ref. */
    const getFieldRef = useCallback((el) => {
        var _a;
        if (el === null || el === void 0 ? void 0 : el.parentElement) {
            setFieldRef(el.parentElement);
        }
        else if ((_a = el === null || el === void 0 ? void 0 : el.node) === null || _a === void 0 ? void 0 : _a.parentElement) {
            setFieldRef(el.node.parentElement);
        }
        else {
            setFieldRef(undefined);
        }
    }, [setFieldRef]);
    const fieldSize = (_c = props.size) !== null && _c !== void 0 ? _c : 'Md';
    const className = useClassNames(theme, 'selectList', [
        `size${fieldSize.charAt(0).toUpperCase() + fieldSize.slice(1)}`,
        props.variant
    ]);
    let control = (createElement(MuiTextField__default, { inputRef: getFieldRef, className: className, autoComplete: 'no', id: `${props.id}_input`, value: newValue, defaultValue: props.defaultValue, label: props.label, onChange: onChange, onBlur: onBlur, onFocus: onFocus, onKeyPress: onKeyPress, disabled: props.disabled, InputLabelProps: {
            shrink: props.raisedLabel,
        }, error: displayRequiredText, SelectProps: {
            MenuProps: {
                classes: {
                    paper: css$f.selectPaper,
                },
                MenuListProps: {
                    classes: {
                        root: css$f.selectMenuList,
                    },
                },
                anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
                transformOrigin: { vertical: 'top', horizontal: 'left' },
                getContentAnchorEl: null,
                PaperProps: {
                    component: SelectScrollerAreaWrapper,
                },
            },
            // Prevents the tooltip from reopening after the dropdown closes...
            onMouseEnter: ({ currentTarget, target }) => setTooltipOpen(currentTarget.contains(target)),
            onMouseLeave: () => setTooltipOpen(false),
            onOpen: () => setTooltipOpen(false),
            onClose: () => setTooltipOpen(false),
            autoWidth: true,
            disableUnderline: props.disableUnderline,
        }, select: true, onClick: onClick }, optionsList));
    if (props.tooltip) {
        control = (createElement(Tooltip, { text: props.tooltip, open: tooltipOpen }, control));
    }
    else if (isOverflow &&
        !!overflowText &&
        overflowText !== value) {
        control = (createElement(Tooltip, { text: overflowText.toString(), open: !!props.disabled ? false : tooltipOpen }, control));
    }
    else if (!!props.label && props.value === '') {
        control = (createElement(Tooltip, { text: props.label, open: !!props.disabled ? false : tooltipOpen }, control));
    }
    return control;
});
const parseString = (value) => {
    const valueParts = (typeof value === 'string') ?
        value.split(ARRAY_DELIMITER) :
        [value];
    return valueParts.length > 1 ? valueParts : valueParts[0];
};
const convertArray = (value) => Array.isArray(value) ? value.join(ARRAY_DELIMITER) : value;
/** This is a helper component for using the custom scroller for the Material UI Select
 *  component. It's necessary to be declared here in order to prevent react from creating
 *  a new component on every render of the Select and remounting the whole sub-tree.
 */
const SelectScrollerAreaWrapper = forwardRef((_a, ref) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    const [top, setTop] = useState(0);
    const listItemRef = useRef(null);
    const offsetTop = listItemRef && listItemRef.current ? listItemRef.current.offsetTop : 0;
    // Scroll to selected item when mounting.
    useEffect(() => {
        setTop(listItemRef.current.offsetTop);
    }, [offsetTop]);
    const child = children;
    const listItems = Children.toArray(child.props.children);
    return (createElement("div", Object.assign({}, props, { ref: ref }),
        createElement(MenuList, { classes: child.classes, className: child.className, role: 'listbox', variant: 'selectedMenu', disableListWrap: true, onKeyDown: child.onKeyDown }, listItems &&
            listItems.map((x, index) => (createElement(MenuItem, { ref: x.props.selected ? listItemRef : null, key: 'SelectList_' + index, classes: x.props.classes, onClick: x.props.onClick, onKeyUp: x.props.onKeyUp, role: x.props.role, selected: x.props.selected, "data-value": x.props['data-value'] }, x.props.children))))));
});

const validateSSNInput = (input) => {
    let isValid = true;
    isValid = !isNaN(+input);
    isValid = isValid && input.length <= 9;
    return isValid;
};
const formatSSN = (value, maskInput) => {
    if (value.length === 9) {
        if (maskInput) {
            return '***-**-' + value.substr(value.length - 4);
        }
        else {
            return value.slice(0, 3) + '-' + value.slice(0, 5) + '-' + value.substr(6);
        }
    }
    else {
        return value;
    }
};
function SSNField(props) {
    const value = props.value !== undefined ? props.value : '';
    const maskInput = props.maskInput !== undefined ? props.maskInput : true;
    const [ssnVal, setSSNVal] = useState(value);
    const [displayValue, setDisplayValue] = useState(ssnVal);
    const [errorText, setErrorText] = useState('');
    const [hasError, setHasError] = useState(false);
    const changeSSN = React__default.useCallback((id, value) => {
        if (validateSSNInput(value)) {
            setSSNVal(value);
            setDisplayValue(formatSSN(value, maskInput));
        }
    }, [maskInput]);
    const blurSSNField = React__default.useCallback((id, value) => {
        let errorFlag = false;
        let errorMsg = '';
        setDisplayValue(formatSSN(value, maskInput));
        if (props.required) {
            if ((value === null || value === '' || +value === -1) && props.required) {
                errorFlag = true;
                errorMsg = 'Field is required';
            }
            else if (value !== null && value !== '' && +value !== -1) {
                errorFlag = false;
            }
        }
        if (value.length !== 9 && !errorFlag) {
            if (value.match(/^([*])(?!\1{2}-\1{2}-\1{4})[*]{2}-[*]{2}-[0-9]/) === null) {
                errorFlag = true;
                errorMsg = 'SSN must have 9 numbers.';
            }
        }
        setHasError(errorFlag);
        setErrorText(errorMsg);
    }, [maskInput, props === null || props === void 0 ? void 0 : props.required]);
    const focusSSNField = React__default.useCallback(() => {
        setDisplayValue(ssnVal);
    }, [ssnVal]);
    return (React__default.createElement(TextField, { id: props.id, value: displayValue, type: 'text', label: props.label, onChange: changeSSN, onBlur: blurSSNField, onFocus: focusSSNField, helperText: errorText, error: hasError }));
}

function TextAreaField(props) {
    const rows = props.rows !== undefined ? props.rows : 6;
    const maxLength = props.maxLength !== undefined ? props.maxLength : 255;
    const showCharCount = props.showCharCount !== undefined ? props.showCharCount : true;
    const [fieldValue, setFieldValue] = useState(props.value);
    const [errorText, setErrorText] = useState('');
    const [helperText, setHelperText] = useState(props.value.length + '/' + maxLength);
    const [hasError, setHasError] = useState(false);
    const onChangeHandler = React__default.useCallback((id, value) => {
        const hasError = errorText === '' ? false : true;
        if (value.length <= maxLength) {
            setFieldValue(value);
            setHelperText(value.length + helperText.substring(helperText.indexOf('/')));
        }
        props.onChange(id, value, hasError);
    }, [errorText, helperText, maxLength, props === null || props === void 0 ? void 0 : props.onChange]);
    const onBlurHandler = React__default.useCallback((id, value) => {
        let errorFlag = false;
        let errorMsg = '';
        if (props.required) {
            if ((value === null || value === '' || +value === -1) && props.required) {
                errorFlag = true;
                errorMsg = 'Field is required';
            }
            else if (value !== null && value !== '' && +value !== -1) {
                errorFlag = false;
            }
        }
        setErrorText(errorMsg);
        setHasError(errorFlag);
        setHelperText(helperText.substring(0, helperText.indexOf('/') + maxLength.toString().length) +
            ' ' + errorMsg);
        if (props.onBlur !== undefined) {
            props.onBlur(id, value, errorFlag);
        }
    }, [helperText, maxLength, props === null || props === void 0 ? void 0 : props.onBlur, props === null || props === void 0 ? void 0 : props.required]);
    return (React__default.createElement(TextField, { id: props.id, value: fieldValue, label: props.label, onChange: onChangeHandler, type: 'text', helperText: showCharCount ? helperText : errorText, error: hasError, onBlur: onBlurHandler, readOnly: props.readOnly, rows: rows, multiline: rows > 1 }));
}

function ZipField(props) {
    const [errorText, setErrorText] = useState('');
    const [hasError, setHasError] = useState(false);
    const [country, setCountry] = useState('US');
    const [lang, setLang] = useState('en');
    React__default.useEffect(() => {
        var _a;
        if (((_a = props === null || props === void 0 ? void 0 : props.locale) !== null && _a !== void 0 ? _a : '').length > 2) {
            const newLang = props.locale.slice(0, 2).toLowerCase();
            const newCountry = props.locale.slice(props.locale.length - 2).toUpperCase();
            setLang(newLang);
            setCountry(newCountry);
        }
    }, [props === null || props === void 0 ? void 0 : props.locale]);
    const validateZipInput = React__default.useCallback((input) => {
        let isValid = true;
        if (country === 'CA') {
            isValid = isValid && input.length <= 8;
        }
        else {
            isValid = !(input.includes('-') && input.length <= 5);
            isValid = isValid && !isNaN(+(input.replace('-', '')));
        }
        isValid = isValid && input.length <= 10;
        return isValid;
    }, [country]);
    const changeZip = React__default.useCallback((id, value) => {
        if (validateZipInput(value)) {
            let tempVal = value;
            if (country === 'CA') {
                if (value.length > 3 && !(value.includes(' ') || value.includes('-'))) {
                    tempVal = value.slice(0, 3) + ' ' + value.slice(3, value.length);
                }
            }
            else {
                if (value.length > 5 && !value.includes('-')) {
                    tempVal = value.slice(0, 5) + '-' + value.slice(5, value.length);
                }
                else if (value.length <= 6 && value.includes('-')) {
                    tempVal = value.substr(0, 5);
                }
            }
            props.onChange(id, tempVal, false);
        }
    }, [country, props === null || props === void 0 ? void 0 : props.onChange, validateZipInput]);
    const blurZipField = React__default.useCallback((id, value) => {
        let errorFlag = false;
        let errorMsg = '';
        if (!!props.required && (value !== null && value !== void 0 ? value : '') === '') {
            errorFlag = true;
            if (lang === 'fr') {
                errorMsg = 'Ce champ est obligatoire';
            }
            else {
                errorMsg = 'Field is required';
            }
        }
        if (country === 'CA') {
            if (!errorFlag) {
                if (value.match(/^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i) === null) {
                    errorFlag = true;
                    if (lang === 'fr') {
                        errorMsg = 'Ce n\'est pas un code postal valide.';
                    }
                    else {
                        errorMsg = 'This is not a valid zipcode.';
                    }
                }
            }
        }
        else {
            if (value.length !== 9 && !errorFlag) {
                if (value.match(/(^\d{5}$)|(^\d{9}$)|(^\d{5}-\d{4}$)/) === null) {
                    errorFlag = true;
                    errorMsg = 'Zip must have either 5 or 9 numbers.';
                }
            }
        }
        setHasError(errorFlag);
        setErrorText(errorMsg);
    }, [country, lang, props === null || props === void 0 ? void 0 : props.required]);
    return (React__default.createElement(TextField, { id: props.id, value: props.value, type: 'text', label: props.label, onChange: changeZip, onBlur: blurZipField, helperText: errorText, error: hasError }));
}

var css_248z$g = ".Popover-module_paper__3aDNX {\n  display: flex;\n  flex-direction: column;\n  flex: 0 1 auto;\n  overflow-y: auto;\n  border-radius: 0;\n  box-shadow: 1px 1px 4px 0 rgba(0, 0, 0, 0.4);\n  background-color: transparent;\n}\n\n.Popover-module_roundedTopRight__1atRA {\n  border-top-right-radius: 20px;\n}\n\n.Popover-module_roundedTopLeft__75mD- {\n  border-top-left-radius: 20px;\n}\n\n.Popover-module_roundedBottomRight__BSjzy {\n  border-bottom-right-radius: 20px;\n}\n.Popover-module_roundedBottomRight__BSjzy .buttonGroup.primaryButtonGroup {\n  border-radius: 0 0 25px 0;\n  box-shadow: none;\n}\n.Popover-module_roundedBottomRight__BSjzy .buttonGroup.primaryButtonGroup button.primaryButton {\n  border-radius: 0 0 20px 0;\n}\n\n.Popover-module_roundedBottomLeft__GfUjV {\n  border-bottom-left-radius: 20px;\n}\n\n.Popover-module_title__1pnXV {\n  padding: 0;\n  margin: 0;\n  flex: 0 0 auto;\n  background: var(--defaultBackgroundVertical);\n}\n\n.Popover-module_header__24LNz {\n  display: flex;\n  min-height: 44px;\n}\n\n.Popover-module_headerText__D4HqT {\n  flex: 1;\n  margin: auto;\n  font-size: 18px;\n  padding-right: 24px;\n  padding-left: 24px;\n  color: var(--contrastColor);\n}\n.Popover-module_headerText__D4HqT.Popover-module_upperCase__2dqJC {\n  text-transform: uppercase;\n}\n\n.Popover-module_content__3aVnj {\n  display: flex;\n  flex: 1 1 auto;\n  flex-wrap: wrap;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  border: solid 1px var(--borderColor);\n  background-color: white;\n}\n\n.Popover-module_contentPadding__18HoK {\n  padding: 24px;\n}\n\n.Popover-module_contentMargin__3uKGT {\n  margin: 24px;\n}\n\n.Popover-module_noTopPaddingMargin__1SBax {\n  margin-top: 0;\n  padding-top: 0;\n}\n\n.Popover-module_noLeftRightPadding__2GnAx {\n  margin-right: 0;\n  margin-left: 0;\n  padding-right: 0;\n  padding-left: 0;\n}\n\n.Popover-module_noBottomPadding__n_RKa {\n  padding-bottom: 0;\n}\n\n.Popover-module_calendarContent__3grt0 {\n  flex-direction: column;\n  padding: 0;\n}\n\n.Popover-module_content__3aVnj:first-child {\n  padding-top: 24px;\n}\n\n.Popover-module_actions__EHBp4 {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex: 0 0 auto;\n  margin: 0;\n  background: var(--backingColor);\n}\n\n.Popover-module_actionButton__7WiZb {\n  margin: 0;\n}\n\n.Popover-module_iconButton__1cWA2 {\n  padding: 5px;\n  float: left;\n}\n\n.Popover-module_iconGroup__qKyPR {\n  margin-right: 100px;\n}";
var popoverCSS = {"paper":"Popover-module_paper__3aDNX","roundedTopRight":"Popover-module_roundedTopRight__1atRA","roundedTopLeft":"Popover-module_roundedTopLeft__75mD-","roundedBottomRight":"Popover-module_roundedBottomRight__BSjzy","roundedBottomLeft":"Popover-module_roundedBottomLeft__GfUjV","title":"Popover-module_title__1pnXV","header":"Popover-module_header__24LNz","headerText":"Popover-module_headerText__D4HqT","upperCase":"Popover-module_upperCase__2dqJC","content":"Popover-module_content__3aVnj","contentPadding":"Popover-module_contentPadding__18HoK","contentMargin":"Popover-module_contentMargin__3uKGT","noTopPaddingMargin":"Popover-module_noTopPaddingMargin__1SBax","noLeftRightPadding":"Popover-module_noLeftRightPadding__2GnAx","noBottomPadding":"Popover-module_noBottomPadding__n_RKa","calendarContent":"Popover-module_calendarContent__3grt0","actions":"Popover-module_actions__EHBp4","actionButton":"Popover-module_actionButton__7WiZb","iconButton":"Popover-module_iconButton__1cWA2","iconGroup":"Popover-module_iconGroup__qKyPR"};
styleInject(css_248z$g,{"insertAt":"top"});

var css_248z$h = ".Std-module_paper__20gxH {\n  display: flex;\n  flex-direction: column;\n  flex: 0 1 auto;\n  overflow-y: auto;\n  border-radius: 0;\n  box-shadow: 1px 1px 4px 0 rgba(0, 0, 0, 0.4);\n}\n\n.Std-module_paperRounded__2G6tB {\n  border-radius: 20px;\n}\n.Std-module_paperRounded__2G6tB .buttonGroup.primaryButtonGroup {\n  border-radius: 0 0 25px 0;\n}\n.Std-module_paperRounded__2G6tB .buttonGroup.primaryButtonGroup button.primaryButton {\n  border-radius: 0 0 20px 0;\n}\n\n.Std-module_errorRounded__3ekUe {\n  border-radius: 12px 0 12px 0;\n  display: flex;\n  flex-direction: column;\n  flex: 0 1 auto;\n  overflow-y: auto;\n  min-width: 450px;\n  min-height: 200px;\n}\n.Std-module_errorRounded__3ekUe .buttonGroup.primaryButtonGroup {\n  border-radius: 0 0 17px 0;\n}\n.Std-module_errorRounded__3ekUe .buttonGroup.primaryButtonGroup button.primaryButton {\n  border-radius: 0 0 12px 0;\n  min-width: 122px;\n  height: 45px;\n}\n.Std-module_errorRounded__3ekUe .buttonGroup.primaryButtonGroup button.secondaryButton {\n  min-width: 122px;\n  height: 45px;\n}\n\n.Std-module_title__nDMAy {\n  padding: 0;\n  margin: 0;\n  flex: 0 0 auto;\n  background: var(--menuBackground);\n  border-bottom: 1px solid var(--borderColor);\n  fill: var(--secondaryColor);\n}\n\n.Std-module_titleFull__mjAHT {\n  padding: 0;\n  margin: 0;\n  flex: 0 0 auto;\n  background: var(--secondaryColor);\n  border-bottom: 1px solid var(--borderColor);\n  fill: var(--contrastColor);\n}\n\n.Std-module_header__18Yns, .Std-module_warningErrorDialogHeader__2R_qi {\n  display: flex;\n  align-items: center;\n}\n\n.Std-module_headerText__1KUyr {\n  flex: 1;\n  font-size: 1.33rem;\n  padding-left: 10px;\n  color: var(--secondaryColor);\n}\n.Std-module_headerText__1KUyr.Std-module_upperCase__4Aq3f {\n  text-transform: uppercase;\n}\n\n.Std-module_headerTextFull__2M0_u {\n  flex: 1;\n  font-size: 1.33rem;\n  padding-left: 10px;\n  color: var(--contrastColor);\n}\n.Std-module_headerTextFull__2M0_u.Std-module_upperCase__4Aq3f {\n  text-transform: uppercase;\n}\n\n.Std-module_headerTextErrorWarning__QkQ0K {\n  flex: 1;\n  font-size: 18px;\n  text-transform: uppercase;\n  padding-left: 10px;\n  color: var(--primaryColor);\n}\n\n.Std-module_contextText__CC2Ai {\n  margin-left: 1em;\n}\n\n.Std-module_contextHeader__3ts4Y {\n  border-left: 1px solid var(--borderColor);\n  border-right: 1px solid var(--borderColor);\n}\n\n.Std-module_content__1m8XM {\n  display: flex;\n  flex: 1 1 auto;\n  flex-wrap: wrap;\n  padding: 24px;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  border-left: 1px solid var(--borderColor);\n  border-right: 1px solid var(--borderColor);\n  border-bottom: 1px solid var(--borderColor);\n}\n\n.Std-module_errorContent__2Maw9 {\n  color: var(--lightTextColor);\n}\n\n.Std-module_content__1m8XM:not(.Std-module_noTopPaddingMargin__1-8GU):first-child {\n  padding-top: 24px;\n}\n\n.Std-module_actions__2mZSL {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex: 0 0 auto;\n  margin: 0;\n  padding: 0;\n  height: 45px;\n  background: var(--backingColor);\n}\n\n.Std-module_warningErrorDialogHeader__2R_qi {\n  height: 58px;\n  padding-left: 0px;\n}\n\n.Std-module_errorIcon__2Hf9l {\n  padding: 17px;\n  background: var(--errorBackgroundVertical);\n  color: var(--contrastColor);\n  text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.3);\n}\n\n.Std-module_warningIcon__2nmf8 {\n  padding: 17px;\n  background: var(--warningBackground);\n  color: var(--contrastColor);\n  text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.3);\n}\n\n.Std-module_warningErrorHeader__1ikQa {\n  padding-left: 24px;\n  font-size: 16px;\n  font-weight: bold;\n  padding-top: 24px;\n  margin-bottom: -10px;\n  color: var(--darkTextColor);\n}\n\n.Std-module_paperWidthXs__1fgNP {\n  max-width: max(0, 450px);\n}\n\n.Std-module_paperWidthSm__3He33 {\n  max-width: 600px;\n}\n\n.Std-module_paperWidthMd__2YEip {\n  max-width: 960px;\n}\n\n.Std-module_paperWidthLg__2JGZ3 {\n  max-width: 1280px;\n}\n\n.Std-module_paperWidthXl__eLcJV {\n  max-width: 1920px;\n}\n\n.Std-module_paperHeightXs__nTCHl {\n  height: max(0, 450px);\n}\n\n.Std-module_paperHeightSm__1xLu7 {\n  height: 600px;\n}\n\n.Std-module_paperHeightMd__3z3Cn {\n  height: 960px;\n}\n\n.Std-module_paperHeightLg__2dKfR {\n  height: 1280px;\n}\n\n.Std-module_paperHeightXl__2kFDU {\n  height: 1920px;\n}";
var standardCSS = {"paper":"Std-module_paper__20gxH","paperRounded":"Std-module_paperRounded__2G6tB","errorRounded":"Std-module_errorRounded__3ekUe","title":"Std-module_title__nDMAy","titleFull":"Std-module_titleFull__mjAHT","header":"Std-module_header__18Yns","warningErrorDialogHeader":"Std-module_warningErrorDialogHeader__2R_qi","headerText":"Std-module_headerText__1KUyr","upperCase":"Std-module_upperCase__4Aq3f","headerTextFull":"Std-module_headerTextFull__2M0_u","headerTextErrorWarning":"Std-module_headerTextErrorWarning__QkQ0K","contextText":"Std-module_contextText__CC2Ai","contextHeader":"Std-module_contextHeader__3ts4Y","content":"Std-module_content__1m8XM","errorContent":"Std-module_errorContent__2Maw9","noTopPaddingMargin":"Std-module_noTopPaddingMargin__1-8GU","actions":"Std-module_actions__2mZSL","errorIcon":"Std-module_errorIcon__2Hf9l","warningIcon":"Std-module_warningIcon__2nmf8","warningErrorHeader":"Std-module_warningErrorHeader__1ikQa","paperWidthXs":"Std-module_paperWidthXs__1fgNP","paperWidthSm":"Std-module_paperWidthSm__3He33","paperWidthMd":"Std-module_paperWidthMd__2YEip","paperWidthLg":"Std-module_paperWidthLg__2JGZ3","paperWidthXl":"Std-module_paperWidthXl__eLcJV","paperHeightXs":"Std-module_paperHeightXs__nTCHl","paperHeightSm":"Std-module_paperHeightSm__1xLu7","paperHeightMd":"Std-module_paperHeightMd__3z3Cn","paperHeightLg":"Std-module_paperHeightLg__2dKfR","paperHeightXl":"Std-module_paperHeightXl__2kFDU"};
styleInject(css_248z$h,{"insertAt":"top"});

const WIDTH_PADDING = 50; // 2*24px padding + 2*1px border;
const HEIGTH_PADDING = 139; // 44px header + 2*24px padding + 2*1px border + 45px action;
/** Displays a simple dialog based on the settings given. */
const Dialog = React__default.memo((props) => {
    /** Triggered when the close action is performed. */
    const onClose = useCallback((event) => {
        props.onCancel(event);
    }, [props.onCancel]);
    /** Triggered when the save action is performed. */
    const onSave = useCallback((event) => {
        props.onSave(event);
    }, [props.onSave]);
    /** Triggered when a custom button is clicked. */
    const onCustomClicked = useCallback((event, id) => {
        props.onCustomClicked(event, id);
    }, [props.onCustomClicked]);
    /** Triggered when back drop is clicked */
    const onBackDropClick = useCallback((event) => {
        props.onBackDropClick(event);
    }, [props.onBackDropClick]);
    // Get the label overrides.
    const isPopover = !!props.anchorReference;
    const cancelLabel = props.cancelLabel !== undefined ? props.cancelLabel : 'Cancel';
    let saveLabel = props.saveLabel !== undefined ? props.saveLabel : 'Save';
    const persistent = (props.persistent !== undefined) ? props.persistent : false;
    const addActions = !props.hideSave || !props.hideCancel || (props.customButtons !== undefined)
        || (props.iconButtons !== undefined);
    let headerIcon = props.headerIcon;
    let contextHeader = props.contextHeader;
    let hideCancel = props.hideCancel;
    if (props.errorOrWarning === 'error') {
        headerIcon = React__default.createElement(Icon, null, IconError);
        contextHeader = 'Error';
        saveLabel = props.saveLabel !== undefined ? props.saveLabel : 'OK';
        // onSave = props.onCancel;
        hideCancel = true;
    }
    else if (props.errorOrWarning === 'warning') {
        headerIcon = React__default.createElement(Icon, null, IconWarning);
        contextHeader = 'Warning';
    }
    return isPopover ?
        (React__default.createElement(PopoverDialog, Object.assign({}, props, { cancelLabel: cancelLabel, saveLabel: saveLabel, persistent: persistent, headerIcon: headerIcon, contextHeader: contextHeader, addActions: addActions, onSave: onSave, onClose: onClose, onCustomClicked: onCustomClicked, onBackDropClick: onBackDropClick, hideCancel: hideCancel }))) :
        (React__default.createElement(StandardDialog, Object.assign({}, props, { cancelLabel: cancelLabel, saveLabel: saveLabel, persistent: persistent, headerIcon: headerIcon, contextHeader: contextHeader, addActions: addActions, onSave: onSave, onClose: onClose, onCustomClicked: onCustomClicked, onBackDropClick: onBackDropClick, hideCancel: hideCancel })));
});
const StandardDialog = React__default.memo((props) => {
    // Context Text Classes.
    const contextHeaderClass = (props.cssClasses && props.cssClasses.contextHeader) ? props.cssClasses.contextHeader : null;
    const contentTextClassName = classNames(standardCSS.contextHeader, {
        [standardCSS.warningErrorHeader]: props.errorOrWarning,
        [standardCSS.contextText]: !props.errorOrWarning,
        [contextHeaderClass]: (props.cssClasses && props.cssClasses.contextHeader),
    });
    // // Content Clasess.
    const contentClass = (props.cssClasses && props.cssClasses.content) ? props.cssClasses.content : null;
    const contentClassName = classNames(standardCSS.content, {
        [contentClass]: (props.cssClasses && props.cssClasses.content),
        [standardCSS.errorContent]: props.errorOrWarning,
        [popoverCSS.noTopPaddingMargin]: props.noTopPaddingMargin,
        [popoverCSS.noLeftRightPadding]: props.noLeftRightPadding,
        [popoverCSS.noBottomPadding]: props.noBottomPadding,
    });
    // // Paper Classes.
    const cssClassesPaper = (props.cssClasses && props.cssClasses.paper) ? props.cssClasses.paper : null;
    const roundedClassName = props.errorOrWarning ?
        standardCSS.errorRounded :
        (props.roundedCorners ? standardCSS.paperRounded : standardCSS.paper);
    const paperClassName = classNames(roundedClassName, {
        [cssClassesPaper]: (props.cssClasses && props.cssClasses.paper),
    });
    // // Calculate the width and height of the Dialog.
    const theme = useTheme$1();
    let width = null;
    if (typeof props.width === 'number' && props.width > 0) {
        width = props.width + WIDTH_PADDING;
    }
    let height = (props.height && props.height > 0) ? props.height + HEIGTH_PADDING : null;
    // If the current screen size is too small for the Dialog, force fullscreen mode.
    let fullScreen = useMediaQuery(theme.breakpoints.down('xs'));
    if (width) {
        fullScreen = useMediaQuery(`(max-width:${width}px)`);
    }
    let titleClass = standardCSS.title;
    if (fullScreen) {
        width = null;
        height = null;
        titleClass = standardCSS.titleFull;
    }
    // const titleClassNames = classNames(
    //     titleClass,
    //     {
    //         [props.cssClasses.header]: props.cssClasses.header !== undefined,
    //     },
    // );
    const headerClasses = (props.cssClasses && props.cssClasses.header) ?
        props.cssClasses.header :
        classNames(titleClass, {
            [standardCSS.warningErrorDialogHeader]: props.errorOrWarning,
            [standardCSS.headerTextFull]: fullScreen,
            [standardCSS.headerText]: !fullScreen,
            [standardCSS.upperCase]: !props.disableUpperCase,
        });
    return (React__default.createElement(muiDialog__default, { classes: { paper: paperClassName }, PaperProps: { style: { width: width, height: height } }, maxWidth: (width) ? false : 'sm', open: props.isOpen, onClose: props.onClose, disableBackdropClick: props.persistent, onBackdropClick: props.onBackDropClick, hideBackdrop: props.hideBackdrop, disableRestoreFocus: true, fullScreen: fullScreen },
        React__default.createElement(DialogTitle, { classes: { root: headerClasses }, disableTypography: true },
            React__default.createElement("div", { className: props.errorOrWarning ?
                    standardCSS.warningErrorDialogHeader :
                    standardCSS.header },
                props.headerIcon,
                React__default.createElement("h4", null, props.errorOrWarning ?
                    props.header.toString().toUpperCase() :
                    props.header),
                React__default.createElement(JSXIf, { Condition: !props.errorOrWarning },
                    React__default.createElement(IconButton, { square: true, onClick: props.onClose, height: 44, width: 44 },
                        React__default.createElement(Icon, null, IconClose))))),
        React__default.createElement(JSXIf, { Condition: props.contextHeader !== undefined },
            React__default.createElement(DialogContentText, { classes: { root: contentTextClassName } }, `${props.contextHeader}`)),
        React__default.createElement(DialogContent, { className: contentClassName }, props.children),
        React__default.createElement(JSXIf, { Condition: props.addActions },
            React__default.createElement(DialogActions
            // classes={{ root: standardCSS.actions }}
            , { 
                // classes={{ root: standardCSS.actions }}
                disableSpacing: true },
                React__default.createElement(ButtonGroup, null,
                    props.customButtons &&
                        props.customButtons.map((button) => (React__default.createElement(Button, { key: button.value, onClick: (event) => props.onCustomClicked(event, button.value), disabled: button.disabled, 
                            // color={button.color}
                            // className={button.className}
                            // textColor={button.textColor}
                            // designation={button.designation}
                            variant: button.variant }, button.label))),
                    React__default.createElement(JSXIf, { Condition: !props.hideCancel },
                        React__default.createElement(Button, { onClick: props.onClose, disabled: props.disableCancel, variant: 'secondary' }, props.cancelLabel)),
                    React__default.createElement(JSXIf, { Condition: !props.hideSave },
                        React__default.createElement(Button, { type: 'text', onClick: props.onSave, disabled: props.disableSave, variant: 'primary' }, props.saveLabel)))))));
});
const PopoverDialog = React__default.memo((props) => {
    // ActionRef is used to recalc the position of the PopOver when then size is changed.
    const actionRef = React__default.useRef(null);
    React__default.useEffect(() => {
        if (actionRef.current) {
            actionRef.current.updatePosition();
        }
    }, [props.children]);
    // Set the actionRef for the component.
    const updateActon = React__default.useCallback((action) => actionRef.current = action, []);
    // Setup defaults.
    const anchorReference = props.anchorReference ? props.anchorReference : 'anchorEl';
    const anchorEl = props.anchorElement ? props.anchorElement : null;
    const anchorPosition = props.anchorPosition ? props.anchorPosition : undefined;
    const anchorOrigin = props.anchorOrigin ?
        {
            vertical: props.anchorOrigin.vertical ? props.anchorOrigin.vertical : 'bottom',
            horizontal: props.anchorOrigin.horizontal ? props.anchorOrigin.horizontal : 'center',
        } :
        {
            vertical: 'bottom',
            horizontal: 'center',
        };
    const tranformOrigin = props.transformOrigin ?
        {
            vertical: props.transformOrigin.vertical ? props.transformOrigin.vertical : 'top',
            horizontal: props.transformOrigin.horizontal ? props.transformOrigin.horizontal : 'left',
        } :
        {
            vertical: 'top',
            horizontal: 'left',
        };
    let roundedCorners = [];
    if (typeof props.roundedCorners === 'boolean') {
        if (!!props.roundedCorners) {
            roundedCorners = ['TopRight', 'TopLeft', 'BottomLeft', 'BottomRight'];
        }
    }
    else {
        roundedCorners = props.roundedCorners;
    }
    const rounded = (roundedCorners).map((r) => popoverCSS['rounded' + r]);
    // Paper Classes.
    const cssClassesPaper = (props.cssClasses && props.cssClasses.paper) ? props.cssClasses.paper : null;
    const paperClassName = classNames(popoverCSS.paper, rounded, {
        [cssClassesPaper]: (props.cssClasses && props.cssClasses.paper),
    });
    const contentClass = (props.cssClasses && props.cssClasses.content) ? props.cssClasses.content : null;
    // Content Classes.
    const contentClassName = classNames(popoverCSS.content, {
        [contentClass]: (props.cssClasses && props.cssClasses.content),
        [popoverCSS.contentPadding]: !props.useMargin,
        [popoverCSS.contentMargin]: props.useMargin,
        [popoverCSS.noTopPaddingMargin]: props.noTopPaddingMargin,
    });
    // Content Text Classes.
    const innerContentClassName = classNames('flex', props.noFillContent ? undefined : 'fill-content', props.cssClasses && props.cssClasses.innerContent ? props.cssClasses.innerContent : undefined);
    // Calc the width and height.
    let width = null;
    if (props.width) {
        if (props.width === 'full') {
            width = '100%';
        }
        else if (typeof props.width === 'number' && props.width > 0) {
            width = props.width + WIDTH_PADDING;
        }
    }
    const height = (props.height && props.height > 0) ?
        props.height + HEIGTH_PADDING :
        null;
    const headerClasses = [popoverCSS.headerText, !!props.disableUpperCase ? '' : popoverCSS.upperCase];
    return (React__default.createElement(muiPopover__default, { action: updateActon, classes: { paper: paperClassName }, PaperProps: { style: { width: width, height: height } }, open: props.isOpen, anchorReference: anchorReference, anchorEl: anchorEl, anchorPosition: anchorPosition, onClose: props.onCancel, disableBackdropClick: props.persistent, BackdropProps: { invisible: props.hideBackdrop ? true : false }, anchorOrigin: anchorOrigin, transformOrigin: tranformOrigin, elevation: 24, onBackdropClick: props.onBackDropClick, disableRestoreFocus: true },
        React__default.createElement("div", { className: popoverCSS.title },
            React__default.createElement("div", { className: popoverCSS.header },
                props.headerIcon,
                React__default.createElement("h4", { className: headerClasses.join(' ') }, props.header),
                React__default.createElement(JSXIf, { Condition: !props.hideClose },
                    React__default.createElement(IconButton
                    // color='contrast'
                    , { 
                        // color='contrast'
                        square: true, 
                        // backgroundColor='error'
                        // gradient
                        onClick: props.onCancel, tooltip: 'Close' },
                        React__default.createElement(Icon, null, IconClose))))),
        React__default.createElement("div", { className: contentClassName, style: {
                overflowY: props.hideScrollbars ? 'hidden' : 'auto',
                overflowX: props.hideScrollbars ? 'hidden' : 'auto',
            } },
            React__default.createElement("div", { className: innerContentClassName }, props.children)),
        React__default.createElement(JSXIf, { Condition: props.addActions },
            React__default.createElement(ButtonGroup, null,
                React__default.createElement("div", { className: popoverCSS.iconGroup }, props.iconButtons &&
                    props.iconButtons.map((icons) => (React__default.createElement(Icon, { key: icons.value, 
                        // color='action'
                        size: 'rg', tooltip: icons.tooltip, onClick: (event) => props.onIconClicked(event, icons.value) }, icons.icon)))),
                props.customButtons &&
                    props.customButtons.map((button) => (React__default.createElement(Button, { key: button.value, onClick: (event) => props.onCustomClicked(event, button.value), disabled: button.disabled, 
                        // color={button.color}
                        // className={button.className}
                        // textColor={button.textColor}
                        // designation={button.designation}
                        variant: button.variant }, button.label))),
                React__default.createElement(JSXIf, { Condition: !props.hideCancel },
                    React__default.createElement(Button, { onClick: props.onCancel, disabled: props.disableCancel, variant: 'secondary' }, props.cancelLabel)),
                React__default.createElement(JSXIf, { Condition: !props.hideSave },
                    React__default.createElement(Button, { type: 'text', onClick: props.onSave, disabled: props.disableSave, variant: 'primary' }, props.saveLabel))))));
});

var css_248z$i = ".Badge-module_badgeWrapper__1fWSR {\n  justify-content: center;\n}\n\n.Badge-module_badge__3fKsk {\n  transform: scale(1);\n  min-width: 1rem;\n  font-weight: 900;\n  border-radius: 50%;\n  padding: 0;\n}\n.Badge-module_badge__3fKsk.Badge-module_noText__2bien {\n  min-width: 0px;\n  transform: none;\n}\n.Badge-module_badge__3fKsk.Badge-module_noText__2bien.Badge-module_sizeMd__3pJ4L {\n  height: 10px;\n  width: 10px;\n  font-size: 0;\n}\n\n.Badge-module_sizeMd__3pJ4L {\n  width: 1rem;\n  height: 1rem;\n  font-size: 8px;\n}\n.Badge-module_sizeMd__3pJ4L.Badge-module_badgeOverflow__2Q2IN {\n  font-size: 6px;\n}\n\n.Badge-module_sizeLg__24Z4_ {\n  width: 1.5rem;\n  height: 1.5rem;\n  font-size: 0.78rem;\n}\n\n.Badge-module_sizeXl__1TLML {\n  width: 1.79rem;\n  height: 1.79rem;\n  font-size: 1rem;\n}\n\n.Badge-module_sizeXxl__3_Su0 {\n  width: 1.79rem;\n  height: 1.79rem;\n  font-size: 16px;\n}\n\n.Badge-module_topBadge__17ZrQ {\n  top: -20%;\n  left: 35%;\n  right: auto;\n  bottom: auto;\n}\n\n.Badge-module_topLeftBadge__24i78 {\n  top: -12.5%;\n  left: 6.85%;\n  right: auto;\n  bottom: auto;\n}\n\n.Badge-module_topRightBadge__3nwIM {\n  top: -20%;\n  left: auto;\n  right: 10%;\n  bottom: auto;\n}\n\n.Badge-module_leftBadge__z213Y {\n  top: 35%;\n  left: 10%;\n  right: auto;\n  bottom: auto;\n}\n\n.Badge-module_rightBadge__5EBhM {\n  top: 35%;\n  left: auto;\n  right: 10%;\n  bottom: auto;\n}\n\n.Badge-module_bottomLeftBadge__3MoU8 {\n  top: auto;\n  left: 10%;\n  right: auto;\n  bottom: -20%;\n}\n\n.Badge-module_bottomRightBadge__Us2ji {\n  top: auto;\n  left: auto;\n  right: 10%;\n  bottom: -20%;\n}\n\n.Badge-module_bottomBadge__kYAl1 {\n  top: auto;\n  left: 35%;\n  right: auto;\n  bottom: -20%;\n}\n\n.Badge-module_colorDefault__26VvU {\n  background-image: var(--errorBackgroundVertical);\n  color: var(--constrastColor);\n}\n\n.Badge-module_colorPrimary__2LY3R {\n  background: var(--primaryColor);\n  color: var(--contrastColor);\n}\n\n.Badge-module_colorAction__bRf6X {\n  background: var(--actionColor);\n  color: var(--darkTextColor);\n}\n\n.Badge-module_colorSecondary__3N7_B {\n  background: var(--secondaryColor);\n  color: var(--constrastColor);\n}\n\n.Badge-module_colorContrast__1NWuY {\n  background: var(--contrastColor);\n  color: var(--errorColor);\n}\n\n.Badge-module_colorError__3H0Ye {\n  background: linear-gradient(#CB3A28, #8F251D);\n}\n\n.Badge-module_colorBlack__CTP6N {\n  color: white;\n  background-color: black;\n}\n\n@media screen and (max-width: 1281px) {\n  .Badge-module_incrementArrow__8-xv9 {\n    padding-top: 1px !important;\n  }\n}\n\n.Badge-module_incrementArrow__8-xv9:hover {\n  background-color: #000;\n  opacity: 0.5;\n}\n\n.Badge-module_decrementArrow__17sVr:hover {\n  background-color: #000;\n  opacity: 0.5;\n}\n\n.Badge-module_incrementDecrementBadge__27Uk0 {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.Badge-module_hideArrow__3KcZq {\n  visibility: hidden;\n}";
var css$g = {"badgeWrapper":"Badge-module_badgeWrapper__1fWSR","badge":"Badge-module_badge__3fKsk","noText":"Badge-module_noText__2bien","sizeMd":"Badge-module_sizeMd__3pJ4L","badgeOverflow":"Badge-module_badgeOverflow__2Q2IN","sizeLg":"Badge-module_sizeLg__24Z4_","sizeXl":"Badge-module_sizeXl__1TLML","sizeXxl":"Badge-module_sizeXxl__3_Su0","topBadge":"Badge-module_topBadge__17ZrQ","topLeftBadge":"Badge-module_topLeftBadge__24i78","topRightBadge":"Badge-module_topRightBadge__3nwIM","leftBadge":"Badge-module_leftBadge__z213Y","rightBadge":"Badge-module_rightBadge__5EBhM","bottomLeftBadge":"Badge-module_bottomLeftBadge__3MoU8","bottomRightBadge":"Badge-module_bottomRightBadge__Us2ji","bottomBadge":"Badge-module_bottomBadge__kYAl1","colorDefault":"Badge-module_colorDefault__26VvU","colorPrimary":"Badge-module_colorPrimary__2LY3R","colorAction":"Badge-module_colorAction__bRf6X","colorSecondary":"Badge-module_colorSecondary__3N7_B","colorContrast":"Badge-module_colorContrast__1NWuY","colorError":"Badge-module_colorError__3H0Ye","colorBlack":"Badge-module_colorBlack__CTP6N","incrementArrow":"Badge-module_incrementArrow__8-xv9","decrementArrow":"Badge-module_decrementArrow__17sVr","incrementDecrementBadge":"Badge-module_incrementDecrementBadge__27Uk0","hideArrow":"Badge-module_hideArrow__3KcZq"};
styleInject(css_248z$i,{"insertAt":"top"});

/** Creates a badge(s) for the specified child element. */
const Badge = memo((props) => {
    let badge = props.children;
    // Top Badge
    if (props.topBadge) {
        badge = createElement(BuildBadge, Object.assign({ position: 'top' }, props.topBadge), badge);
    }
    // Top Left Badge
    if (props.topLeftBadge) {
        badge = createElement(BuildBadge, Object.assign({ position: 'topLeft' }, props.topLeftBadge), badge);
    }
    // Top Right Badge
    if (props.topRightBadge) {
        badge = createElement(BuildBadge, Object.assign({ position: 'topRight' }, props.topRightBadge), badge);
    }
    // Left Badge
    if (props.leftBadge) {
        badge = createElement(BuildBadge, Object.assign({ position: 'left' }, props.leftBadge), badge);
    }
    // Right Badge
    if (props.rightBadge) {
        badge = createElement(BuildBadge, Object.assign({ position: 'right' }, props.rightBadge), badge);
    }
    // Bottom Left Badge
    if (props.bottomLeftBadge) {
        badge = createElement(BuildBadge, Object.assign({ position: 'bottomLeft' }, props.bottomLeftBadge), badge);
    }
    // Bottom Right Badge
    if (props.bottomRightBadge) {
        badge = createElement(BuildBadge, Object.assign({ position: 'bottomRight' }, props.bottomRightBadge), badge);
    }
    // Bottom Badge
    if (props.bottomBadge) {
        badge = createElement(BuildBadge, Object.assign({ position: 'bottom' }, props.bottomBadge), badge);
    }
    return badge;
});
const BuildBadge = (props) => {
    let badgeContent = props.content;
    const badgeSize = props.size ? props.size : 'md';
    const onClick = props.onClick ? props.onClick : null;
    const className = onClick !== null ? 'clickable' : null;
    const badgeClassName = classNames(css$g.badge, css$g[`${props.position}Badge`], css$g[`size${badgeSize.charAt(0).toUpperCase() + badgeSize.slice(1)}`], {
        [props.className]: props.className,
    }, props.noText ? css$g.noText : null, +badgeContent > 99 ? css$g.badgeOverflow : null);
    if (props.tooltip) {
        badgeContent = (createElement(Tooltip, { text: props.tooltip }, badgeContent));
    }
    if (props.showIncrement || props.showDecrement) {
        badgeContent = (createElement("div", { className: css$g.incrementDecrementBadge },
            createElement(IconButton, { onClick: props.onIncrement, className: props.showIncrement ? css$g.incrementArrow : css$g.hideArrow, width: '12px', height: '12px', tooltip: props.incrementTooltip },
                createElement(Icon, { size: 'ss' }, IconBadgeUp)),
            createElement("div", { className: css$g.badgeContent }, badgeContent),
            createElement(IconButton, { onClick: props.onDecrement, className: props.showDecrement ? css$g.decrementArrow : css$g.hideArrow, width: '12px', height: '12px', tooltip: props.decrementTooltip },
                createElement(Icon, { size: 'ss' }, IconBadgeDown))));
    }
    const badge = (createElement(muiBadge__default, { classes: {
            root: css$g.badgeWrapper,
            badge: badgeClassName,
            colorPrimary: css$g[GetColor(props.color)],
        }, className: className, badgeContent: badgeContent, color: 'primary', onClick: onClick }, props.children));
    return badge;
};
/** Returns the specified color style. */
function GetColor(color) {
    const tempColor = color ? color : 'default';
    return `color${tempColor.charAt(0).toUpperCase() + tempColor.slice(1)}`;
}

var css_248z$j = ".Avatar-module_colorDefault__1uGnn {\n  background-color: var(--defaultColor);\n}\n\n.Avatar-module_colorContrast__-TcWE {\n  background-color: var(--contrastColor);\n}\n\n.Avatar-module_colorBlank__3uVhU {\n  background-color: var(--lightTextColor);\n}\n\n.Avatar-module_colorPrimary__1pN7y {\n  background-color: var(--primaryColor);\n}\n\n.Avatar-module_colorSecondary__3MaiS {\n  background-color: var(--errorColor);\n}\n\n.Avatar-module_colorLabel__2hoj9 {\n  background-color: var(--labelColor);\n}\n\n.Avatar-module_colorCompleted__2Bd8f {\n  background-color: var(--completeColor);\n}\n\n.Avatar-module_borderColorDefault__36vAz {\n  border-color: var(--defaultColor);\n}\n\n.Avatar-module_borderColorPrimary__20Kz8 {\n  border-color: var(--primaryColor);\n}\n\n.Avatar-module_borderColorSecondary__3jcaD {\n  border-color: var(--secondaryColor);\n}\n\n.Avatar-module_borderColorContrast__68AlT {\n  border-color: var(--contrastColor);\n}\n\n.Avatar-module_borderColorLabel__2a6e2 {\n  border-color: var(--labelColor);\n}\n\n.Avatar-module_borderColorError__1FtgP {\n  border-color: var(--errorColor);\n}\n\n.Avatar-module_borderColorWarning___eeIe {\n  border-color: var(--warningColor);\n}\n\n.Avatar-module_topLeftBadge__3xebA {\n  top: 1%;\n  left: -1%;\n}\n\n.Avatar-module_topRightBadge__2xzQf {\n  top: 1%;\n  right: -1%;\n}\n\n.Avatar-module_badgelessWrapper__17fKS {\n  justify-content: center;\n  display: inline-flex;\n  position: relative;\n  flex-shrink: 0;\n  vertical-align: middle;\n}\n\n.Avatar-module_clickable__2k7cb {\n  cursor: pointer;\n}\n\n.Avatar-module_paper__2l89w {\n  display: inline-block !important;\n}";
var css$h = {"colorDefault":"Avatar-module_colorDefault__1uGnn","colorContrast":"Avatar-module_colorContrast__-TcWE","colorBlank":"Avatar-module_colorBlank__3uVhU","colorPrimary":"Avatar-module_colorPrimary__1pN7y","colorSecondary":"Avatar-module_colorSecondary__3MaiS","colorLabel":"Avatar-module_colorLabel__2hoj9","colorCompleted":"Avatar-module_colorCompleted__2Bd8f","borderColorDefault":"Avatar-module_borderColorDefault__36vAz","borderColorPrimary":"Avatar-module_borderColorPrimary__20Kz8","borderColorSecondary":"Avatar-module_borderColorSecondary__3jcaD","borderColorContrast":"Avatar-module_borderColorContrast__68AlT","borderColorLabel":"Avatar-module_borderColorLabel__2a6e2","borderColorError":"Avatar-module_borderColorError__1FtgP","borderColorWarning":"Avatar-module_borderColorWarning___eeIe","topLeftBadge":"Avatar-module_topLeftBadge__3xebA","topRightBadge":"Avatar-module_topRightBadge__2xzQf","badgelessWrapper":"Avatar-module_badgelessWrapper__17fKS","clickable":"Avatar-module_clickable__2k7cb","paper":"Avatar-module_paper__2l89w"};
styleInject(css_248z$j,{"insertAt":"top"});

/** This controls allows us to build an elevated Avator with an optional badge. */
const Avatar = (props) => {
    var _a, _b;
    // Setup defaults
    const size = (props.size && props.size > 34) ? props.size : 34;
    const color = (props.color !== undefined) ? props.color : 'default';
    const borderThickness = (props.borderThickness !== undefined) ? props.borderThickness : 5;
    const avatarClassName = classNames(css$h[`color${color.charAt(0).toUpperCase() + color.slice(1)}`], {
        [css$h.clickable]: props.IsClickable,
        [css$h.borderColorDefault]: props.borderColor === 'default' || props.borderColor === undefined,
        [css$h.borderColorPrimary]: props.borderColor === 'primary',
        [css$h.borderColorSecondary]: props.borderColor === 'secondary',
        [css$h.borderColorContrast]: props.borderColor === 'contrast',
        [css$h.borderColorLabel]: props.borderColor === 'label',
        [css$h.borderColorError]: props.borderColor === 'error',
        [css$h.borderColorWarning]: props.borderColor === 'warning',
    });
    let children = props.children;
    let iconColor = props.iconColor;
    if (iconColor === undefined || iconColor === null) {
        iconColor = 'secondary';
    }
    if (((_b = (_a = props.src) === null || _a === void 0 ? void 0 : _a.trim()) !== null && _b !== void 0 ? _b : '') === '' && !children) {
        if (props.defaultIcon === 'none') {
            children = (createElement(Fragment, null));
        }
        else {
            children = (createElement(Icon, null, (!!props.defaultIcon) ? props.defaultIcon : IconDefaultUserImage));
        }
    }
    let control = (createElement(muiAvatar__default, { className: avatarClassName, alt: props.alt, src: props.src, onClick: props.onClick, style: {
            width: `${size}px`,
            height: `${size}px`,
            border: `${borderThickness}px solid`,
        } }, children));
    // Tooltip
    if (props.toolTip) {
        control = (createElement(Tooltip, { text: props.toolTip }, control));
    }
    // Paper
    if (props.elevation && props.elevation > 0) {
        control = (createElement(Paper, { elevation: props.elevation ? props.elevation : 4, shape: 'circle', size: size + (borderThickness * 2), className: css$h.paper }, control));
    }
    if (props.topLeftBadge) {
        const badge = Object.assign(Object.assign({}, props.topLeftBadge), { className: props.topLeftBadge.className || css$h.topLeftBadge });
        control = (createElement(Badge, { topLeftBadge: badge }, control));
    }
    else if (props.topRightBadge) {
        const badge = Object.assign(Object.assign({}, props.topRightBadge), { className: props.topRightBadge.className || css$h.topRightBadge });
        control = (createElement(Badge, { topRightBadge: badge }, control));
    }
    else {
        control = (createElement("div", { className: css$h.badgelessWrapper }, control));
    }
    return control;
};

var css_248z$k = ".RadioButton-module_radioBtn__2nav8 {\n  padding: 2px;\n}\n\n.RadioButton-module_vertical__3XH-X {\n  padding-left: 12px;\n}\n\n.RadioButton-module_disabled__2enlN {\n  color: var(--disabledColor);\n}\n\n.RadioButton-module_defaultColor__1W4m3 {\n  color: var(--actionColor);\n}\n\n.RadioButton-module_defaultChecked__3QLvH {\n  color: var(--primaryColor);\n}\n\n.RadioButton-module_primaryColor__34fzc {\n  color: var(--primaryColor);\n}\n\n.RadioButton-module_primaryChecked__1CJul {\n  color: var(--secondaryColor);\n}\n\n.RadioButton-module_secondaryColor__2L28W {\n  color: var(--secondaryColor);\n}\n\n.RadioButton-module_secondaryChecked__1q32P {\n  color: var(--primaryColor);\n}";
var css$i = {"radioBtn":"RadioButton-module_radioBtn__2nav8","vertical":"RadioButton-module_vertical__3XH-X","disabled":"RadioButton-module_disabled__2enlN","defaultColor":"RadioButton-module_defaultColor__1W4m3","defaultChecked":"RadioButton-module_defaultChecked__3QLvH","primaryColor":"RadioButton-module_primaryColor__34fzc","primaryChecked":"RadioButton-module_primaryChecked__1CJul","secondaryColor":"RadioButton-module_secondaryColor__2L28W","secondaryChecked":"RadioButton-module_secondaryChecked__1q32P"};
styleInject(css_248z$k,{"insertAt":"top"});

/** This is the styled implementation of a RadioButton. */
const RadioButton = ((props) => {
    const labelPlacement = props.labelOnLeft ? 'start' : 'end';
    // const tempColor = (props.color !== undefined) ? props.color : 'default';
    // const color = `color${tempColor.charAt(0).toUpperCase() + tempColor.slice(1)}`;
    const rootClass = classNames(css$i.radioBtn, {
        [css$i.defaultColor]: (props.color === 'default' || props.color === undefined) && !props.checked,
        [css$i.defaultChecked]: (props.color === 'default' || props.color === undefined) && props.checked,
        [css$i.primaryColor]: props.color === 'primary' && !props.checked,
        [css$i.primaryChecked]: props.color === 'primary' && props.checked,
        [css$i.secondaryColor]: props.color === 'secondary' && !props.checked,
        [css$i.secondaryChecked]: props.color === 'secondary' && props.checked,
        [css$i.disabled]: props.disabled,
    });
    return (React__default.createElement(FormControlLabel, { label: props.label, value: props.value, checked: props.checked, onChange: props.onChange, disabled: props.disabled, labelPlacement: labelPlacement, control: React__default.createElement(Radio, { name: props.name, classes: {
                root: rootClass,
            }, color: 'default' }) }));
});

/** Builds a Checkbox. */
class RadioButtonGroup extends Component {
    constructor() {
        super(...arguments);
        // Triggered when a field's value is changed.
        this.onChange = (event) => {
            if (this.props.onChange) {
                this.props.onChange(this.props.id, event.target.value);
            }
        };
    }
    render() {
        // We will pass all props to the InnerControl except the functions.
        const _a = this.props, other = __rest(_a, ["onChange"]);
        return (createElement(InnerControl$1, Object.assign({ onChange: this.onChange }, other)));
    }
}
/** Custom styles for the Checkbox control. */
const styles$2 = createStyles({
    horizontalOrientation: {
        flexDirection: 'row',
    },
});
/** This is the styled implementation of a Checkbox. */
const InnerControl$1 = withStyles(styles$2)((props) => {
    const orientation = props.orientation ? props.orientation : 'vertical';
    // Build custom properties.
    const className = classNames({
        [props.classes.horizontalOrientation]: (orientation === 'horizontal'),
    });
    return (createElement(FormControl, { component: 'div' },
        createElement(JSXIf, { Condition: props.label !== undefined },
            createElement(FormLabel, { component: 'label' }, props.label)),
        createElement(RadioGroup, { classes: {
                root: className,
            }, name: props.id, value: props.value, onChange: props.onChange }, props.children)));
});

var css_248z$l = ".ViewPane-module_viewPane__2esbp {\n  position: relative;\n}\n\n.ViewPane-module_content__2a16J {\n  padding: 3px;\n}";
var css$j = {"viewPane":"ViewPane-module_viewPane__2esbp","content":"ViewPane-module_content__2a16J"};
styleInject(css_248z$l,{"insertAt":"top"});

let paneRef = null;
const ViewPane = (props) => {
    const Renderer = props.renderer;
    const className = classNames(css$j.viewPane, {
        [props.className]: !!props.className,
    });
    useEffect(() => {
        if (props.getPaneRef) {
            props.getPaneRef(paneRef);
        }
    }, [props.getPaneRef]);
    return (React__default.createElement("div", { ref: (el) => paneRef = el, className: className },
        React__default.createElement(TransitionGroup, null, props.views &&
            props.views.map((view, index, original) => {
                const isTop = ((index + 1) === original.length);
                return (React__default.createElement(FadeAndSlideTransition, { key: view.viewId, timeout: { enter: 300, exit: 100 }, isTop: isTop, zIndex: index + 1 },
                    React__default.createElement("div", { className: css$j.content },
                        React__default.createElement(Renderer, Object.assign({ id: view.viewId }, view)))));
            }))));
};

var css_248z$m = ".Flexbox-module_verticalFlex__1fv9J {\n  height: 100%;\n}\n\n.Flexbox-module_noMargin__1FkGN {\n  margin: 0px;\n}\n\n.Flexbox-module_hide__2p3qg {\n  display: none;\n}\n\n.Flexbox-module_horizontalFlex__U-oJA {\n  display: flex;\n}\n\n.Flexbox-module_overflowItems__166ho {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  width: inherit;\n  white-space: nowrap;\n}";
var css$k = {"verticalFlex":"Flexbox-module_verticalFlex__1fv9J","noMargin":"Flexbox-module_noMargin__1FkGN","hide":"Flexbox-module_hide__2p3qg","horizontalFlex":"Flexbox-module_horizontalFlex__U-oJA","overflowItems":"Flexbox-module_overflowItems__166ho"};
styleInject(css_248z$m,{"insertAt":"top"});

/** Wraps the component in a flexible component that will auto-adjust
 * to the screen size based on the given configurations.
 */
const Flexbox = (props) => {
    const container = props.container;
    const item = !props.container;
    const classname = classNames({
        [css$k.verticalFlex]: (props.verticalFlex && container),
        [css$k.noMargin]: (props.noMargin && container),
        [css$k.hide]: props.hide,
        [css$k.horizontalFlex]: props.horizontalFlex,
        [css$k.overflowItems]: props.overflowItems,
    });
    // These settings only apply to a container.
    let direction = undefined;
    let alignContent = undefined;
    let alignItems = undefined;
    let justify = undefined;
    let spacing = undefined;
    let wrap = undefined;
    if (container) {
        direction = (props.direction !== undefined) ? props.direction : 'row';
        alignContent = (props.alignContent !== undefined) ? props.alignContent : 'stretch';
        alignItems = (props.alignItems !== undefined) ? props.alignItems : 'stretch';
        justify = (props.justify !== undefined) ? props.justify : 'flex-start';
        spacing = (props.spacing !== undefined) ? props.spacing : 4;
        wrap = props.wrap;
    }
    // These settings only apply to an item.
    let xs = undefined;
    let sm = undefined;
    let md = undefined;
    let lg = undefined;
    let xl = undefined;
    if (item) {
        xs = (props.xs !== undefined) ? props.xs : undefined;
        sm = (props.sm !== undefined) ? props.sm : undefined;
        md = (props.md !== undefined) ? props.md : undefined;
        lg = (props.lg !== undefined) ? props.lg : undefined;
        xl = (props.xl !== undefined) ? props.xl : undefined;
    }
    return (createElement(Grid, { className: classname, container: container, item: item, direction: direction, alignContent: alignContent, alignItems: alignItems, justify: justify, spacing: spacing, xs: xs, sm: sm, md: md, lg: lg, xl: xl, wrap: wrap }, props.children));
};

const LazyLoadSpinner = (props) => (createElement(Suspense, { fallback: createElement(CircularProgress, Object.assign({}, props)) }, props.children));

var css_248z$n = ".Divider-module_divider__3muA9 {\n  height: 100%;\n  width: 1px;\n  background-color: var(--dividerColor);\n}\n\n.Divider-module_hrDivider__20P4B {\n  background-color: var(--dividerColor);\n}\n\n.Divider-module_primary__2PjpD {\n  background-color: var(--priamryColor);\n}\n\n.Divider-module_secondary__1mfyV {\n  background-color: var(--secondaryColor);\n}\n\n.Divider-module_contrast__38MKU {\n  background-color: var(--contrastColor);\n}\n\n.Divider-module_defaultColor__EvFyw {\n  background-color: var(--dividerColor);\n}";
var css$l = {"divider":"Divider-module_divider__3muA9","hrDivider":"Divider-module_hrDivider__20P4B","primary":"Divider-module_primary__2PjpD","secondary":"Divider-module_secondary__1mfyV","contrast":"Divider-module_contrast__38MKU","defaultColor":"Divider-module_defaultColor__EvFyw"};
styleInject(css_248z$n,{"insertAt":"top"});

/** Displays a verticle or horizontal divider. */
const Divider = ((props) => {
    const horizontal = props.horizontal ? props.horizontal : false;
    let control = null;
    if (horizontal) {
        // For now the color can only be set with props on horizontal lines.
        const dividerClasses = classNames(props.className ? props.className : css$l.hrDivider, {
            [css$l.primary]: props.color === 'primary',
            [css$l.secondary]: props.color === 'secondary',
            [css$l.contrast]: props.color === 'contrast',
            [css$l.defaultColor]: props.color === 'default' || !props.color,
        });
        control = createElement(muiDivider__default, { className: dividerClasses });
    }
    else {
        control = (createElement("div", { className: props.className ? props.className : css$l.divider }));
    }
    return control;
});

var css_248z$o = ".CollapseSection-module_collapseSection__2Bm-7 {\n  padding: 10px;\n}\n\n.CollapseSection-module_collapseHeaderDiv__1fDM7 {\n  position: relative;\n  height: 44px;\n  margin-bottom: 14px;\n  border-bottom: var(--dividerColor);\n}\n\n.CollapseSection-module_collapseHeaderLabel__1DHH8 {\n  font-size: 16px;\n  padding-top: 10px;\n  padding-bottom: -10px;\n  padding-left: 10px;\n  padding-right: 10px;\n  color: var(--textColor);\n}\n\n.CollapseSection-module_defaultIconDiv__32kyF {\n  position: absolute;\n  top: -8px;\n  right: 0;\n}";
var css$m = {"collapseSection":"CollapseSection-module_collapseSection__2Bm-7","collapseHeaderDiv":"CollapseSection-module_collapseHeaderDiv__1fDM7","collapseHeaderLabel":"CollapseSection-module_collapseHeaderLabel__1DHH8","defaultIconDiv":"CollapseSection-module_defaultIconDiv__32kyF"};
styleInject(css_248z$o,{"insertAt":"top"});

/** A collapseable section which handles the collapse state and provides a UI. */
class CollapseSection extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            isCollapsed: !this.props.startCollapsed,
        };
        this.toggleCollapse = () => {
            this.setState((prevState) => ({
                isCollapsed: !prevState.isCollapsed,
            }));
        };
    }
    render() {
        var _a;
        const isCollapsed = (_a = this.props.overrideCollapse) !== null && _a !== void 0 ? _a : this.state.isCollapsed;
        const icon = isCollapsed ? IconDropDown : IconDropDownReverse;
        const sectionCount = this.props.sectionCount || 2;
        return (createElement("div", { className: this.props.className ? this.props.className : css$m.collapseSection },
            createElement("div", { className: classNames(this.props.headerClass, css$m.collapseHeaderDiv) },
                createElement("div", { className: css$m.collapseHeaderLabel }, this.props.header),
                createElement("div", { className: css$m.defaultIconDiv },
                    createElement(IconButton, { onClick: this.toggleCollapse, className: this.props.iconClass ? this.props.iconClass : null, tooltip: isCollapsed ? 'Expand' : 'Collapse' },
                        createElement(Icon, null, icon)))),
            createElement(Collapse, { collapse: isCollapsed }, this.props.children),
            createElement(Divider, { className: this.props.dividerClass, horizontal: true }),
            createElement(JSXIf, { Condition: sectionCount > 1 },
                createElement(Divider, { className: this.props.dividerClass, horizontal: true }))));
    }
}

var css_248z$p = ".Tabs-module_tabs__166WJ {\n  background-color: inherit;\n}\n\n.Tabs-module_tab__mlLnV {\n  height: 35px;\n  width: 44px;\n  border-bottom: 1px solid transparent;\n  opacity: 1;\n  padding: 0;\n  color: var(--labelColor);\n  background-color: var(--contrastColor);\n}\n@media screen and (max-width: 1366px) {\n  .Tabs-module_tab__mlLnV {\n    height: 30px;\n    width: 35px;\n  }\n}\n\n.Tabs-module_tabWrapper__1gGx2 {\n  align-items: normal;\n}\n\n.Tabs-module_tabBorder__2uoeb:after {\n  content: \"\";\n  position: absolute;\n  box-sizing: border-box;\n  width: 100%;\n  height: 20px;\n  border-left: 1px solid var(--labelColor);\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.Tabs-module_selectedTab__15MWU {\n  background-color: var(--contrastColor);\n  color: var(--primaryColor);\n}\n.Tabs-module_selectedTab__15MWU:before {\n  content: \"\";\n  position: absolute;\n  width: 30px;\n  height: 100%;\n  border-bottom: 1px solid var(--primaryColor);\n  left: calc(50% - 15px);\n  bottom: 0px;\n}\n\n.Tabs-module_compact__2GgCJ {\n  padding-top: \"0px\";\n  padding-bottom: \"0px\";\n  font-size: \".5rem\";\n  white-space: \"normal\";\n  min-height: \"30px\";\n}\n.Tabs-module_compact__2GgCJ.Tabs-module_xs__2icZF {\n  min-width: \"35px\";\n}\n.Tabs-module_compact__2GgCJ.Tabs-module_lg__3dwVw {\n  min-width: \"42px\";\n}\n.Tabs-module_compact__2GgCJ.Tabs-module_sm__167al {\n  min-width: \"32px\";\n}\n\n.Tabs-module_wrapper__3N8Ip {\n  display: \"block\";\n}\n\n.Tabs-module_textColorInherit__dFXye {\n  color: var(--contrastColor);\n  background-color: \"inherit\";\n}\n.Tabs-module_textColorInherit__dFXye.Tabs-module_selected__cB9Ih {\n  color: var(--defaultColor);\n  background-color: var(--contrastColor);\n}\n.Tabs-module_textColorInherit__dFXye.Tabs-module_disabled__2rXHb {\n  opacity: 0.4;\n}\n\n.Tabs-module_textColorPrimary__2AnEK {\n  color: var(--contrastColor);\n  background-color: \"inherit\";\n}\n.Tabs-module_textColorPrimary__2AnEK.Tabs-module_selected__cB9Ih {\n  color: var(--primaryColor);\n  background-color: var(--contrastColor);\n}\n.Tabs-module_textColorPrimary__2AnEK.Tabs-module_disabled__2rXHb {\n  color: var(--disabledColor);\n}\n\n.Tabs-module_textColorSecondary__of6rT {\n  color: var(--contrastColor);\n  background-color: \"inherit\";\n}\n.Tabs-module_textColorSecondary__of6rT.Tabs-module_selected__cB9Ih {\n  color: var(--secondaryColor);\n  background-color: var(--contrastColor);\n}\n.Tabs-module_textColorSecondary__of6rT.Tabs-module_disabled__2rXHb {\n  color: var(--disabledColor);\n}\n\n@media (max-width: 1366px) {\n  .Tabs-module_selectedTab__15MWU:before {\n    left: calc(50% - 13px);\n    width: 26px;\n  }\n}\n.Tabs-module_altTab__1LtxA {\n  height: 35px;\n  width: 44px;\n  border-bottom: 1px solid transparent;\n  opacity: 1;\n  padding: 0;\n}\n@media screen and (max-width: 1366px) {\n  .Tabs-module_altTab__1LtxA {\n    height: 30px;\n    width: 35px;\n  }\n}\n\n.Tabs-module_altSelectedTab__1wZ3p {\n  background-color: var(--contrastColor);\n}\n.Tabs-module_altSelectedTab__1wZ3p:after {\n  content: \"\";\n  position: absolute;\n  box-sizing: border-box;\n  width: 30px;\n  height: 100%;\n  border-bottom: 1px solid var(--primaryColor);\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n.Tabs-module_tabsCompact__3W6ap {\n  min-height: 32px;\n}\n@media screen and (max-width: 1366px) {\n  .Tabs-module_tabsCompact__3W6ap {\n    min-height: 30px;\n  }\n}";
var css$n = {"tabs":"Tabs-module_tabs__166WJ","tab":"Tabs-module_tab__mlLnV","tabWrapper":"Tabs-module_tabWrapper__1gGx2","tabBorder":"Tabs-module_tabBorder__2uoeb","selectedTab":"Tabs-module_selectedTab__15MWU","compact":"Tabs-module_compact__2GgCJ","xs":"Tabs-module_xs__2icZF","lg":"Tabs-module_lg__3dwVw","sm":"Tabs-module_sm__167al","wrapper":"Tabs-module_wrapper__3N8Ip","textColorInherit":"Tabs-module_textColorInherit__dFXye","selected":"Tabs-module_selected__cB9Ih","disabled":"Tabs-module_disabled__2rXHb","textColorPrimary":"Tabs-module_textColorPrimary__2AnEK","textColorSecondary":"Tabs-module_textColorSecondary__of6rT","altTab":"Tabs-module_altTab__1LtxA","altSelectedTab":"Tabs-module_altSelectedTab__1wZ3p","tabsCompact":"Tabs-module_tabsCompact__3W6ap"};
styleInject(css_248z$p,{"insertAt":"top"});

/** This controls builds a Tab with more options. */
const Tabs = ((props) => {
    // Get custom colors.
    const tempColor = (props.color !== undefined) ? props.color : 'inherit';
    // Set up overrides.
    const className = classNames(props.className, {
        [css$n.textColorInherit]: tempColor === 'inherit',
        [css$n.textColorPrimary]: tempColor === 'primary',
        [css$n.textColorSecondary]: tempColor === 'secondary',
        [css$n.compact]: props.compact,
        [css$n.selected]: props.selected,
        [css$n.disabled]: props.disabled,
    });
    // Base Icon.
    let icon = null;
    if (props.icon) {
        icon = createElement(Icon, null, props.icon);
    }
    if (props.badge) {
        icon = (createElement(Badge, { topLeftBadge: { content: '', noText: true } }, icon));
    }
    let control = (createElement(muiTab__default, { key: props.value, classes: { wrapper: css$n.tabWrapper }, className: className, icon: icon, label: props.label, selected: props.selected, onChange: (event) => props.onChange(event, props.value), disabled: props.disabled }));
    if (props.tooltip) {
        control = (createElement(Tooltip, { text: props.tooltip }, control));
    }
    return control;
});

/** This controls builds a Tab with more options. */
const Tabs$1 = (props) => {
    // Define the classNames.
    const tabsClassName = classNames(css$n.tabs, {
        [css$n.tabsCompact]: props.compact,
    });
    const tabIndicatorClassName = props.indicatorClass ? props.indicatorClass : 'hidden';
    // Base Icon.
    const control = (createElement(muiTabs__default, { classes: {
            root: tabsClassName,
            indicator: tabIndicatorClassName,
        }, value: props.value, centered: props.centered, onChange: props.onChange }, props.tabs.map((tab, index) => {
        const selected = props.value === tab.value;
        // Add default styling if a custom tab class is not provided.
        const tabClass = classNames({
            [tab.className]: tab.className,
            [css$n.tab]: (!tab.className && !props.alternate),
            [css$n.altTab]: (!tab.className && props.alternate),
        });
        // Apply a default border if a custom class is not provided and it is not the first element.
        const borderClass = classNames({
            [css$n.tabBorder]: (!tab.className && index !== 0 && !props.alternate),
        });
        // Add default styling for the selected tab if a class is not provided.
        const selectedTabClass = classNames({
            [props.selectedTabClass]: props.selectedTabClass,
            [css$n.selectedTab]: (!props.selectedTabClass && !props.alternate),
            [css$n.altSelectedTab]: (!props.selectedTabClass && props.alternate),
        });
        return (createElement(Tabs, { key: tab.value, value: tab.value, icon: tab.icon, label: tab.label, color: props.color, compact: props.compact, tooltip: tab.tooltip, selected: selected, onChange: props.onChange, badge: tab.badge, className: classNames(tabClass, borderClass, { [selectedTabClass]: selected }) }));
    })));
    return control;
};

var css_248z$q = ".ReyPopover-module_popoverContent__3EXhe {\n  padding: 2px;\n  outline: none;\n  position: absolute;\n  min-width: 16px;\n  max-width: calc(100% -32px);\n  overflow-y: auto;\n  overflow-x: hidden;\n  min-height: 16px;\n  max-height: calc(100% -32px);\n  background: var(--contrastColor);\n  border: 1px solid var(--bodyColor);\n}\n\n/*Nav Menu Popover specific stylings*/\n.ReyPopover-module_navMenuPopover__1RNwx {\n  padding: 0px;\n  border-radius: 20px 0;\n  width: 390px;\n  box-shadow: 1px 1px 1px 0 rgba(0, 0, 0, 0.4);\n}";
var css$o = {"popoverContent":"ReyPopover-module_popoverContent__3EXhe","navMenuPopover":"ReyPopover-module_navMenuPopover__1RNwx"};
styleInject(css_248z$q,{"insertAt":"top"});

const ReyPopover = (props) => {
    var _a;
    const onClose = useCallback(() => {
        if (props.onClose) {
            props.onClose();
        }
    }, [props.onClose]);
    return (React__default.createElement(Popover, { id: 'info-popper', open: props.isOpen, anchorEl: props.anchorElement, anchorReference: props.anchorPosition ? 'anchorPosition' : null, onClose: onClose, anchorOrigin: {
            vertical: props.popupOriginVertical ? props.popupOriginVertical : 'bottom',
            horizontal: props.popupOriginHorizontal ? props.popupOriginHorizontal : 'center',
        }, anchorPosition: props.anchorPosition, PaperProps: {
            className: classNames(css$o.popovercontent, props.className, {
                [css$o.navMenuPopover]: props.navMenuPopover,
            }),
        }, transformOrigin: {
            vertical: props.transformOriginVertical ? props.transformOriginVertical : 'top',
            horizontal: props.transformOriginHorizontal ? props.transformOriginHorizontal : 'center',
        }, marginThreshold: (_a = props.marginThreshold) !== null && _a !== void 0 ? _a : 16, keepMounted: props.keepMounted, disableRestoreFocus: true }, props.children));
};

const ReyPopper = (props) => (React__default.createElement(Popper, { className: props.className, placement: props.placement, anchorEl: props.anchorEl, transition: props.transition, open: props.isOpen }, props.children));

var css_248z$r = ".ComboBoxList-module_comboBoxList__2_LO7 {\n  display: inline-flex;\n  margin: 0;\n}\n\n.ComboBoxList-module_groupHeader__QUwab {\n  font-size: 0.875rem;\n  font-family: inherited;\n  padding: 0 4px 0 4px;\n  line-height: 24px;\n  color: rgba(0, 0, 0, 0.54);\n}\n\n.ComboBoxList-module_menuList__dZupo {\n  box-shadow: 2px 2px 4px 0 rgba(0, 0, 0, 0.4);\n  border: 1px solid var(--borderColor);\n}";
var css$p = {"comboBoxList":"ComboBoxList-module_comboBoxList__2_LO7","groupHeader":"ComboBoxList-module_groupHeader__QUwab","menuList":"ComboBoxList-module_menuList__dZupo"};
styleInject(css_248z$r,{"insertAt":"top"});

var ButtonDesignation;
(function (ButtonDesignation) {
    /** A Primary Button is one that carries out the main function of a panel or advances the user forward in the process.
     * There can only be one button with a primary designation per panel section. Multiple primary buttons should never
     * occupy the same row.
     */
    ButtonDesignation[ButtonDesignation["primary"] = 0] = "primary";
    /** A Secondary Button is one that modifies content on the current panel without proceeding. There is no limit to the
     * number of secondary buttons that may exist within a panel or row.
     */
    ButtonDesignation[ButtonDesignation["secondary"] = 1] = "secondary";
})(ButtonDesignation || (ButtonDesignation = {}));
var DateRange;
(function (DateRange) {
    DateRange[DateRange["Today"] = 0] = "Today";
    DateRange[DateRange["Week"] = 1] = "Week";
    DateRange[DateRange["Month"] = 2] = "Month";
    DateRange[DateRange["Last2Days"] = 3] = "Last2Days";
    DateRange[DateRange["Last3Days"] = 4] = "Last3Days";
    DateRange[DateRange["Last7Days"] = 5] = "Last7Days";
    DateRange[DateRange["Last30Days"] = 6] = "Last30Days";
    DateRange[DateRange["Custom"] = 7] = "Custom";
    DateRange[DateRange["SelectedDay"] = 8] = "SelectedDay";
    DateRange[DateRange["SelectedDayPlusPreviousDay"] = 9] = "SelectedDayPlusPreviousDay";
    DateRange[DateRange["SelectedDayPlusPrevious2Days"] = 10] = "SelectedDayPlusPrevious2Days";
    DateRange[DateRange["SelectedDayPlusPrevious3Days"] = 11] = "SelectedDayPlusPrevious3Days";
    DateRange[DateRange["SelectedDayPlusPrevious4Days"] = 12] = "SelectedDayPlusPrevious4Days";
    DateRange[DateRange["SelectedDayPlusPrevious5Days"] = 13] = "SelectedDayPlusPrevious5Days";
    DateRange[DateRange["SelectedDayPlusPrevious6Days"] = 14] = "SelectedDayPlusPrevious6Days";
    DateRange[DateRange["SelectedDayPlusPrevious7Days"] = 15] = "SelectedDayPlusPrevious7Days";
    DateRange[DateRange["SelectedDayPlusPrevious8Days"] = 16] = "SelectedDayPlusPrevious8Days";
    DateRange[DateRange["SelectedDayPlusPrevious9Days"] = 17] = "SelectedDayPlusPrevious9Days";
    DateRange[DateRange["SelectedDayPlusPrevious10Days"] = 18] = "SelectedDayPlusPrevious10Days";
    DateRange[DateRange["SelectedDayPlusPrevious11Days"] = 19] = "SelectedDayPlusPrevious11Days";
    DateRange[DateRange["SelectedDayPlusPrevious12Days"] = 20] = "SelectedDayPlusPrevious12Days";
    DateRange[DateRange["SelectedDayPlusPrevious13Days"] = 21] = "SelectedDayPlusPrevious13Days";
    DateRange[DateRange["SelectedDayPlus1Day"] = 22] = "SelectedDayPlus1Day";
    DateRange[DateRange["SelectedDayPlus2Days"] = 23] = "SelectedDayPlus2Days";
    DateRange[DateRange["LastWeek"] = 24] = "LastWeek";
    DateRange[DateRange["LastMonth"] = 25] = "LastMonth";
    DateRange[DateRange["Last2Weeks"] = 26] = "Last2Weeks";
    DateRange[DateRange["Last60Days"] = 27] = "Last60Days";
    DateRange[DateRange["Last45Days"] = 28] = "Last45Days";
    DateRange[DateRange["Yesterday"] = 29] = "Yesterday";
})(DateRange || (DateRange = {}));

const Control = (props) => {
    const value = props.selectProps.value ? props.selectProps.value.label : null;
    /** Handles the onChange event for the Control. */
    const handleChange = (newValue, props) => {
        let value = null;
        if (newValue !== null) {
            value = { label: newValue, value: newValue, manual: true };
        }
        props.setValue(value);
        if (!!value && newValue === '') {
            props.selectProps.setFullList(true);
        }
        else {
            props.selectProps.setFullList(false);
        }
        props.selectProps.onMenuOpen();
    };
    /** Handles the onBlur event for the Control. */
    const handleBlur = (newValue, props) => {
        props.selectProps.onMenuClose();
        props.selectProps.onBlur(newValue);
    };
    /** Handles the onFocus event for the Control. */
    const handleFocus = (newValue, props) => {
        props.selectProps.onFocus(newValue);
    };
    /** Handles the onClick event for the Control. */
    const handleClick = (_, props) => {
        props.selectProps.setFocus();
        props.selectProps.setFullList(true);
        props.selectProps.onMenuOpen();
    };
    /** Set the inner field ref for this control. */
    const getFieldRef = (fieldRef, props) => {
        props.selectProps.getFieldRef(fieldRef);
    };
    return (React__default.createElement(TextField, Object.assign({ id: props.selectProps.id, getFieldRef: (fieldRef) => getFieldRef(fieldRef, props), label: props.selectProps.label, onChange: (_, x, __, ___) => handleChange(x, props), onBlur: (_, x, __, ___) => handleBlur(x, props), onFocus: (_, x, __, ___) => handleFocus(x, props), value: value, error: props.selectProps.error, required: props.selectProps.required, size: props.selectProps.size, disabled: props.selectProps.disabled, readOnly: props.selectProps.readOnly, helperText: props.selectProps.helperText, raisedLabel: props.selectProps.raisedLabel, textOverflow: props.selectProps.textOverflow, marginBottom: props.selectProps.marginBottom, type: props.selectProps.type, decimalSignOptional: props.selectProps.decimalSignOptional, endAdornment: !!props.selectProps.readOnly ? null : (React__default.createElement(IconButton, { onClick: (event) => handleClick(event, props), width: 18, height: 18, disabled: props.selectProps.disabled },
            React__default.createElement(Icon, { size: 'xs' }, IconDropDown))) }, props.innerProps)));
};

const ComboBoxList = (props) => {
    let tempValue = {
        label: props.value ? props.value.toString() : '',
        value: props.value,
    };
    if (props.dropDownList && props.dropDownList.length > 0) {
        let existingValue = props.dropDownList.find((x) => isEqual(x.value, props.value));
        if (existingValue) {
            tempValue = existingValue;
        }
        else {
            // Attempt to match on the label.
            existingValue = props.dropDownList.find((x) => isEqual(NormalizeValue(x.label), NormalizeValue(props.value)));
            if (existingValue) {
                tempValue = existingValue;
            }
        }
    }
    const [error, setError] = useState(false);
    const [value, setValue] = useState(tempValue);
    const [displayRequiredText, setDisplayRequiredText] = useState(false);
    const [showFullList, setShowFullList] = useState(false);
    const [fieldRef, setFieldRef] = useState(null);
    const [ignoreNextChange, setIgnoreNextChange] = useState(false);
    // private fieldRef: HTMLElement;
    // private selectRef: Creatable<{label: string, value: string}>;
    /** Triggered when a field's value is changed. */
    const onChange = useCallback((optionValue) => {
        if (optionValue && !ignoreNextChange) {
            let returnValue = Object.assign({}, optionValue);
            let tempValue = returnValue.value;
            const isInvalid = false;
            // If this was a manual entry, attempt to match it with our list.
            if (optionValue.manual) {
                const existingOption = props.dropDownList.find((x) => isEqual(NormalizeValue(x.label), NormalizeValue(optionValue.value)));
                if (existingOption) {
                    returnValue = { label: existingOption.label, value: existingOption.value };
                    tempValue = returnValue.value;
                }
            }
            if (props.required && tempValue !== null && tempValue !== '' && +tempValue !== -1 && displayRequiredText) {
                setDisplayRequiredText(false);
            }
            if (!isEqual(returnValue, tempValue)) {
                setValue(returnValue);
                setError(isInvalid);
                if (props.onChange) {
                    props.onChange(props.id, tempValue, optionValue.manual);
                }
            }
        }
        else {
            setIgnoreNextChange(false);
        }
    }, [props.onChange, props.id, props.required, displayRequiredText, ignoreNextChange, props.dropDownList]);
    // private onInputChange = (value: string) => {
    //     if (this.selectRef) {
    //         this.selectRef.select.getNextFocusedOption = () => null;
    //     }
    // }
    /** Triggered when a field loses focus. */
    const onBlur = useCallback((value) => {
        if (props.onBlur) {
            props.onBlur(props.id, value);
        }
        if (props.required) {
            if ((value === null || value === '' || +value === -1) && !displayRequiredText) {
                setDisplayRequiredText(true);
            }
            else if (value !== null && value !== '' && +value !== -1 && displayRequiredText) {
                setDisplayRequiredText(true);
            }
        }
        setIgnoreNextChange(false);
    }, [displayRequiredText, props.onBlur, props.id, props.required]);
    /** Triggered when a field gains focus. */
    const onFocus = useCallback((value) => {
        if (props.onFocus) {
            props.onFocus(props.id, value);
        }
    }, [props.onFocus, props.id]);
    /** Forces focus into the control. */
    const setFocus = useCallback(() => {
        if (fieldRef) {
            fieldRef.focus();
        }
    }, [fieldRef]);
    /** Get the inner ref of the control. */
    const getFieldRef = useCallback((tempFieldRef) => {
        setFieldRef(tempFieldRef);
    }, []);
    /** Sets the list status. */
    const setFullList = useCallback((showFullList) => {
        setShowFullList(showFullList);
    }, []);
    const onKeyDown = useCallback((event) => {
        if (!props.noFilter) {
            return;
        }
        if (event.key === 'Tab' || event.key === 'Enter') {
            setIgnoreNextChange(true);
        }
    }, [props.noFilter]);
    /** Filter the options of the drop down list. */
    const filterOption = useCallback((option) => {
        if (showFullList || props.noFilter) {
            return true;
        }
        let inputValue = value ? value.value : '';
        inputValue = (isNumber(inputValue) && inputValue === -1) ? '' : inputValue;
        if (!isEmpty(inputValue)) {
            return startsWith(NormalizeValue(option.label), NormalizeValue(inputValue).toString());
        }
        return false;
    }, [props.noFilter, value, showFullList]);
    const options = useMemo(() => GroupList(props.dropDownList), [props.dropDownList]);
    const other = __rest(props, []);
    const moreProps = Object.assign({}, other);
    moreProps.error = props.error || error || displayRequiredText;
    const inputValue = (value && value.value !== '-1') ? value.value : '';
    return (React__default.createElement("div", { className: css$p.comboBoxList },
        React__default.createElement(Creatable
        // ref={(el) => this.selectRef = el}
        , Object.assign({ 
            // ref={(el) => this.selectRef = el}
            components: { Control, Menu, Option, GroupHeading }, onChange: onChange, 
            // onInputChange={this.onInputChange}
            onBlur: onBlur, onFocus: onFocus, setFocus: setFocus, getFieldRef: getFieldRef, fieldRef: fieldRef, setFullList: setFullList, filterOption: filterOption, onKeyDown: onKeyDown, options: options, value: value, inputValue: inputValue, backspaceRemovesValue: true, tabSelectsValue: !props.noSelectOnEnter, isClearable: false }, moreProps, { noOptionsMessage: () => 'No Options' }))));
};
/** Custom Menu for Createable. */
const Menu = (props) => (React__default.createElement(Popper$1, { open: props.selectProps.menuIsOpen, anchorEl: props.selectProps.fieldRef, placement: 'bottom-start', transition: true, style: { zIndex: 1301 } /* Find alternative for hard-coded zIndex value */ },
    React__default.createElement(muiPaper__default, { style: { maxHeight: '316px' /* , width: `${props.selectProps.fieldRef.clientWidth}px` */ } },
        React__default.createElement(ClickAwayListener, { onClickAway: props.selectProps.onMenuClose },
            React__default.createElement(MenuList, Object.assign({}, props.innerProps), props.children)))));
/** Custom MenuOption for Createable. */
const Option = (props) => {
    const background = props.isFocused ? 'var(--primaryColor)' : props.isSelected ? 'var(--accordionBackground)' : null;
    const color = props.isFocused ? 'var(--paperBackground)' : null;
    return (React__default.createElement(MenuItem, Object.assign({ buttonRef: props.innerRef, selected: props.isSelected, component: 'div', style: { background, color } }, props.innerProps), props.children));
};
/** Custom GroupHeading for Createable. */
const GroupHeading = (props) => (React__default.createElement("div", Object.assign({ className: css$p.groupHeader }, props.innerProps), props.children));
/** Creates the combox list. */
const GroupList = createSelector((list) => list, (list) => {
    const groupList = [];
    // Build the Groups.
    list.forEach((item) => {
        const groupLabel = item.group ? item.group : null;
        const index = groupList.findIndex((group) => isEqual(group.label, groupLabel));
        if (index === -1) {
            groupList.push({ label: groupLabel, options: [item] });
        }
        else {
            groupList[index].options.push(item);
        }
    });
    return groupList;
});
const NormalizeValue = (value) => IsString(value) ? value.toUpperCase() : value;
const IsString = (value) => {
    var _a;
    return ((_a = value) === null || _a === void 0 ? void 0 : _a.toUpperCase) !== undefined;
};

export { Avatar, Badge, Button, ButtonDesignation, ButtonGroup, Checkbox, CircularProgress, Collapse, CollapseSection, ComboBoxList, CurrencyField, DateRange, Dialog, Divider, EmailField, FadeAndSlideTransition, Flexbox, Grow, Icon, IconButton, Label, LazyLoadSpinner, LinearProgress, Link, Literal, LoadingProgress, NumberField, Paper, PasswordField, PhoneField, RadioButton, RadioButtonGroup, ReyPopover, ReyPopper, SSNField, ScrollArea, ScrollBar, SelectList, Tabs$1 as Tabs, TextAreaField, TextField, ThemeProvider, Tooltip, ViewPane, ZipField, useClassNames, useTheme };
